import logo from './logo.svg';
import React from 'react';
import {useEffect, useRef} from 'react';
import '@shopify/polaris/build/esm/styles.css';
import './App.scss';
import './css/ui.scss';
import './css/grid.scss';
import enTranslations from '@shopify/polaris/locales/en.json';
import {
  AppProvider, 
  Autocomplete,
  Avatar,
  Badge,
  Banner,
  Button,
  ButtonGroup,
  Card,
  Checkbox,
  ChoiceList,
  Collapsible,
  ContextualSaveBar,
  DisplayText,
  EmptyState,
  Filters,
  FooterHelp,
  FormLayout,
  Frame,
  Grid,
  Heading,
  Icon,
  IndexTable,
  Layout,
  Link,
  Modal,
  Page,
  Pagination,
  Popover,
  ResourceList,
  ResourceItem,
  Select,
  SkeletonBodyText,
  SkeletonDisplayText,
  SkeletonPage,
  Spinner,
  Tabs,
  TextContainer,
  TextStyle,
  TextField,
  Toast,
  Tooltip,
  Label,
} from '@shopify/polaris';
import {
  AnalyticsMinor,
  BlogMajor,
  ChevronDownMinor,
  ChevronUpMinor,
  CircleInformationMajor,
  ClockMajor,
  CollectionsMajor,
  DeleteMajor,
  HomeMajor,
  PageMajor,
  PlayCircleMajor,
  ProductsMajor,
  QuestionMarkMajor,
  SearchMinor,
  SortMinor,
  TextBlockMajor,
} from '@shopify/polaris-icons';
import createApp from '@shopify/app-bridge';

//log rocket session recording
import LogRocket from 'logrocket';

//charts
import Chart from "react-apexcharts";


//refs?


//global components
import Plans from './components/global/Plans';
import IndexTableCustomHeadings from './components/global/IndexTableCustomHeadings';
import Configurables from './components/global/Configurables';

/* Production URLS 
 -> need to make this an environment variable
*/
const ajaxUrl = 'https://dynasort.immersiveecommerce.com/ajax.php';
const planUrl = 'https://dynasort.immersiveecommerce.com/change-plans.php';
const downloadProductsUrl = 'https://dynasort.immersiveecommerce.com/download.php';
const adminAppSlug = 'dynasort';

/* staging URLs 
const ajaxUrl = 'https://dynastage.immersiveecommerce.com/ajax.php';
const planUrl = 'https://dynastage.immersiveecommerce.com/change-plans.php';
const downloadProductsUrl = 'https://dynastage.immersiveecommerce.com/download.php';
const adminAppSlug = 'dynasort-staging';
*/

var urlParams = new URLSearchParams(window.location.search);
var storeUrl = urlParams.get('shop');
if(storeUrl == 'dynasort.myshopify.com'){
  //storeUrl = 'lightintheatticrecordsandtapes.myshopify.com';
  //storeUrl = 'eclipsejewelers.myshopify.com';
  //storeUrl = 'eclipsejewelers.myshopify.com';
  //storeUrl = 'us-neweracap.myshopify.com';
  //console.log('dev shop 2 '+ storeUrl);
}
if(storeUrl == 'diffy-test.myshopify.com'){
  //storeUrl = 'plugtechh.myshopify.com';
  //storeUrl = 'puma-golf-canada.myshopify.com';
  //storeUrl = 'cobrapuma-main.myshopify.com';
  //storeUrl = 'good-vietnam-shirts.myshopify.com';
  
  //storeUrl = 'tyhbtq.myshopify.com';
  //storeUrl = '8379e7-3.myshopify.com'; //scene print george
  //storeUrl = 'eclipsejewelers.myshopify.com'; //masion
  
  //storeUrl = 'greatgardenplants.myshopify.com';
  //storeUrl = 'puma-golf-us.myshopify.com';
  
  //console.log('dev shop 2 '+ storeUrl);
}
let hasRunInit = false;
const resourceListItemCount = 25;

const config = {
  // The client ID provided for your application in the Partner Dashboard.
   apiKey: "b6c23db7946e49b92510a4010708ab82", //production
  //apiKey: "0d4d2fbe6ad3a40b77f3261f6f9de7fc", //staging
  // The host of the specific shop that's embedding your app. This value is provided by Shopify as a URL query parameter that's appended to your application URL when your app is loaded inside the Shopify admin.
  host: new URLSearchParams(window.location.search).get("host"),
  forceRedirect: true
};
const app = createApp(config);

const revertToSelectOptions = [
  {label:'Best Selling',value:'best-selling'},
  {label:'Product title A-Z',value:'alpha-asc'},
  {label:'Product title Z-A',value:'apha-desc'},
  {label:'Highest price',value:'price-desc'},
  {label:'Lowest Price',value:'price-asc'},
  {label:'Newest',value:'created-desc'},
  {label:'Oldest',value:'created-asc'},
  {label:'Manual',value:'manual'},
];
const attributeOptionTypes = [
  {label:'Quantity',value:'quantity'},
  {label: 'Full Size Run', value: 'full-size-run'},
  {label: 'Sizes In Stock', value: 'sizes-in-stock'},
  {label: 'Variants In Stock', value: 'variants-in-stock'},
  {label:'Product Published Age',value:'days-since-published'},
  {label:'Product Created Age',value:'days-since-created'},
  {label:'Age Of Newest Variant',value:'age-of-newest-variant'},
  {label:'Sales (Last 24 Hours)',value:'sales-last-1-days'},
  {label:'Sales (Last 3 Days)',value:'sales-last-3-days'},
  {label:'Sales (Last 7 Days)',value:'sales-last-7-days'},
  {label:'Sales (Last 30 Days)',value:'sales-last-30-days'},
  {label:'Sales (Last 60 Days)',value:'sales-last-60-days'},
  {label:'Sales (All-time)',value:'sales-all-time'},
  {label:'Revenue (Last 24 Hours)',value:'revenue-last-1-days'},
  {label:'Revenue (Last 3 Days)',value:'revenue-last-3-days'},
  {label:'Revenue (Last 7 Days)',value:'revenue-last-7-days'},
  {label:'Revenue (Last 30 Days)',value:'revenue-last-30-days'},
  {label:'Revenue (Last 60 Days)',value:'revenue-last-60-days'},
  {label:'Revenue (All-time)',value:'revenue-all-time'},
  {label:'Margin',value:'margin'},
  {label:'Sold Out',value:'sold-out'},
  {label:'On Sale',value:'on-sale'},
  {label: 'Coming Soon', value: 'coming-soon'},
  {label: 'Brand Boost', value: 'brand-boost'},
  //{label: 'Yotpo Reviews', value: 'yotpo'}, //hidden for dev/review
]
const initAttributeRow = {
  select:{
    options:attributeOptionTypes,
    value:attributeOptionTypes[0].value,
  },
  value:0,
}
const soldOutOptions = [
  {label:'Move to bottom',value:'move-to-bottom'},
  {label:'Leave in place',value:'leave-in-place'},
];
const tieBreaker = [
  {label:'Highest price',value:'highest-price'},
  {label:'Highest margin',value:'highest-margin'},
  {label:'Best selling',value:'best-selling'},
  {label:'Lowest Cost',value:'lowest-cost'},
  {label:'Most inventory',value:'most-inventory'},
]
const metricsBeingEditedDefaultRevert ={
  id:0,
  title:'',
  attributes:[],
  boost:false,
  is_default:false,
  soldOutValue:soldOutOptions[0],
  tieBreakerValue:tieBreaker[0],
  products:[],
};

const devTabs = [

];

const blankManagedBeingEdited = {
  id:0,
  title:'',
  doSort:"0",
  boolean:'all',
  conditions:[],
  conditions_display:[],
  metaNamespaces:[],
  metaKeys:[],
  metricsId:0,
  doLimit:"0",
  limit:'',
  last_run:'',
}


let settingsRevert = {};
let metricsRevert = {};
let metricsRevertIndex = 0;

const helpTransition = {duration: '500ms', timingFunction: 'ease-in-out'};

let dateRange = (1000*60*60*24*7); //default to 7
let money_format = '${{amount}}'; //default US

const conditions = [
  {value:'product-title',label:'Product Title',boolean:'string',defaults:['','','']},
  //{value:'product-handle',label:'Product Handle',boolean:'string',defaults:['','','']},
  {value:'product-type',label:'Product Type',boolean:'string',defaults:['','','']},
  {value:'product-vendor',label:'Product Vendor',boolean:'string',defaults:['','','']},
  {value:'product-tag',label:'Product Tag',boolean:'tag',defaults:['','','']},
  {value:'price',label:'Price',boolean:'number',defaults:['100','','']},
  {value:'price-varies',label:'Price Varies',boolean:'truthy',defaults:[true,'','']},
  {value:'compare-at-price',label:'Compare-at Price',boolean:'number',defaults:['100','','']},
  {value:'quantity',label:'Inventory Quantity',boolean:'number',defaults:['100','','']},
  {value:'option-names',label:'Product Option Names',boolean:'string',defaults:['','','']},
  {value:'option-values',label:'Product Option Values',boolean:'string',defaults:['','','']},
  {value:'requires-shipping',label:'Requires Shipping',boolean:'truthy',defaults:[true,'','']},
  {value:'sku',label:'SKU',boolean:'string',defaults:['','','']},
  {value:'full-size-run',label:'Full Size Run',boolean:'truthy',defaults:[true,'','']},
  {value:'sizes-in-stock',label:'Sizes In Stock',boolean:'truthy',defaults:[true,'','']},
  {value:'variants-in-stock',label:'Variants In Stock',boolean:'truthy',defaults:[true,'','']},
  {value:'days-since-published',label:'Product Published Age',boolean:'number',defaults:['30','','']},
  {value:'days-since-created',label:'Product Created Age',boolean:'number',defaults:['30','','']},
  {value:'variant-age',label:'Age of Newest Variant',boolean:'number',defaults:['30','','']},
  {value:'sales-last-1',label:'Sales Last 24 Hours',boolean:'number',defaults:['5','','']},
  {value:'sales-last-3',label:'Sales Last 3 Days',boolean:'number',defaults:['5','','']},
  {value:'sales-last-7',label:'Sales Last 7 Days',boolean:'number',defaults:['5','','']},
  {value:'sales-last-30',label:'Sales Last 30 Days',boolean:'number',defaults:['25','','']},
  {value:'sales-last-60',label:'Sales Last 60 Days',boolean:'number',defaults:['50','','']},
  {value:'sales-all-time',label:'Sales (All-time)',boolean:'number',defaults:['100','','']},
  {value:'revenue-last-1',label:'Revenue Last 24 Hours',boolean:'number',defaults:['100','','']},
  {value:'revenue-last-3',label:'Revenue Last 3 Days',boolean:'number',defaults:['100','','']},
  {value:'revenue-last-7',label:'Revenue Last 7 Days',boolean:'number',defaults:['100','','']},
  {value:'revenue-last-30',label:'Revenue Last 30 Days',boolean:'number',defaults:['1000','','']},
  {value:'revenue-last-60',label:'Revenue Last 60 Days',boolean:'number',defaults:['5000','','']},
  {value:'revenue-all-time',label:'Revenue (All-time)',boolean:'number',defaults:['20000','','']},
  {value:'cost',label:'Cost',boolean:'number',defaults:['10','','']},
  {value:'margin',label:'Margin',boolean:'number',defaults:['40','','']},
  {value:'sold-out',label:'Sold Out',boolean:'truthy',defaults:[true,'','']},
  {value:'on-sale',label:'On Sale',boolean:'truthy',defaults:[false,'','']},
  {value:'metafield',label:'Metafield',boolean:'metafield',defaults:['','','','']}, //need extra field??
  {value:'rating',label:'Rating',boolean:'number',defaults:['4','','']},
  {value:'reviews',label:'Reviews Count',boolean:'number',defaults:['5','','']},
  {value:'has-image',label:'Has Image',boolean:'truthy',defaults:[true,'','']},
  {value:'boost',label:'Boost Value',boolean:'number',defaults:['5','','']},
];
const conditionBoolean = {
  string:[
    {value:'equals',label:'Is equal to'},
    {value:'not-equal',label:'Is not equal to'},
    {value:'starts',label:'Starts with'},
    {value:'ends',label:'Ends with'},
    {value:'contains',label:'Contains'},
    {value:'does-not-contain',label:'Does not contain'},
    //{value:'is-not-empty',label:'Is not empty'},
    //{value:'is-empty',label:'Is empty'},
    //{value:'exists',label:'Exists'},
    //{value:'does-not-exist',label:'Does not exist'},
  ],
  tag:[
    {value:'has-tag',label:'Has tag'},
    {value:'does-not-have-tag',label:'Does not have tag'},
    {value:'any-tag-contains',label:'Any tag contains'},
    {value:'all-tags-do-not-contain',label:'All tags do not contain'},
    //{value:'is-not-empty',label:'Is not empty'},
    //{value:'is-empty',label:'Is empty'},
    //{value:'exists',label:'Exists'},
    //{value:'does-not-exist',label:'Does not exist'},
  ],
  number:[
    {value:'equals',label:'Is equal to'},
    {value:'not-equal',label:'Is not equal to'},
    {value:'greater',label:'Is greater than'},
    {value:'lesser',label:'Is lesser than'},
    //{value:'is-not-empty',label:'Is not empty'},
    //{value:'is-empty',label:'Is empty'},
    //{value:'exists',label:'Exists'},
    //{value:'does-not-exist',label:'Does not exist'},
  ],
  truthy:[
    {value:'true',label:'True'},
    {value:'false',label:'False'},    
  ],
  metafield:[
    {value:'equals',label:'Is equal to'},
    {value:'not-equal',label:'Is not equal to'},
    {value:'starts',label:'Starts with'},
    {value:'ends',label:'Ends with'},
    {value:'contains',label:'Contains'},
    {value:'does-not-contain',label:'Does not contain'},
    {value:'is-not-empty',label:'Is not empty'},
    {value:'is-empty',label:'Is empty'},
    {value:'exists',label:'Exists'},
    {value:'does-not-exist',label:'Does not exist'},
    {value:'greater',label:'Is greater than'},
    {value:'lesser',label:'Is lesser than'},
    {value:'true',label:'Is true'},
    {value:'false',label:'Is false'}, 
  ]

}


const defaultConditionObj = [
  conditions[0].value, //first drop down
  conditions[0].boolean, //bool type for conditional render
  conditionBoolean[conditions[0].boolean][0].value, //second drop down
  conditions[0].defaults[0], //main value here
  conditions[0].defaults[1], //secondary value for metafield key/value
];



class App extends React.Component {
  constructor(props) {
    super(props);    

    //refs yay

    this.state = {
      showOnboarding:true,
      showCacheStatus:false,
      onboarding_flow:{
        onboarding_modal_dismissed:true,
        onboarding_steps:{
          complete:true,
          metrics:true,
          collections:true,
          status:true,
        }
      },
      firstCollectionEnabled:false,
      firstCollectionEnabledObject:{
        name:'it', //default placeholder
      },
      showOnboardingModal:false,
      showVideoModal:false,
      videoUrl:'',
      videoModalTitle:'',
      cacheStatus:{
        products_cached:0,
        products_total:0,
        collections_cached:0,
        collections_total:0,
        orders_cached:0,
        orders_total:0,

        //bulk statuses
        
      },
      bulkCacheStatus:{
        showBanner:false,
        complete:true,
        bannerStatus:'',
        bannerDismissable:false,
        timeRequired:'3-4',
        bulkStatuses:{
          collections:{
            class:'queued',
            status:'',
            progress:'',
            badgeLabel:'Waiting',
            count:'?',
          },
          products:{
            class:'queued',
            status:'',
            progress:'',
            badgeLabel:'Waiting',
            count:'?',
          },
          orders:{
            class:'queued',
            status:'',
            progress:'',
            badgeLabel:'Waiting',
            count:'?',
          },
        }
      },
      metaData:{},
      date: new Date(),
      status:'On',
      statusModalOpen:false,
      init:{
        ui_loading:true,
        show_tabs:false,
        show_plans:false,
        plans:[],
        plan_token:'',
        password_enabled:'',
        shop_email:'',
        current_plan:'',
        permissions:{
          collections:0,
          metrics:0,
          managed:0,
          custom_attributes:false,
          partner_attributes:false,
          boost:false,
          exports:false,        
        },
        has_turned_on:1,
        generating_attr_values:false,
      },
      settings:{
        showProcessingSave:false,
        showNotificationsSave:false,
        processingSaveLoading:false,
        notificationsSaveLoading:false,
        processing_interval:{
          value:'',
          options:[],
        },
        days_of_the_week:{
          value:'',
          options:[],
        },
        hours_of_the_day:{
          value:'',
          options:[],
        },
        email_shop_owner:{
          value:"false",
        },
        additional_emails:'',
        additional_emails_valid:true,
        //:'',
        notify_order_changed:{
          value:'',
        },
        notify_collections_sorted:{
          value:'',
        },
      },
      /* save bar */
      saveBar:{
        show:false,
        context:'',
        discardDisabled:false,
        saveLoading:false,
      },
      /* tabs vars */
      activeTab:0,
      tabs:[
        {
          id: 'dashboard',
          content: 'Dashboard',
          panelID: 'dashboard',
        },
        {
          id: 'collections',
          content: 'Sorting',
          panelID: 'collections',
        },
        {
          id: 'managed',
          content: 'Managed',
          panelID: 'managed',
        },
        {
          id: 'metrics',
          content: 'Metrics',
          panelID: 'metrics',
        },
        {
          id: 'attributes',
          content: 'Attributes',
          panelID: 'attributes',
        },
        {
          id: 'products',
          content: 'Products',
          panelID: 'products',
        },
        {
          id: 'settings',
          content: 'Settings',
          panelID: 'settings',
        },
        {
          id: 'plans',
          content: 'Plans',
          panelID: 'plans',
        },
        {
          id: 'help',
          content: 'Help',
          panelID: 'help',
        },
      ],
      activeCollectionsTab: 0,
      collectionsTabs: [
        {
          id: 'all',
          content: 'All',
          accessibilityLabel: 'All collections',
          panelID: 'collections-tabs-1',
        },
        {
          id: 'dynamic',
          content: 'Dynamic',
          accessibilityLabel: 'Dynamic collections',
          panelID: 'collections-tabs-2',
        },
        {
          id: 'traditional',
          content: 'Traditional',
          panelID: 'collections-tabs-3',
        },
      ],
      activeMetricsTab: 0,
      metricsTabs: [
        {
          id: 'all',
          content: 'All',
          accessibilityLabel: 'All metrics',
          panelID: 'metrics-tabs-1',
        },
        {
          id: 'booster',
          content: 'Boosted',
          accessibilityLabel: 'Boosted metrics',
          panelID: 'metrics-tabs-2',
        },
        {
          id: 'active',
          content: 'Active',
          panelID: 'metrics-tabs-3',
        },
      ],
      /* Autocomplete vars 
      collectionsFilterValue:'',
      collectionsOptions:[],
      metricsFilterValue:'',
      metricsOptions:[],
      */
      /* resource list vars */
      collectionsFilters:[
        /*
        {
          key: 'collectionFiltersType',
          label: 'Type',
          filter: (
            <TextField
              label="Type"
              value={''}
              onChange={() => { console.log('handleTaggedWithChange')}}
              autoComplete="off"
              labelHidden
            />
          ),
          shortcut: true,
        },
        */
      ],
      collectionsAllCheckboxSelected:false,
      collectionsSelectedItems:[],
      collectionsResourceItemsPage:0,
      collectionsResourceItemsPages:0,
      collectionsResourceItemsType:'',
      collectionsResourceItemEnabled:0,
      collectionsResourceItems:[],
      collectionBeingEditedModal:false,
      collectionBeingEditedModalBulk:false,      
      collectionBeingEdited:{
        enabled:'0',
        handle:'',
        id:0,
        lastSorted:'',
        metricId:"0",
        name:'',
        productCount:0,
        revertSorting:'',
        resourceIndex:0,
      },
      collectionsBulkEditMetricSetOptions:[],
      collectionsBulkEditMetricSetValue: '',
      collectionsBulkEditRevertOptions:[],
      collectionsBulkEditRevertValue:'',
      collectionsBulkEditShowSave:false,
      collectionsBulkEditShowSave:false,
      collectionsBulkEditSaveLoading:false,
      processingBulkEdit:false,
      collectionFilterQueryValue:'',
      /* metrics vars */
      metricssResourceItemsPage:0,
      metricsResourceItemsPages:0,
      metricsResourceItems:[],
      metricsResourceItemsCount:0,
      metricsDefaultId:0,
      metricsFilterQueryValue:'',
      //metricsBeingEditedId:0,
      metricsBeingEdited:{
        id:0,
        title:'',
        attributes:[],
        boost:false,
        is_default:false,
        soldOutValue:soldOutOptions[0],
        tieBreakerValue:tieBreaker[0],
        products:[],
      },
      metricsBeingEditedDefault:{
        id:0,
        title:'',
        attributes:[],
        boost:false,
        is_default:false,
        soldOutValue:soldOutOptions[0],
        tieBreakerValue:tieBreaker[0],
        products:[],
      },
      deleteMetricsModalOpen:false,
      deleteMetricsCollectionCount:0,
      sidebarCollectionsValue:'',
      metricsSidebarCollections:[],
      /* product vars */
      productAttributes:{
        data:[],
        custom:[],
        partner:[],
      },
      //eof attributes
      /* products vars */
      productMetricsOptions:[],
      productsMetricsSelected:0,
      showProductCount:100,
      showProductIndex:0,
      productsLoading:false,
      productsCollectionsOptions:[],
      productsCollectionsSelected:'',
      filtersProduct: [
        /*
        {
          key: 'editProductRows',
          label: 'Edit Product Rows',
          filter: (
            <ChoiceList
              title="Edit Product Rows"
              titleHidden
              choices={[
                {label: 'Margin', value: 'margin'},
                {label: 'Sales', value: 'sales'},
                {label: 'On Sale', value: 'on-sale'},
                {label: 'Full Size Run', value: 'full-size-run'},
                {label: 'Quantity', value: 'quantity'},
              ]}
              selected={['margin','sales','on-sale','full-size-run','quantity']}
              onChange={() => { console.log('handleEditProductRowsChange')}}
              allowMultiple
            />
          ),
          shortcut: true,
        },
        */
      ],
      productsMetricsId:0,
      products:[],
      productsResorting:false,
      productsResortingCollection:0,
      resortingToastShow:false,
      resortedToastShow:false,
      sortingDisplayText:'',
      isSortingCollections:false,
      sortingCollectionsNext:'',
      sortingCollectionsLast:'',
      /* metrics vars */
      metricsCollectionProductsAttributes:{},
      metricsCollectionProductsBoost:"0",
      metrics:{
        createMetricsDisplay:false,
        demo:{
          attributes:[
            {
              type:'Margin',
              weight:35,
            },
            {
              type:'On Sale',
              weight:20,
            },
            {
              type:'Sales',
              weight:15,
            },

          ],
          products:[]
        },
      },
      metricsPreviewProducts:[],
      /* product vars */
      productsPreviewItems:[],
      productsResourceItems:[],
      /* heartbeat vars */
      heartbeat:{
        banners:{
          global:[],
        }
      },
      errors:{
        additional_emails:false,
      },
      popoverFilters:{
        collections:{
          value:'date-asc',
          show:false
        },
        collectionsActive:{
          value:'all',
          show:false,//run off of the above
        },
        metrics:{
          value:'date-asc',
          show:false,
        },
        managed:{
          value:'name-asc',
          show:false,
        },
      },
      toasts:{
        collectionEnabled:{
          show:false,
          content:'Collection Enabled',
        },
        collectionDisabled:{
          show:false,
          content:'Collection Disabled',
        },
        collectionDetailsChanged:{
          show:false,
          content:'Collection Details Changed',
        },
        collectionsBulkEnabled:{
          show:false,
          content:'Collections Enabled',
        },
        collectionsBulkDisabled:{
          show:false,
          content:'Collections Disabled',
        },
        collectionsBulkChanged:{
          show:false,
          content:'Collections Details Changed',
        },
        metricsSaved:{
          show:false,
          content:'Metrics Saved',
        },
        metricsReverted:{
          show:false,
          content:'Metrics Reverted',
        },
        attributeEnabled:{
          show:false,
          content:'Attribute Activated',
        },
        attributeDisabled:{
          show:false,
          content:'Attribute Deactivated',
        },
        attributeSaved:{
          show:false,
          content:'Attribute Saved',
        },
        boostSaved:{
          show:false,
          content:'Boost Saved',
        },
        settingsSaved:{
          show:false,
          content:'Settings Saved',
        },
        status:{
          show:false,
          content:'Dynasort Status Updated',
        },
        managedSaved:{
          show:false,
          content:'Managed collection saved',
        },
        managedDeleted:{
          show:false,
          content:'Managed collection deleted',
        }
      },
      helpItemsOpen:{
        faqs:[
          false,
          false,
        ],
        attributes:[
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
        ],
        metrics:[
          false,
          false,
          false,
          false,
          false,
          false,
        ],
        collections:[
          false,
          false,
          false,
          false,
          false,
        ],
        products:[
          false,
          false,
          false,
          false,
          false,
        ],
      },
      displayCollectionIssues:false,
      collectionsNeedsAttention:false,
      issueCollectionCurrent:{
        title:'',
        collection_id:false,
      },
      singleIssueLoading:false,
      collectionIssues:{
        loaded:false,
        items:[],
      },
      singleCollectionIssuesProducts:[],
      singleCollectionIssuesProductsTotal:0,
      analytics:{
        positionEffectiveness:{
          loaded:false,
          items:[],
        },
        risingProducts:{
          loaded:false,
          items:[],
        },
        salesVelocity:{
          loaded:false,
          data:{},
        },        
      },
      salesVelocityChart:{
        options: {
          chart: {
            id: "main-chart",
            toolbar: {
              show: false,
            },         
          },
          xaxis: {
            type:'datetime',
            range: dateRange //default 30 days
          },
          yaxis: [
            {
              title: {
                text: "Units"
              },
              labels: {
                formatter: function (value) {

                  return Math.round(value);
                }
              },
            },
            {
              opposite: true,
              title: {
                text: "Volume"
              },
              labels: {
                formatter: function (value) {
                  let amount = value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                  //console.log('amount: '+amount);
                  let amount_no_decimals = value.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                  //console.log('amount_no_decimals: '+amount_no_decimals);
                  let amount_with_comma_separator = value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&.');
                  //console.log('amount_with_comma_separator: '+amount_with_comma_separator);
                  let amount_no_decimals_with_comma_separator = value.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&.');
                  //console.log('amount_no_decimals_with_comma_separator: '+amount_no_decimals_with_comma_separator);
                  let amount_with_apostrophe_separator = value.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&\'');
                  //console.log('amount_with_apostrophe_separator: '+amount_with_apostrophe_separator);
                  let formattedValue = money_format.replace('{{amount}}',amount).replace('{{amount_no_decimals}}',amount_no_decimals).replace('{{amount_with_comma_separator}}',amount_with_comma_separator).replace('{{amount_no_decimals_with_comma_separator}}',amount_no_decimals_with_comma_separator).replace('{{amount_with_apostrophe_separator}}',amount_with_apostrophe_separator);
                  return formattedValue;
                }
              },
            }
          ],
          stroke:{
            curve: 'smooth',
          }
        },
        series: [
          /*
          {
            name: "series-1",
            //data: [30, 40, 45, 50, 49, 60, 70, 91]
            data:[
              { x: "28-Feb-2017 GMT", y: 134 },
              { x: "31-Mar-2017 GMT", y: 143 },
              { x: "30-Apr-2017 GMT", y: 131 },
              { x: "31-May-2017 GMT", y: 143 },
              { x: "30-Jun-2017 GMT", y: null },
              { x: "31-Jul-2017 GMT", y: 152 }
            ]
          }
          */
        ]
      },
      objectData:{},
      daysMax:0,
      graphedObjects:[],
      objectType:'product',
      calendarOpen:false,
      kbModal:{
        open:false,
        title:'',
        type:'',
        slug:'',
      },
      newsItems:[],
      newsModalOpen:false,
      newsItemActive:{},
      /* managed collections vars */
      managedCount:0,
      createManagedCollection:false,
      displayManagedCollection:false,
      managedBeingEdited:{
        id:0,
        title:'',
        doSort:"0",
        boolean:'all',
        conditions:[],
        metaNamespaces:[],
        metaKeys:[],
        metricsId:0,
        doLimit:"0",
        limit:'',
        last_run:'',
      },
      deleteManagedModalOpen:false,
      managedPreviewProducts:[],
      managedCollections:[
        /*
        {
          id:12345,
          title:'Test Collection', 
          conditions:[
            'Price > $100',
            'Tag not dynamagic'
          ],
          products:67,
          metrics:'Dynasort Default',
          enabled:true,
        }
        */
      ],
      managedFilterQueryValue:'',
      
    };

    //bindings 
    this.toggleStatus = this.toggleStatus.bind(this);
    this.statusShowModal = this.statusShowModal.bind(this);
    this.handleNavTabChange = this.handleNavTabChange.bind(this);
    this.handleCollectionsNavChange = this.handleCollectionsNavChange.bind(this);
    this.handleMetricsNavChange = this.handleMetricsNavChange.bind(this);
    this.changeCollectionsFilterValue = this.changeCollectionsFilterValue.bind(this);
    this.changeMetricsFilterValue = this.changeMetricsFilterValue.bind(this);
    this.setCollectionsSelectedItems = this.setCollectionsSelectedItems.bind(this);
    this.getCollectionResourceItems = this.getCollectionResourceItems.bind(this);
    this.collectionResourcePage = this.collectionResourcePage.bind(this);
    this.setCollectionStatus = this.setCollectionStatus.bind(this);
    this.doImmediateCollectionSorting = this.doImmediateCollectionSorting.bind(this);
    this.collectionDetailsModal = this.collectionDetailsModal.bind(this);
    this.displayEditMetrics = this.displayEditMetrics.bind(this);
    this.getMetrics = this.getMetrics.bind(this);
    this.editMetricsObject = this.editMetricsObject.bind(this);
    this.addMetricsAttributeRow = this.addMetricsAttributeRow.bind(this);
    this.removeMetricAttribute = this.removeMetricAttribute.bind(this);
    this.getMetricsPreviewProducts = this.getMetricsPreviewProducts.bind(this);
    this.getPreviewProducts = this.getPreviewProducts.bind(this);
    this.getMetricsProductsPreview = this.getMetricsProductsPreview.bind(this);
    this.getMetricsCollections = this.getMetricsCollections.bind(this);
    this.doDiscardAction = this.doDiscardAction.bind(this);
    this.doSaveAction = this.doSaveAction.bind(this);
    this.doSaveMetrics = this.doSaveMetrics.bind(this);
    this.editMetrics = this.editMetrics.bind(this);
    this.metricsChangeCollection = this.metricsChangeCollection.bind(this);
    this.productsMetricsChanged = this.productsMetricsChanged.bind(this);
    this.getMetricsCollectionProducts = this.getMetricsCollectionProducts.bind(this);
    this.changeProductsCollectionsChanged = this.changeProductsCollectionsChanged.bind(this);
    this.loadMoreProducts = this.loadMoreProducts.bind(this);
    this.changeSettingsSelect = this.changeSettingsSelect.bind(this);
    this.saveProcessingSettings = this.saveProcessingSettings.bind(this);
    this.discardProcessingSettings = this.discardProcessingSettings.bind(this);
    this.changeSettingsCheckbox = this.changeSettingsCheckbox.bind(this);
    this.changeSettingsAdditionalEmails = this.changeSettingsAdditionalEmails.bind(this);
    this.saveNotificationsSettings = this.saveNotificationsSettings.bind(this);
    this.discardNotificationsSettings = this.discardNotificationsSettings.bind(this);   
    this.getAttributes = this.getAttributes.bind(this); 
    this.changeConfigurables = this.changeConfigurables.bind(this);
    this.changeConfigurableTitle = this.changeConfigurableTitle.bind(this);
    this.saveConfigurables = this.saveConfigurables.bind(this);
    this.attributeStatus = this.attributeStatus.bind(this);
    this.collectionsAllCheckboxToggle = this.collectionsAllCheckboxToggle.bind(this);
    this.collectionsToggleCheckAll = this.collectionsToggleCheckAll.bind(this);
    this.isCollectionsAllChecked = this.isCollectionsAllChecked.bind(this);
    this.selectCollectionItem = this.selectCollectionItem.bind(this);
    this.uncheckAllCollectionsResourceItems = this.uncheckAllCollectionsResourceItems.bind(this);
    this.collectionsBulkToggle = this.collectionsBulkToggle.bind(this);
    this.collectionsBulkEdit = this.collectionsBulkEdit.bind(this);
    this.saveCollectionsEditBulk = this.saveCollectionsEditBulk.bind(this);
    this.discardCollectionsEditBulk = this.discardCollectionsEditBulk.bind(this);
    this.changeCollectionsEditBulkMetrics = this.changeCollectionsEditBulkMetrics.bind(this);
    this.changeCollectionsEditBulkRevert = this.changeCollectionsEditBulkRevert.bind(this);
    this.collectionFilterChangeQueryValue = this.collectionFilterChangeQueryValue.bind(this);
    this.togglePopover = this.togglePopover.bind(this);
    this.changePopover = this.changePopover.bind(this);
    this.metricsFilterChangeQueryValue = this.metricsFilterChangeQueryValue.bind(this);
    this.sidebarCollectionsChange = this.sidebarCollectionsChange.bind(this);
    this.getMetricsSidebarCollections = this.getMetricsSidebarCollections.bind(this);
    this.editBoost = this.editBoost.bind(this);
    this.saveBoost = this.saveBoost.bind(this);
    this.viewProductScores = this.viewProductScores.bind(this);
    this.duplicateMetrics = this.duplicateMetrics.bind(this);
    this.checkCacheStatus = this.checkCacheStatus.bind(this);
    this.getAttributeOptionTypes = this.getAttributeOptionTypes.bind(this);
    this.showOnboardingModal = this.showOnboardingModal.bind(this);
    this.doOnboardingModalClick = this.doOnboardingModalClick.bind(this);
    this.updateOnboardingModal = this.updateOnboardingModal.bind(this);
    this.addAttribute = this.addAttribute.bind(this);
    this.deleteAttribute = this.deleteAttribute.bind(this);
    this.viewSorting = this.viewSorting.bind(this);
    this.resortCollection = this.resortCollection.bind(this);
    this.hideResortingToast = this.hideResortingToast.bind(this);
    this.hideResortedToast = this.hideResortedToast.bind(this);
    //this.hideCollectionActivatedToast = this.hideCollectionActivatedToast.bind(this);
    this.checkSortingTimes = this.checkSortingTimes.bind(this);
    this.hideToast = this.hideToast.bind(this);
    this.showToast = this.showToast.bind(this);
    this.watchVideo = this.watchVideo.bind(this);
    this.closeVideoModal = this.closeVideoModal.bind(this);
    this.crispChat = this.crispChat.bind(this);
    this.logRocket = this.logRocket.bind(this);
    this.maybeCheckBulkStatus = this.maybeCheckBulkStatus.bind(this);
    this.dismissBulkBanner = this.dismissBulkBanner.bind(this);
    this.toggleHelpItem = this.toggleHelpItem.bind(this);
    this.displayCollectionIssues = this.displayCollectionIssues.bind(this);
    this.loadCollectionIssues = this.loadCollectionIssues.bind(this);
    this.loadAnalytics = this.loadAnalytics.bind(this);
    this.getTopIssue = this.getTopIssue.bind(this);
    this.getTopCollectionIssues = this.getTopCollectionIssues.bind(this);
    this.getIssueBadges = this.getIssueBadges.bind(this);
    this.toggleIssuesTracking = this.toggleIssuesTracking.bind(this);
    this.getCollectionIssuesDetail = this.getCollectionIssuesDetail.bind(this);
    this.getSalesVelocity = this.getSalesVelocity.bind(this);
    this.openChatWindow  = this.openChatWindow.bind(this);
    this.openCalendar = this.openCalendar.bind(this);
    this.showKBModal = this.showKBModal.bind(this);
    this.viewNews = this.viewNews.bind(this);
    this.showDeleteMetricsModal = this.showDeleteMetricsModal.bind(this);
    this.doDeleteMetricsSet = this.doDeleteMetricsSet.bind(this);
    this.createManagedCollection = this.createManagedCollection.bind(this);
    this.managedFilterChangeQueryValue = this.managedFilterChangeQueryValue.bind(this);
    this.changeManagedFilterValue = this.changeManagedFilterValue.bind(this);
    this.editManagedObject = this.editManagedObject.bind(this);
    this.addManagedCondition = this.addManagedCondition.bind(this);
    this.changeConditionType = this.changeConditionType.bind(this);
    this.changeConditionBoolean = this.changeConditionBoolean.bind(this);
    this.changeConditionValue = this.changeConditionValue.bind(this);
    this.removeManagedCondition = this.removeManagedCondition.bind(this);
    //this.getConditionMetaNamespaces = this.getConditionMetaNamespaces.bind(this);
    //this.getConditionMetaKeys = this.getConditionMetaKeys.bind(this);
    //this.changeConditionMetaValue = this.changeConditionMetaValue.bind(this);
    this.doSaveManaged = this.doSaveManaged.bind(this);
    this.getManagedCollections = this.getManagedCollections.bind(this);
    this.doDeleteManaged = this.doDeleteManaged.bind(this);
  }
  /* Lifecycle methods */
  componentWillMount() {  
    if(!hasRunInit){
      //console.log('componentDidMount'); 
      this.doInit();
      //this.startHeartBeat();
      //this.getChartControls();
      //hasRunInit = true;
    }
    //setTimeout(() => window.dispatchEvent(new Event('resize')), 500);
    //console.log('should fix 4');
    //dev stuff
    if(
      storeUrl == 'dynasort.myshopify.com'
      ||
      storeUrl == 'dakine-prod.myshopify.com'
      ||
      storeUrl == 'uga-pike-golf-tournament.myshopify.com'
    ){
      //console.log('dev domain here');
      this.setState({
        tabs: [
          ...this.state.tabs,
          //...devTabs 
        ]
      })
    }

  }

  /* Generic methods */

  doInit() {
    window.dynaloaded = true;
    //console.log('doInit()');
    const data = {
      action: 'init',
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      this.setState({ init: json });
      //check for no iframe
      if(window.top == window.self) {
        // Top level window
        //console.log('not in frame!');
        window.location.replace('https://'+storeUrl+'/admin/apps/'+adminAppSlug+'/');
      }
      //set status
      let status;
      if(parseInt(json.app_status) > 0) {
        status = 'On';
      } else {
        status = 'Off';
      }
      //show plans tab if needed
      if(json.show_plans){
        //console.log('show plans');
        this.setState({ activeTab: 7 }); 
      }
      if(json.settings){
        //do all settings here
        this.setState({ 
          settings:json.settings,
          status:status,
        },() => {
          for (const property in json.settings) {
            //console.log(`${property}: ${object[property]}`);
            if(json.settings[property].hasOwnProperty('value')){
              settingsRevert[property] = json.settings[property].value;
            }
          }
          //console.log(settingsRevert);
        });
      }
      if(json.bulk_cache_status){
        //console.log('bulk_cache_status');
        //console.log(json.bulk_cache_status);
        this.setState({
          bulkCacheStatus:json.bulk_cache_status
        },() => {
          this.maybeCheckBulkStatus();
        });
      }
      if(json.show_cache_status){
        //console.log('json init show showCacheStatus');
        this.setState({
          showCacheStatus:true,
          cacheStatus:json.show_cache_status
        },() =>{
          this.checkCacheStatus();
        })
      } else {
        //console.log('json init hide showCacheStatus');
        this.setState({showCacheStatus:false});
        //console.log('HIDE CACHED STATUS, run here?');
      }
      //console.log('has meta data?');
      if(json.meta_data){
        //console.log('has meta data');
        this.setState({
          metaData:json.meta_data,
        },() =>{
          //console.log(this.state.metaData);
        })
      } else {
        this.setState({showCacheStatus:false})
      }
      //onboarding
      if(json.onboarding_flow){
        if(!json.onboarding_flow.onboarding_steps.complete) {
          //console.log('show onboarding modal');
          //this.showOnboardingModal(true);
        }
        //this.setState({onboarding_flow:json.onboarding_flow});
      }
      //currency
      //onboarding
      if(json.money_format){
        //this.setState({money_format:json.money_format});
        money_format = json.money_format;
      }

      //crisp chat
      this.crispChat();
      this.logRocket();

    }).then(()=>{
      //console.log(this.state.init)
      this.getCollections();
      this.getMetrics();
      this.getAttributes();
      this.checkSortingTimes();
      this.loadCollectionIssues();
      this.loadAnalytics();
      this.getSalesVelocity();
      this.getNews();
      this.getManagedCollections();
    }).then(() => {
      //this.getProducts(); //get default products on first load
      hasRunInit = true;
    });
  }
  hideToast(toast){
    //console.log('hideToast: '+toast);
    let toastsCopy = this.state.toasts;
    toastsCopy[toast].show = false;
    this.setState({
      toasts:toastsCopy
    });
  }
  showToast(toast){
    //console.log('showToast: '+toast);
    let toastsCopy = this.state.toasts;
    toastsCopy[toast].show = true;
    this.setState({
      toasts:toastsCopy
    });
  }
  checkSortingTimes() {
    //console.log('checkSortingTimes');
    const data = {
      action: 'check_sorting_times',
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      this.setState({
        isSortingCollections:json.is_sorting,
        sortingCollectionsNext:json.next_text,
        sortingCollectionsLast:json.last_text,        
      })
      /*
      this.setState({
        statusModalOpen:false,
        status:newStatus,
      });
      this.updateOnboardingModal();
      */
      const timer = setTimeout(() => {
        this.checkSortingTimes();
      }, 10000); 
    });
   
  }
  dismissBulkBanner() {
    let bulkCacheStatusCopy = this.state.bulkCacheStatus;
    bulkCacheStatusCopy.showBanner = false;
    this.setState({
      bulkCacheStatus:bulkCacheStatusCopy
    },() => {
      const data = {
        action: 'get_bulk_cache_status',
        store_url: storeUrl,
        dismiss:true,
      }  
      fetch('/ajax.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then(response => response.json())
      .then((json) =>{
        //nothing, just posted
      });
    });
  }
  maybeCheckBulkStatus() {
    //console.log('maybeCheckBulkStatus');
    //if no metrics shown, load the intitial:
    //console.log(this.state.metrics);
    if(this.state.metrics.length == 0){
      //console.log('0 metrics, load first');
      this.getMetrics();
    }

    const data = {
      action: 'get_bulk_cache_status',
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      //if collections status changed
      if(
        json.bulkStatuses.collections.status != this.state.bulkCacheStatus.bulkStatuses.collections.status
      ) {
        //console.log('maybeCheckBulkStatus getCollections()');
        this.getCollections();
        //console.log('maybeCheckBulkStatus getMetrics()');
        this.getMetrics();
        this.getManagedCollections();
      }
      //if products status changed
      if(
        json.bulkStatuses.products.status != this.state.bulkCacheStatus.bulkStatuses.products.status
      ) {
        //console.log('maybeCheckBulkStatus getProducts()');
        this.getProducts();
        this.getMetricsCollectionProducts();
      }
      //if orders status changed
      if(
        json.bulkStatuses.orders.status != this.state.bulkCacheStatus.bulkStatuses.orders.status
      ) {
        //console.log('maybeCheckBulkStatus orders here');
        this.getProducts();
        this.getMetricsCollectionProducts();
        this.loadCollectionIssues();
        this.loadAnalytics();
        this.getSalesVelocity();
        this.getNews();
        //show onboarding
        //xoxo here show it, but if not done already
        //this.showOnboardingModal(true);
      }
      this.setState({
        bulkCacheStatus:json,       
      });

     if(json.complete != true) {
      //set attribute calcs to caching status
      let initCopy = this.state.init;
      initCopy.generating_attr_values = true;
      this.setState({init:initCopy},() =>{
        //this.getAttributes();
      });
      const timer = setTimeout(() => {
        this.maybeCheckBulkStatus();
      }, 500); 
     } else {
      
      //hide after 10 seconds
      const timer = setTimeout(() => {
        let bulkCacheStatusCopy = this.state.bulkCacheStatus;
        bulkCacheStatusCopy.showBanner = false;
        this.setState({bulkCacheStatus:bulkCacheStatusCopy});
      }, (10 * 1000));      
      //console.log('BULK STATUS COMPLETE, run here?');
      this.loadCollectionIssues();
      this.loadAnalytics();
      this.getSalesVelocity();
      this.getNews();
      //console.log('reload attributes without banner and blocking here');
      let initCopy = this.state.init;
      initCopy.generating_attr_values = false;
      this.setState({init:initCopy},() =>{
        this.getAttributes();
      });
    }
     //run issues and analytics first time here?
     // NO JUST NOconsole.log('BULK STATUS COMPLETE, run here?');
    });
  }
  checkCacheStatus() {
    return;
    if(this.state.init.cache_v2 == "1") {
    }
    //console.log('checkCacheStatus');
    const data = {
      action: 'get_shop_onboarding_status',
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      //check bulk cache status first
      if(json.bulk_cached_complete == 1) {
        //console.log('bulk_cached_complete == 1');
        //console.log('stop cache check');
        this.setState({
          cacheStatus:json,
          showCacheStatus:false,
        },() => {
          //console.log(this.state.cacheStatus);
          this.getCollections();
          this.getProducts();
        });
      } else if(json){
        this.setState({
          cacheStatus:json,
          showCacheStatus:true,
        })
        const timer = setTimeout(() => {
          this.checkCacheStatus();
        }, 1000);
      } else {
        //console.log('stop cache check');
        this.setState({
          cacheStatus:json,
          showCacheStatus:false,
          
        },() => {
          //console.log(this.state.cacheStatus);
          this.getCollections();
          this.getProducts();
        });
      }
      /*
      this.setState({
        statusModalOpen:false,
        status:newStatus,
      });
      */
    });

  }
  toggleStatus() {
    //console.log('toggleStatus: '+this.state.status);
    let newStatus;
    if(this.state.status == 'On'){
      newStatus = 'Off';
    } else {
      newStatus = 'On';
    }
    const data = {
      action: 'toggle_status',
      status:newStatus,
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      let toastsCopy = this.state.toasts;
      toastsCopy.status.show = true;
      toastsCopy.status.content = "Dynasort is now "+newStatus.toLowerCase();


      //onboarding first enable?
      //console.log('firstCollectionEnabledObject');
      //console.log(this.state.firstCollectionEnabledObject);
      if(
        newStatus == "On"
        &&
        this.state.firstCollectionEnabled
      ){
        //console.log('enable and run first collection');
      }

      this.setState({
        statusModalOpen:false,
        status:newStatus,
        firstCollectionEnabled:false,
        toasts:toastsCopy,
      });
      this.updateOnboardingModal();
    });

  }
  statusShowModal(bool){
    //console.log('statusShowModal: '+bool);
    this.setState({statusModalOpen:bool});
  }
  watchVideo(videoSlug){
    //console.log('watchVideo: '+videoSlug);
    let title = '';
    let url = '';
    switch(videoSlug) {
      case 'quick-start':
        title = 'Dynasort Quickstart';
        url = '_Apmr1BJEW0';
        //_Apmr1BJEW0
        break;
      case 'metrics':
        title = 'Dynasort Metrics Training';
        url = 'qc5cmxhGEd0';
        //qc5cmxhGEd0
        // code block
        break;
      case 'attributes':
        title = 'Dynasort Attributes Training';
        url = 'ggf1EDRh77A';
        //ggf1EDRh77A
        //
        break;
      default:
        return;
    } 
    //first close onboarding if open
    this.setState({
      showOnboardingModal:false
    },() => {
      this.setState({
        showVideoModal:true,
        videoModalTitle:title,
        videoUrl:url,
      });
    })
  }
  closeVideoModal(){
    //console.log('closeVideoModal');
    this.setState({
      showVideoModal:false,
      videoModalTitle:'',
      videoUrl:'',
    });
  }

  logRocket() {
    //log rocket session recording
    //if demo store, stop
    if(storeUrl == 'dynasort.myshopify.com'){
      //console.log('stop logRocket');
      return;
    }
    //console.log('init logRocket');
    LogRocket.init('aa6hhq/dynasort');
  }
  crispChat(){
    //console.log('crispChat');
    // Include the Crisp code here, without the <script></script> tags
    window.$crisp = [];
    //window.CRISP_WEBSITE_ID = "ed5ae8b2-77d3-470b-966e-f3f15344ac41";
    window.CRISP_WEBSITE_ID = "74695c98-ebe5-437d-9f31-e78b8c1bdf7e";
    
    (function() {
      var d = document;
      var s = d.createElement("script");

      s.src = "https://client.crisp.chat/l.js";
      s.async = 1;
      d.getElementsByTagName("head")[0].appendChild(s);
      //$crisp.push(["set", "user:email", "user@gmail.com"]);
      window.$crisp.push(["set", "session:data", [[["app", "dynasort"]]]]);
    })();
    const data = {
      action: 'get_user_data',
      store_url: storeUrl
    } 
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      const timer = setTimeout(() => {
        //crisp user data
        window.$crisp.push(["set", "session:segments", [["app", "dynasort"]]]);
        window.$crisp.push(["set", "user:email", [json.email]]);
        //window.$crisp.push(["set", "user:name", [json.name]]);
        //window.$crisp.push(["set", "user:website", [json.myshopify]]);
        window.$crisp.push(["set", "session:data", [[["shop_name", json.name]]]]);
        window.$crisp.push(["set", "session:data", [[["myshopify", json.myshopify]]]]);
        window.$crisp.push(["set", "session:data", [[["installed", json.created]]]]);
        window.$crisp.push(["set", "session:data", [[["owner", json.owner]]]]);
        window.$crisp.push(["set", "session:data", [[["plan", json.plan]]]]);
        window.$crisp.push(["set", "session:data", [[["shopify_plan", json.shopify_plan]]]]);

        //logrocket user data
        LogRocket.identify(json.myshopify, {
          name: json.owner,
          email: json.email,
        
          // Add your own custom user variables here, ie:
          plan: json.plan,
          shopifyPlan:json.shopify_plan,
          installed:json.created,
        });

      }, 1000); 
    });
  }

  togglePopover(popoverType){
    //console.log('togglePopover: '+popoverType);
    let popoverFiltersCopy = this.state.popoverFilters;
    popoverFiltersCopy[popoverType].show = !this.state.popoverFilters[popoverType].show;
    this.setState({
      popoverFilters:popoverFiltersCopy
    });
  }
  changePopover = (value,popoverType) => {
    //console.log('changePopover: '+value+' '+popoverType);
    let popoverFiltersCopy = this.state.popoverFilters;
    popoverFiltersCopy[popoverType].value = value;
    popoverFiltersCopy[popoverType].show = !this.state.popoverFilters[popoverType].show;
    this.setState({
      popoverFilters:popoverFiltersCopy
    },() => {
      this.getCollections();
      this.getMetrics();
      this.getManagedCollections();
    });
  }

  doSaveAction() {
    //console.log('doSaveAction: '+this.state.saveBar.context);
    switch(this.state.saveBar.context){
      case 'metrics':
        this.doSaveMetrics();
      case 'managed':
        //console.log('doSaveManaged');
        this.doSaveManaged();
    }
  }
  doDiscardAction() {
    //console.log('doDiscardAction: '+this.state.saveBar.context);
    if(this.state.saveBar.context == 'metrics'){
      //console.log('metrics edited');
      //console.log(this.state.metricsBeingEdited);
      //console.log('metricsRevert');
      //console.log(metricsRevertIndex);
      //console.log(metricsRevert);
      //let metricsCopy = this.state.metrics;
      //metricsCopy.createMetricsDisplay = false;
      //let metricsResourceItemsCopy = this.state.metricsResourceItems;
      //metricsResourceItemsCopy[metricsRevertIndex] = metricsRevert;

      let saveBarCopy = this.state.saveBar;
      saveBarCopy.show = false;
      saveBarCopy.context = '';

      this.setState({
        //metrics:metricsCopy,
        saveBar:saveBarCopy,
        //metricsResourceItems:metricsResourceItemsCopy,
      },() =>{
        this.displayEditMetrics(false,true);
        this.getMetrics();
      });
    }
    if(this.state.saveBar.context == 'managed'){
      //console.log('managed edited');
      //console.log(this.state.metricsBeingEdited);
      //console.log('metricsRevert');
      //console.log(metricsRevertIndex);
      //console.log(metricsRevert);
      //let metricsCopy = this.state.metrics;
      //metricsCopy.createMetricsDisplay = false;
      //let metricsResourceItemsCopy = this.state.metricsResourceItems;
      //metricsResourceItemsCopy[metricsRevertIndex] = metricsRevert;

      let saveBarCopy = this.state.saveBar;
      saveBarCopy.show = false;
      saveBarCopy.context = '';

      this.setState({
        //metrics:metricsCopy,
        saveBar:saveBarCopy,
        createManagedCollection:false,
        displayManagedCollection:false,
        managedBeingEdited:blankManagedBeingEdited,
      },() =>{
        //this.displayEditMetrics(false,true);
        //this.getMetrics();
        this.getManagedCollections();
      });
    }
  }
  /* Navigation Methods */
  handleNavTabChange(selectedTab) {
    //this.setState({selectedTab});
    //console.log('handleTabChange:'+selectedTab);
    setTimeout(() => window.dispatchEvent(new Event('resize')), 30);
    //console.log('should fix 3');
    this.setState({ activeTab: selectedTab},() => {
      //do stuff?
      //close edit metrics if no metrics tabs clicked
      if(selectedTab != 1){
        this.displayEditMetrics(false,true); 
      }
    },() => {
      //dispatch resize event to fix tabs in pages bug
      //setTimeout(() => window.dispatchEvent(new Event('resize')), 500);
      //console.log('should fix 2');
    });
  }
  handleCollectionsNavChange(selectedTab) {
    //this.setState({selectedTab});
    //console.log('handleTabChange:'+selectedTab);
    this.setState({ 
      activeCollectionsTab: selectedTab,
      collectionsSelectedItems:[],
      collectionsAllCheckboxSelected:false,
      collectionsResourceItemsPage:0,
      collectionFilterQueryValue:'',
    },() => {
      this.getCollections();
    });
  }
  handleMetricsNavChange(selectedTab) {
    //this.setState({selectedTab});
    //console.log('handleTabChange:'+selectedTab);
    this.setState({ activeMetricsTab: selectedTab},() => {
      this.getMetrics();
    });
  }
  metricsFilterChangeQueryValue = (value) => {
    //console.log('metricsFilterChangeQueryValue: '+value);
    this.setState({metricsFilterQueryValue:value},() =>{
      this.getMetrics();
    });
  }
  managedFilterChangeQueryValue = (value) => {
    //console.log('managedFilterChangeQueryValue: '+value);
    this.setState({managedFilterQueryValue:value},() =>{
      //this.getMetrics();
      this.getManagedCollections();
    });
  }

  /* Autocomplete methods */
  changeCollectionsFilterValue = (value) => {
    //console.log('changeCollectionsFilterValue: '+value);
    this.setState({collectionsFilterValue:value})
    
  }
  changeMetricsFilterValue = (value) => {
    //console.log('changeMetricsFilterValue: '+value);
    this.setState({metricsFilterValue:value})
    
  }
  changeManagedFilterValue = (value) => {
    //console.log('changeMetricsFilterValue: '+value);
    this.setState({managedFilterValue:value})
    
  }
  /* Resource List Methods */
  /* collections methods */

  setCollectionsSelectedItems = (selected) => {
    this.setState({collectionsSelectedItems:selected});
  }
  resortCollection = (collectionId) => {
    //console.log('resortCollection: '+collectionId);
    this.setState({
      productsResorting:true,
      productsResortingCollection:collectionId,
      resortingToastShow:true
    },() => {
      const data = {
        action: 'resort_collection',
        collection:collectionId,
        store_url: storeUrl
      }  
      fetch('/ajax.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then(response => response.json())
      .then((json) =>{
        //console.log(json);
        this.setState({
          resortedToastShow:true,
          productsResorting:false,
          productsResortingCollection:0,
        })
        
      });
    })
    
  }
  hideResortingToast() {
    //console.log('hideResortingToast');
    this.setState({
      resortingToastShow:false
    });
  }
  hideResortedToast() {
    //console.log('hideResortedToast');
    this.setState({
      resortedToastShow:false
    });    
  }
  collectionsBulkToggle(enable) {
    //console.log('collectionsBulkToggle: '+enable);
    //console.log('has_turned_on? '+this.state.init.has_turned_on);
    //console.log(this.state.collectionsResourceItems);
    let collectionsResourceItemsCopy = this.state.collectionsResourceItems;
    let collectionsResourceItemEnabledCopy = 0;
    //let collectionsResourceItemEnabledCopy = this.state.collectionsResourceItemEnabled;
    let enabled;
    if(enable){
      enabled = "1";
    } else {
      enabled = "0";
    }
    for (let i = 0; i < collectionsResourceItemsCopy.length; i++) {
      let indexOfArray = this.state.collectionsSelectedItems.indexOf(collectionsResourceItemsCopy[i].id);
      //console.log('indexOfArray :'+indexOfArray);
      if(indexOfArray > -1){
        if (indexOfArray > -1) { // only splice array when item is found
          collectionsResourceItemsCopy[i].enabled = enabled;
        }      
      } 
      if(collectionsResourceItemsCopy[i].enabled == "1"){
        collectionsResourceItemEnabledCopy++;
      }
    }    
    const data = {
      action: 'collections_bulk_toggle',
      resources:this.state.collectionsSelectedItems,
      status:enable,
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      this.setState({
        collectionsResourceItems:collectionsResourceItemsCopy,
        collectionsResourceItemEnabled:collectionsResourceItemEnabledCopy,
      },() => {
        this.updateOnboardingModal();
      });
      if(enable){
        this.showToast('collectionsBulkEnabled');
      } else {
        this.showToast('collectionsBulkDisabled');
      }
    });
  }
  changeCollectionsEditBulkMetrics = (value) => {
    //console.log('changeCollectionsEditBulkMetrics: '+value);
    this.setState({
      collectionsBulkEditMetricSetValue:value,
      collectionsBulkEditShowSave:true,
    });
  }
  changeCollectionsEditBulkRevert = (value) => {
    //console.log('changeCollectionsEditBulkRevert: '+value);
    this.setState({
      collectionsBulkEditRevertValue:value,
      collectionsBulkEditShowSave:true,
    });
  }
  saveCollectionsEditBulk() {
    //console.log('saveCollectionsEditBulk');
    this.setState({
      collectionsBulkEditSaveLoading:true
    },() =>{
      const data = {
        action: 'save_bulk_collections',
        resources:this.state.collectionsSelectedItems,
        metric:this.state.collectionsBulkEditMetricSetValue,
        revert:this.state.collectionsBulkEditRevertValue,
        store_url: storeUrl,
      }  
      fetch('/ajax.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then(response => response.json())
      .then((json) =>{
        //console.log(json);
        let collectionsResourceItemsCopy = this.state.collectionsResourceItems;
        //console.log('collectionsResourceItemsCopy n: '+collectionsResourceItemsCopy.length);
        for (let i = 0; i < collectionsResourceItemsCopy.length; i++) {
          //console.log('checking id: '+collectionsResourceItemsCopy[i].id);
          const index = this.state.collectionsSelectedItems.indexOf(collectionsResourceItemsCopy[i].id);
          //console.log('index: '+index);
          if (index > -1) { // only splice array when item is found
            //collectionsSelectedItemsCopy.splice(index, 1); // 2nd parameter means remove one item only
            //console.log('change: '+collectionsResourceItemsCopy[i].name);
            //console.log(collectionsResourceItemsCopy[i]);
            if(this.state.collectionsBulkEditMetricSetValue != ''){
              collectionsResourceItemsCopy[i].metricId = this.state.collectionsBulkEditMetricSetValue;
              collectionsResourceItemsCopy[i].metricName = json.name;
            }
            if(this.state.collectionsBulkEditRevertValue != ''){
              collectionsResourceItemsCopy[i].revertSorting = this.state.collectionsBulkEditMetricSetValue;
            }
          }
        }        
        this.setState({
          collectionsBulkEditSaveLoading:false,
          collectionsBulkEditShowSave:false,
          collectionsResourceItems:collectionsResourceItemsCopy,
          //collectionsResourceItemsPages:collectionsResourceItemsPages
          
        },()=> {
          //this.getPreviewProducts();
          this.showToast('collectionsBulkChanged');

        });
      }); 
    });

       
  }
  discardCollectionsEditBulk(){
    //console.log('discardCollectionsEditBulk');
    this.collectionsBulkEdit(true); //reset
    this.collectionsBulkEdit(false); //close

  }

  uncheckAllCollectionsResourceItems() {
    //console.log('uncheckAllCollectionsResourceItems');
    let collectionsResourceItemsCopy = this.state.collectionsResourceItems;
    let collectionsSelectedItemsCopy = this.state.collectionsSelectedItems;
    //console.log('begin: '+begin+' end: '+end);    
    collectionsSelectedItemsCopy = [];
    for (let i = 0; i < collectionsResourceItemsCopy.length; i++) {
      collectionsResourceItemsCopy[i].checked = false;
    }
    this.setState({
      collectionsAllCheckboxSelected:false,
      collectionsResourceItems:collectionsResourceItemsCopy,
      collectionsSelectedItems:collectionsSelectedItemsCopy,
    },() => {
      this.isCollectionsAllChecked();
    });
  }
  collectionsAllCheckboxToggle = (selected) => {
    //console.log('collectionsAllCheckboxToggle: '+selected);
    //console.log('collectionsResourceItemsPage: '+this.state.collectionsResourceItemsPage);
    //const pagedItems = this.getCollectionResourceItems(this.state.collectionsResourceItemsPage);
    //console.log(this.state.collectionsResourceItems);
    //console.log(pagedItems);
    let collectionsResourceItemsCopy = this.state.collectionsResourceItems;
    let collectionsSelectedItemsCopy = this.state.collectionsSelectedItems;
    const page = this.state.collectionsResourceItemsPage;
    const begin = (0 + (page * resourceListItemCount));
    const end = (resourceListItemCount + (page * resourceListItemCount));
    //console.log('begin: '+begin+' end: '+end);    
    for (let i = begin; i < end; i++) {
      if(collectionsResourceItemsCopy[i]){
        collectionsResourceItemsCopy[i].checked = selected;
        if(selected){
          collectionsSelectedItemsCopy.push(collectionsResourceItemsCopy[i].id);
        } else {
          let id = collectionsResourceItemsCopy[i].id;
          const index = collectionsSelectedItemsCopy.indexOf(id);
          if (index > -1) { // only splice array when item is found
            collectionsSelectedItemsCopy.splice(index, 1); // 2nd parameter means remove one item only
          }
        }
      }
    }
    this.setState({
      collectionsAllCheckboxSelected:selected,
      collectionsResourceItems:collectionsResourceItemsCopy,
      collectionsSelectedItems:collectionsSelectedItemsCopy,
    },() => {
      this.isCollectionsAllChecked();
    });
    //console.log(this.state.collectionsResourceItems);
  }
  selectCollectionItem = (item,index,checked) => {
    const page = this.state.collectionsResourceItemsPage;
    index = index + (page * resourceListItemCount);
    //console.log('selectCollectionItem checked? '+item.checked+' index: '+index);
    let collectionsResourceItemsCopy = this.state.collectionsResourceItems;
    let collectionsSelectedItemsCopy = this.state.collectionsSelectedItems;
    collectionsResourceItemsCopy[index].checked = !collectionsResourceItemsCopy[index].checked;
    const indexOfArray = collectionsSelectedItemsCopy.indexOf(collectionsResourceItemsCopy[index].id);
    //console.log('indexOfArray :'+indexOfArray);
    if(indexOfArray > -1){
      //console.log('remove it: '+item.id);
      if (indexOfArray > -1) { // only splice array when item is found
        collectionsSelectedItemsCopy.splice(indexOfArray, 1); // 2nd parameter means remove one item only
      }      
    } else {
      if (indexOfArray < 0) { // only splice array when item is found
        //console.log('add it: '+item.id);
        collectionsSelectedItemsCopy.push(item.id); // 2nd parameter means remove one item only
      } 
    }
    //console.log(collectionsSelectedItemsCopy);
    this.setState({
      collectionsResourceItems:collectionsResourceItemsCopy,
      collectionsSelectedItems:collectionsSelectedItemsCopy,
    },() => {
      this.isCollectionsAllChecked();
    });
  }
  isCollectionsAllChecked() {
    const page = this.state.collectionsResourceItemsPage;
    const begin = (0 + (page * resourceListItemCount));
    const end = (resourceListItemCount + (page * resourceListItemCount));
    //console.log('begin: '+begin+' end: '+end);  
    let checkedCount = 0;  
    for (let i = begin; i < end; i++) {
      if(this.state.collectionsResourceItems[i] //if defined on last page
        &&
        this.state.collectionsResourceItems[i].checked
      ) {
        checkedCount++;
        //console.log('i: '+i+' checked, total: '+checkedCount);
      }
    }
    let checked;
    if(checkedCount == 0){
      checked = false;
    } else if (checkedCount == resourceListItemCount){
      checked =  true;
    } else {
      checked=  "indeterminate";
    }
    this.setState({
      collectionsAllCheckboxSelected:checked
    })
  }
  collectionsToggleCheckAll(checked) {
    //console.log('collectionsToggleCheckAll: '+checked);
    let collectionsResourceItemsCopy = this.state.collectionsResourceItems;
    let collectionsSelectedItemsCopy = [];
    for (let i = 0; i < collectionsResourceItemsCopy.length; i++) {
      collectionsResourceItemsCopy[i].checked = checked;
      if(checked){
        collectionsSelectedItemsCopy.push(collectionsResourceItemsCopy[i].id);
      } 
    }
    //if(!checked){
    //  collectionsSelectedItemsCopy = [];
    //}
    this.setState({
      collectionsResourceItems: collectionsResourceItemsCopy,
      collectionsSelectedItems: collectionsSelectedItemsCopy,
    },() => {
      this.isCollectionsAllChecked();
    });    
  }
 

  getCollections() {
    //console.log('getCollections? '+ storeUrl);
    const data = {
      action: 'get_collections',
      tab:this.state.activeCollectionsTab,
      query:this.state.collectionFilterQueryValue,
      sort:this.state.popoverFilters.collections.value,
      active:this.state.popoverFilters.collectionsActive.value,
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      let collectionsResourceItemEnabled = 0;
      for (let i = 0; i < json.collections.length; i++) {
        if(json.collections[i].enabled == "1"){
          collectionsResourceItemEnabled++;
        }
      }
      let collectionsResourceItemsPages = Math.ceil((json.collections.length / resourceListItemCount));
      this.setState({
        collectionsResourceItems:json.collections,
        collectionsResourceItemsPages:collectionsResourceItemsPages,
        collectionsResourceItemsPage:0,
        collectionsResourceItemEnabled:collectionsResourceItemEnabled,
      },()=> {
        this.getPreviewProducts();
      });
    }).then(()=>{
      //what else?
      //console.log('getCollections() finished');
    });
  }
  collectionFilterChangeQueryValue = (value) => {
    //console.log('collectionFilterChangeQueryValue: '+value);
    this.setState({
      collectionFilterQueryValue:value,
    },() =>{
      this.getCollections();
    });
  }
  getCollectionResourceItems(page){
    //console.log('collectionsResourceItemsPages: '+this.state.collectionsResourceItemsPages);
    const begin = (0 + (page * resourceListItemCount));
    const end = (resourceListItemCount + (page * resourceListItemCount));
    return this.state.collectionsResourceItems.slice(begin,end);
  }
  collectionResourcePage(i){
    const newPage = this.state.collectionsResourceItemsPage + i;
    this.setState({collectionsResourceItemsPage:newPage},() => {
      this.isCollectionsAllChecked();
    });
  }
  setCollectionStatus = (cid,index,value) => {
    //console.log('page: '+this.state.collectionsResourceItemsPage+' x '+resourceListItemCount);
    let resourceIndex = (this.state.collectionsResourceItemsPage * resourceListItemCount) + index;
    //console.log('cid: '+cid+' index: '+index+' value: '+value);
    //console.log('has_turned_on? '+this.state.init.has_turned_on);

    //toggle turn if not done already
    if(
      this.state.init.has_turned_on == "0"
      &&
      value == "1"
    ){
      let initCopy = this.state.init;
      initCopy.has_turned_on = "1";
      this.setState({
        init:initCopy,
        firstCollectionEnabled:true,
        firstCollectionEnabledObject:this.state.collectionsResourceItems[index],
      },() =>{
        //console.log(this.state.collectionsResourceItems[index]);
        this.statusShowModal(true);
      });
    }
    //do stuff
    let collectionsResourceItemsCopy = this.state.collectionsResourceItems;
    let collectionsResourceItemEnabledCopy = this.state.collectionsResourceItemEnabled;
    if(parseInt(value) == 1){
      collectionsResourceItemEnabledCopy++;
    } else {
      collectionsResourceItemEnabledCopy--;
    }
    collectionsResourceItemsCopy[resourceIndex].enabled = value;
    this.setState({
      collectionsResourceItems:collectionsResourceItemsCopy,
      collectionsResourceItemEnabled:collectionsResourceItemEnabledCopy,
    });
    const data = {
      action: 'set_collection_status',
      status:value,
      collection_id:cid,
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      this.updateOnboardingModal();
      this.getProducts();
      if(value == 1){
        this.showToast('collectionEnabled');
      } else {
        this.showToast('collectionDisabled');
      }
      this.doImmediateCollectionSorting(cid,index,value);
    });

  }
  doImmediateCollectionSorting(cid,index,value){
    if(storeUrl != 'dynasort.myshopify.com'){
      //return;
    }
    if(
      this.state.status != 'On'
    ){
      //console.log('no rank, turned off');
      return;
    }
    let resourceIndex = (this.state.collectionsResourceItemsPage * resourceListItemCount) + index;
    //console.log('doImmediateCollectionSorting: cid: '+cid+' index: '+index+' resourceIndex: '+resourceIndex+' value: '+value);
    //console.log(this.state.collectionsResourceItems[resourceIndex]);
    let collectionsResourceItemsCopy = this.state.collectionsResourceItems;

    //set timeout to revert UI even if failed or network hangup
      //here!

    collectionsResourceItemsCopy[resourceIndex].lastSorted = (parseInt(value) == 1 ? 'Sorting':'Reverting');
    collectionsResourceItemsCopy[resourceIndex].isSorting = true;
    this.setState({
      collectionsResourceItems:collectionsResourceItemsCopy,
    },() => {
      const data = {
        action: 'sort_or_revert_collection',
        status:value,
        collection_id:cid,
        store_url: storeUrl
      }  
      fetch('/ajax.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then(response => response.json())
      .then((json) =>{
        //console.log(json);
        //collectionsResourceItemsCopy[resourceIndex].lastSorted = 'just now';
        collectionsResourceItemsCopy[resourceIndex].lastSorted = json.lastSorted;
        collectionsResourceItemsCopy[resourceIndex].isSorting = false; 
        this.setState({
          collectionsResourceItems:collectionsResourceItemsCopy,
        },() => {
          this.getProducts();
        });       
      });      
    });

  }
  collectionsBulkEdit(display) {
    //console.log('collectionsBulkEdit');
    let collectionsBulkEditMetricSetOptions = [{label:"Keep Current Value",value:''}];
    let collectionsBulkEditRevertOptions = [{label:"Keep Current Value",value:''},...revertToSelectOptions];
    
    //setup metric sets
    //console.log(this.state.metricsResourceItems);
    this.state.metricsResourceItems.map(function(item, i){
      collectionsBulkEditMetricSetOptions.push({label:item.name,value:item.id});
    });
    this.setState({
      collectionBeingEditedModalBulk:display,
      collectionsBulkEditShowSave:false,
      collectionsBulkEditMetricSetOptions:collectionsBulkEditMetricSetOptions,
      collectionsBulkEditRevertOptions:collectionsBulkEditRevertOptions,
      collectionsBulkEditMetricSetValue:collectionsBulkEditMetricSetOptions[0].value,
      collectionsBulkEditRevertValue:collectionsBulkEditRevertOptions[0].value,
    });    
  }
  collectionDetailsModal(cid,index,display){
    //console.log('page: '+this.state.collectionsResourceItemsPage+' x '+resourceListItemCount);
    let resourceIndex = (this.state.collectionsResourceItemsPage * resourceListItemCount) + index;
    //console.log('resourceIndex: '+resourceIndex);
    //console.log('cid: '+cid+' index: '+index+' display: '+display);
    let collectionBeingEditedCopy = this.state.collectionsResourceItems[resourceIndex];
    collectionBeingEditedCopy.resourceIndex = index;
    this.setState({
      collectionBeingEditedModal:display,
      collectionBeingEdited:collectionBeingEditedCopy,
    });
  }
  metricsChangeCollection(value,collectionObj,key) {
    //console.log('metricsChangeCollection -  key: '+key+' value: '+value);
    //console.log(collectionObj);
    collectionObj[key] = value;
    let collectionsResourceItemsCopy = this.state.collectionsResourceItems;
    //console.log(collectionsResourceItems[collectionObj.resourceIndex]);
    collectionsResourceItemsCopy[collectionObj.resourceIndex] = collectionObj;
    //console.log(collectionsResourceItemsCopy[collectionObj.resourceIndex]);
    this.setState({
      collectionBeingEdited:collectionObj,
      collectionsResourceItems:collectionsResourceItemsCopy,
    },() => {
      //console.log(collectionsResourceItems[collectionObj.resourceIndex]);
      //console.log('do ajax request to update collection');
      const data = {
        action: 'update_collection',
        collection:collectionObj,
        store_url: storeUrl
      }  
      fetch('/ajax.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then(response => response.json())
      .then((json) =>{
        //console.log(json);
        this.getCollections();
        this.getCollectionResourceItems();
        this.getMetrics();
        this.getMetricsCollections();
        this.getMetricsCollectionProducts();
        this.getMetricsProductsPreview();
        //productsCollectionsOptions
        this.setState({

        },()=> {
          //this.getCollections();
          this.showToast('collectionDetailsChanged')
        });
      });
      
    });
  }
  viewSorting(metricsId,collectionId){
    //console.log('viewSorting: m: '+metricsId+' c: '+collectionId);
    this.setState({
      activeTab:5,//xoxo
      productsMetricsSelected:metricsId,
      //productsCollectionsSelected:collectionId,
    },() => {
      //window.scrollTo(0, 0);
      //this.getMetricsCollections(metricsId,collectionId);
      const data = {
        action: 'get_metrics_collections',
        id:metricsId,
        store_url: storeUrl
      }  
      fetch('/ajax.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then(response => response.json())
      .then((json) =>{
        //console.log('json:');
        //console.log(json);
        //console.log(json[0]);
        this.setState({
          productsCollectionsOptions:json,
          productsCollectionsSelected:collectionId,
          //productsCollectionsSelected:json[0]['value'] || '',
          //metricsResourceItems:json.metrics,
          //collectionsResourceItemsPages:collectionsResourceItemsPages
        },() => {
          this.getMetricsCollectionProducts();
        });
      }).then(()=>{
        //what else?
        
      }); 
    });
  }


  /* metrics methods */
  duplicateMetrics(metricId){
    //console.log('duplicateMetrics: '+metricId);
    //console.log(this.state.metrics);
    let duplicateMetrics = {
      id:0,
      name:this.state.metricsBeingEdited.name+' (Duplicate)',
      attributes:this.state.metricsBeingEdited.attributes,
      boost:this.state.metricsBeingEdited.boost,
      is_default:false,
      soldOutValue:this.state.metricsBeingEdited.soldOutValue,
      tieBreakerValue:this.state.metricsBeingEdited.tieBreakerValue,
      products:[],
    }
    let saveBarCopy = this.state.saveBar;
    saveBarCopy.show = true;
    saveBarCopy.context = 'metrics';
    //console.log(duplicateMetrics);
    this.setState({
      metricsBeingEdited:duplicateMetrics,
      saveBar:saveBarCopy,
    });
  }
  displayEditMetrics = (display,create=false) => {
    //console.log('displayEditMetrics: '+display+' / '+create);
    let metricsCopy = this.state.metrics;
    //console.log(this.state.metrics);
    metricsCopy.createMetricsDisplay = display; 
    if(create){
      //console.log(this.state.metricsBeingEditedDefault);
      //console.log(metricsBeingEditedDefaultRevert);
      const fuckStateMetrics = {
        id:0,
        title:'',
        attributes:[],
        boost:false,
        is_default:false,
        soldOutValue:soldOutOptions[0],
        tieBreakerValue:tieBreaker[0],
        products:[],
      };
      this.setState({
        metricsBeingEdited:fuckStateMetrics,
        metrics:metricsCopy
      },() => {
        this.getMetricsPreviewProducts();
      });
    } else {
      this.setState({metrics:metricsCopy}, () => {
        this.getMetricsPreviewProducts();
      });
    }
    //createMetricsDisplay
  }
  getMetrics() {
    //console.log('getMetrics');
    const data = {
      action: 'get_metrics',
      tab:this.state.activeMetricsTab,
      query:this.state.metricsFilterQueryValue,
      sort:this.state.popoverFilters.metrics.value,
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      let collectionsResourceItemsPages;
      if(json.metrics){
        collectionsResourceItemsPages = Math.ceil((json.metrics.length / resourceListItemCount));
      } else {
        collectionsResourceItemsPages = 0;
      }
      let productMetricsOptions = [];
      let metricsCollectionsId = false;
      if(json.metrics != null){
        for (let i = 0; i < json.metrics.length; i++) {
          if(parseInt(json.metrics[i].collections) > 0){
            productMetricsOptions.push({label:json.metrics[i].name,value:json.metrics[i].id});
            if(metricsCollectionsId === false){
              metricsCollectionsId = json.metrics[i].id;
            }
          }
        }
      }
      //console.log('metrics!');
      //console.log(json.metrics);
      let productMetricsSelected;
      //console.log('productMetricsOptions:');
      //console.log(productMetricsOptions);
      //console.log(productMetricsOptions[0]);
      //console.log(productMetricsOptions[0].value);
      if(productMetricsOptions.length == 0){
        productMetricsSelected = '';
      } else {
        productMetricsSelected = productMetricsOptions[0]['value'];
      }
      this.setState({
        metricsResourceItems:json.metrics,
        metricsResourceItemsCount:json.metrics.length,
        metricsDefaultId:json.default,
        productMetricsOptions:productMetricsOptions,
        //here??
        productsMetricsSelected:productMetricsSelected,
      },()=> {
        this.getPreviewProducts();
        this.getMetricsCollections(metricsCollectionsId);
        //if(parseInt(json.metrics[0].collections) > 0){
        //}
        
        //console.log('productsMetricsSelected? '+this.state.productsMetricsSelected)
      });
    }).then(()=>{
      //what else?

    });
  }
  sidebarCollectionsChange = (value) => {
    //console.log('sidebarCollectionsChange: '+value);
    this.setState({sidebarCollectionsValue:value},() =>{
      //console.log('sidebar metricsBeingEdited for ')
      //console.log(this.state.metricsBeingEdited.id);
      this.getMetricsSidebarCollections(this.state.metricsBeingEdited.id,value)
    });
  }
  getMetricsSidebarCollections(id,search){
    //console.log('getMetricsSidebarCollections: '+id+' / '+search);
    const data = {
      action: 'get_metrics_sidebar_collections',
      id:id,
      search:search,
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      this.setState({
        metricsSidebarCollections:json,
      });
    }); 
  }
  editMetricsObject = (isNew,index=false,key,value) => {
    //console.log('editMetricsObject ~ isNew: '+isNew+' index: '+index+' key: '+key+' value: '+value);
    let metricsBeingEditedCopy = this.state.metricsBeingEdited;
    //console.log(metricsBeingEditedCopy);
    let saveBarCopy = this.state.saveBar;
    saveBarCopy.show = true;
    saveBarCopy.context = 'metrics';
    metricsBeingEditedCopy[key] = value;
    //metricsBeingEditedCopy.is_default = true;

    //console.log(metricsBeingEditedCopy);
    this.setState({
      metricsBeingEdited:metricsBeingEditedCopy,
      saveBar:saveBarCopy
    }, () => {
      //console.log(this.state.metricsBeingEdited);
      this.getMetricsPreviewProducts();
    });
  }
  addMetricsAttributeRow = () => {
    //console.log('addMetricsAttributeRow');
    //console.log(initAttributeRow);
    //console.log(this.state.metricsBeingEdited.attributes);
    let metricsBeingEditedCopy = this.state.metricsBeingEdited;
    let saveBarCopy = this.state.saveBar;
    saveBarCopy.show = true;
    saveBarCopy.context = 'metrics';
/*
const initAttributeRow = {
  select:{
    options:attributeOptionTypes,
    value:attributeOptionTypes[0].value,
  },
  value:0,
}
*/
  const initOptionTypes = this.getAttributeOptionTypes(-1);
  //console.log('initOptionTypes');
  //console.log(initOptionTypes);
  let initAttributeRowFuck = {
    select:{
      options:initOptionTypes[0],
      value:initOptionTypes[0].value
    },
    value:0
  }

    metricsBeingEditedCopy.attributes.push(initAttributeRowFuck);
    //console.log(metricsBeingEditedCopy.attributes);
    this.setState({metricsBeingEdited:metricsBeingEditedCopy, saveBar:saveBarCopy},() =>{
      this.getMetricsPreviewProducts();
    });
  }
  removeMetricAttribute = (i) => {
    //console.log('removeMetricAttribute: '+i);
    let metricsBeingEditedCopy = this.state.metricsBeingEdited;
    let saveBarCopy = this.state.saveBar;
    saveBarCopy.show = true;
    saveBarCopy.context = 'metrics';
    //console.log(metricsBeingEditedCopy.attributes);
    metricsBeingEditedCopy.attributes.splice(i,1);
    //console.log(metricsBeingEditedCopy.attributes);
    this.setState({metricsBeingEdited:metricsBeingEditedCopy, saveBar:saveBarCopy},() => {
      this.getMetricsPreviewProducts();
    });
  }
  editMetricsAttributes = (index,key,value) => {
    //console.log('editMetricsAttributes: '+index+' key: '+key+' value: '+value);
    let metricsBeingEditedCopy = this.state.metricsBeingEdited;
    let saveBarCopy = this.state.saveBar;
    saveBarCopy.show = true;
    saveBarCopy.context = 'metrics';
    //console.log(metricsBeingEditedCopy);
    if(key == 'select') {
      metricsBeingEditedCopy.attributes[index] = {
        select:{
          options:this.state.metricsBeingEdited.attributes[index].select.options,
          value:value
        },
        value:this.state.metricsBeingEdited.attributes[index].value
      }
    }
    if(key == 'value') {
      metricsBeingEditedCopy.attributes[index] = {
        select:{
          options:this.state.metricsBeingEdited.attributes[index].select.options,
          value:this.state.metricsBeingEdited.attributes[index].select.value
        },
        value:value
      }
    }
    //console.log(metricsBeingEditedCopy);
    this.setState({metricsBeingEdited: metricsBeingEditedCopy, saveBar:saveBarCopy},() => {
      this.getMetricsPreviewProducts();
    });
  }
  getMetricsCollections(id){
    //console.log('getMetricsCollections: '+id);
    const data = {
      action: 'get_metrics_collections',
      id:id,
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log('json:');
      //console.log(json);
      //console.log(json[0]);
      this.setState({
        productsCollectionsOptions:json,
        productsCollectionsSelected:json[0]['value'] || '',
        //metricsResourceItems:json.metrics,
        //collectionsResourceItemsPages:collectionsResourceItemsPages
      },() => {
        this.getMetricsCollectionProducts();
      });
    }).then(()=>{
      //what else?
      
    }); 
  }
  getMetricsProductsPreview(metricsId,metricsBeingEditedObj=false) {
    //old, not using
    //console.log('getMetricsProductsPreview');
  }
  doSaveMetrics(){
    //console.log('doSaveMetrics');
    //console.log(this.state.metricsBeingEdited);
    const data = {
      action: 'save_metrics',
      metrics:this.state.metricsBeingEdited,
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      let metricsBeingEditedCopy = this.state.metricsBeingEdited;
      let saveBarCopy = this.state.saveBar;
      metricsBeingEditedCopy.products = json.products;
      metricsBeingEditedCopy.id = json.id;
      saveBarCopy.show = false;
      saveBarCopy.context = '';

      this.setState({
        metricsBeingEdited:metricsBeingEditedCopy,
        saveBar:saveBarCopy,
      });
    }).then(()=>{
      this.getMetrics();
      this.getCollections();
      this.getMetricsCollectionProducts();
      this.getMetricsProductsPreview();
      //this.
      this.showToast('metricsSaved');
      //what else?
      //console.log(this.state.metricsBeingEdited);
    }); 
  }
  editMetrics(id,index){
    //console.log('editMetrics');
    //console.log(this.state.metricsResourceItems[index]);
    let metricsCopy =  this.state.metrics;
    metricsCopy.createMetricsDisplay = true;
    for (const property in this.state.metricsResourceItems[index]) {
      metricsRevert[property] = this.state.metricsResourceItems[index][property];
    }
    metricsRevertIndex = index;

    this.setState({
      metrics:metricsCopy,
      metricsBeingEdited:this.state.metricsResourceItems[index]
    },() => {
      this.getMetricsSidebarCollections(id,'');
      this.getMetricsPreviewProducts();
    });
  }
  viewProductScores(metricId){
    //console.log('viewProductScores: '+metricId);
    //change tag
    this.handleNavTabChange(5); //xoxo
    //change dropdown
    this.setState({productsMetricsSelected:metricId},() => {
      this.getMetricsCollections(metricId);
    });
  }
  getMetricsPreviewProducts(){
    //console.log('getMetricsPreviewProducts');
    //  metricsPreviewProducts
    const data = {
      action: 'get_metrics_preview_products',
      metrics:this.state.metricsBeingEdited,
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      this.setState({
        metricsPreviewProducts:json,
        //collectionsResourceItemsPages:collectionsResourceItemsPages
      });
    }); 
  }

  /* products methods */
  getPreviewProducts() {
    //only run once both are set
    if(
      this.state.collectionsResourceItems.length == 0
      ||
      this.state.metricsResourceItems.length == 0
    ) {
      //console.log('getPreviewProducts state not set');
      return;      
    }
    //console.log('getPreviewProducts state set');
    //console.log('getPreviewProducts mid: '+this.state.collectionsResourceItems[0].id+' cid: '+this.state.metricsResourceItems[0].id);
    const data = {
      action: 'get_preview_products',
      collection:this.state.collectionsResourceItems[0].id,
      metrics:this.state.metricsResourceItems[0].id,
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      this.setState({
        //metricsResourceItems:json.metrics,
        //collectionsResourceItemsPages:collectionsResourceItemsPages
      });
    });    
  }
  getProducts(){
    //console.log('getProducts() ');
    //productsLoading
    this.setState({
      productsLoading:true,
    },() => {
      const data = {
        action: 'get_products',
        //collection:this.state.collectionsResourceItems[0].id,
        //metrics:this.state.metricsResourceItems[0].id,
        store_url: storeUrl
      }  
      fetch('/ajax.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then(response => response.json())
      .then((json) =>{
        //console.log(json);
        this.setState({
          productsLoading:false,
          //productsMetricsId:json.product_metrics_id,
          //collectionsResourceItemsPages:collectionsResourceItemsPages
        });
      }); 
    });
    
  }
  loadMoreProducts = () => {
    const showProductIndex = this.state.showProductIndex + 1;
    //console.log('loadMoreProducts: '+showProductIndex);
    this.setState({showProductIndex:showProductIndex});
  }
  productsMetricsChanged = (value) => {
    //console.log('productsMetricsChanged: '+value);
    this.setState({
      productsMetricsSelected:value,
      showProductIndex:0,
    },() => {
      this.getMetricsCollections(value);
    });
    //let productsMetricsSelectedCopy  = this.state.productsMetricsSelected;
  }
  changeProductsCollectionsChanged = (value) => {
    //console.log('changeProductsCollectionsChanged: '+value);
    this.setState({
      productsCollectionsSelected:value,
      showProductIndex:0,
    },() => {
      this.getMetricsCollectionProducts();
    });    
  }
  getMetricsCollectionProducts(){
    console.log('getMetricsCollectionProducts~  collection: '+this.state.productsCollectionsSelected+' metrics: '+this.state.productsMetricsSelected);
    //get collections producst here
    this.setState({
      productsLoading:true,
    },() => {
      const data = {
        action: 'get_metrics_collection_products',
        collection:this.state.productsCollectionsSelected,
        metrics:this.state.productsMetricsSelected,
        store_url: storeUrl
      }  
      fetch('/ajax.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then(response => response.json())
      .then((json) =>{
        //console.log(json);
        this.setState({
          products:json.products,
          metricsCollectionProductsAttributes:json.attributes,
          metricsCollectionProductsBoost:json.boost,
          productsLoading:false,
          //collectionsResourceItemsPages:collectionsResourceItemsPages
        });
      }); 
    })
  }

  /* settings methods */
  changeSettingsSelect = (value,key) => {
    //console.log('changeSettingsValues v: '+value+' k: '+key);
    let settingsCopy = this.state.settings;
    settingsCopy[key].value = value;
    this.setState({
      settings: settingsCopy,
      showProcessingSave:true
    });
  }
  saveProcessingSettings() {
    //console.log('saveProcessingSettings');
    this.setState({
      processingSaveLoading:true,
    },() => {
      const data = {
        action: 'save_processing_settings',
        settings:this.state.settings,
        store_url: storeUrl
      }  
      fetch('/ajax.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then(response => response.json())
      .then((json) =>{
        //console.log(json);
        this.setState({
          showProcessingSave:false,
          processingSaveLoading:false,
        });
        this.showToast('settingsSaved');
      }); 
    });
    
  }
  discardProcessingSettings() {
    //console.log('discardProcessingSettings');
    ///console.log(this.state.settings);
    //console.log('settingsRevert 2');
    //console.log(settingsRevert);
    this.setState({
      processingSaveLoading:true,
    },() => {
      let settingsCopy = this.state.settings;
      for (const property in settingsCopy) {
        if(settingsRevert.hasOwnProperty(property)){
          settingsCopy[property].value = settingsRevert[property];
        }
      }
      //console.log('settingsRevert 2');
      //console.log(settingsCopy);
      this.setState({
        showProcessingSave:false,
        processingSaveLoading:false,
      });
    });    
  }
  saveNotificationsSettings() {
    //console.log('saveNotificationsSettings');
    this.setState({
      notificationsSaveLoading:true,
    },() => {
      const data = {
        action: 'save_notification_settings',
        settings:this.state.settings,
        store_url: storeUrl
      }  
      fetch('/ajax.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then(response => response.json())
      .then((json) =>{
        //console.log(json);
        this.setState({
          showNotificationsSave:false,
          notificationsSaveLoading:false,
        });
      }); 
    });
  }
  discardNotificationsSettings() {
    //console.log('discardNotificationsSettings');
    ///console.log(this.state.settings);
    //console.log('settingsRevert 2');
    //console.log(settingsRevert);
    this.setState({
      notificationsSaveLoading:true,
    },() => {
      let settingsCopy = this.state.settings;
      for (const property in settingsCopy) {
        if(settingsRevert.hasOwnProperty(property)){
          settingsCopy[property].value = settingsRevert[property];
        }
      }
      //console.log('settingsRevert 2');
      //console.log(settingsCopy);
      this.setState({
        showNotificationsSave:false,
        notificationsSaveLoading:false,
      });
    });    
  }
  changeSettingsCheckbox = (key,value) => {
    //console.log('changeSettingsCheckbox '+key+' : '+value);
    let settingsCopy = this.state.settings;
    settingsCopy[key].value = value;
    this.setState({
      settings: settingsCopy,
      showNotificationsSave:true
    });
  }
  changeSettingsAdditionalEmails = (value) => {
    //console.log('changeSettingsTextInput '+value);
    let settingsCopy = this.state.settings;
    let errorsCopy = this.state.errors;
    let additionalEmailsError = false;
    settingsCopy['additional_emails'].value = value;
    let emailAddresses = value.split(',');
    for (let i = 0; i < emailAddresses.length; i++) {
      //test each for valid email
      emailAddresses[i] = emailAddresses[i].trim();
      //console.log("'"+emailAddresses[i]+"'");
      if(
        emailAddresses[i].match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
        ||
        emailAddresses[i].length == 0
      ){
        //additionalEmailsError = false;
      } else {
        additionalEmailsError = 'Please enter valid email addresses separated by commas';
      }
    }    
    //console.log('error? '+additionalEmailsError);
    errorsCopy.additional_emails = additionalEmailsError;
    this.setState({
      settings: settingsCopy,
      showNotificationsSave:true,
      errors:errorsCopy,
    },() => {
      //this.validateAdditionalEmails();
    });
  }
  //validateAdditionalEmails() {
  //  //console.log('validate');
  //}
  /* attribute methods */
  getAttributeOptionTypes =  (index) => {
    let attributeOptionTypesFuck = [
      {label:'Quantity',value:'quantity'},
      {label:'Full Size Run', value: 'full-size-run'},
      {label:'Sizes In Stock', value: 'sizes-in-stock'},
      {label:'Variants In Stock', value: 'variants-in-stock'},
      {label:'Product Published Age',value:'days-since-published'},
      {label:'Product Created Age',value:'days-since-created'},
      {label:'Age Of Newest Variant',value:'age-of-newest-variant'},
      {label:'Sales (Last 24 Hours)',value:'sales-last-1-days'},
      {label:'Sales (Last 3 Days)',value:'sales-last-3-days'},
      {label:'Sales (Last 7 Days)',value:'sales-last-7-days'},
      {label:'Sales (Last 30 Days)',value:'sales-last-30-days'},
      {label:'Sales (Last 60 Days)',value:'sales-last-60-days'},
      {label:'Sales (All-time)',value:'sales-all-time'},
      {label:'Revenue (Last 24 Hours)',value:'revenue-last-1-days'},
      {label:'Revenue (Last 3 Days)',value:'revenue-last-3-days'},
      {label:'Revenue (Last 7 Days)',value:'revenue-last-7-days'},
      {label:'Revenue (Last 30 Days)',value:'revenue-last-30-days'},
      {label:'Revenue (Last 60 Days)',value:'revenue-last-60-days'},
      {label:'Revenue (All-time)',value:'revenue-all-time'},
      {label:'Margin',value:'margin'},
      {label:'Sold Out',value:'sold-out'},
      {label:'On Sale',value:'on-sale-natural'},
      //{label:'On Sale',value:'on-sale'},
      //{label: 'Coming Soon', value: 'coming-soon'},
      //{label: 'Brand Boost', value: 'brand-boost'},
      //{label: 'Yotpo Reviews', value: 'yotpo'}, //hidden for dev/review
    ];
    //add custom attrs to list
    //console.log('getAttributeOptionTypes productAttributes');
    //console.log(this.state.productAttributes);

    //custom attrs
    if(this.state.productAttributes !== null && this.state.productAttributes.custom && this.state.productAttributes.custom.length > 0){
      for (let i = 0; i < this.state.productAttributes.custom.length; i++) {
        attributeOptionTypesFuck.push({label:this.state.productAttributes.custom[i].name,value:this.state.productAttributes.custom[i].attribute_key})
      }
    }
    //partner attrs
    if(this.state.productAttributes !== null && this.state.productAttributes.partner && this.state.productAttributes.partner.length > 0){
      for (let i = 0; i < this.state.productAttributes.partner.length; i++) {
        attributeOptionTypesFuck.push({label:this.state.productAttributes.partner[i].name,value:this.state.productAttributes.partner[i].attribute_key})
      }
    }


    let fuckingAlreadyUsed = [];
    for (let i = 0; i < this.state.metricsBeingEdited.attributes.length; i++) {
      fuckingAlreadyUsed.push(this.state.metricsBeingEdited.attributes[i].select.value);
    }

    let fuck = [];
    let empty = true;
    for (let i = 0; i < this.state.metricsBeingEdited.attributes.length; i++) {
      //console.log('val: '+this.state.metricsBeingEdited.attributes[i].select.value);
      empty = false;
      for (let i2 = 0; i2 < attributeOptionTypesFuck.length; i2++) {
        //console.log('val: '+this.state.metricsBeingEdited.attributes[i].select.value+' fuck? '+attributeOptionTypesFuck[i2].value);
        //console.log('iterate? '+i);
        if(
          (
            this.state.metricsBeingEdited.attributes[i].select.value == attributeOptionTypesFuck[i2].value
            &&
            i == index
          )
          ||
          (
            !fuckingAlreadyUsed.includes(attributeOptionTypesFuck[i2].value)
            &&
            !fuck.includes(attributeOptionTypesFuck[i2])
          )
        ){
          //console.log('fuck! '+attributeOptionTypesFuck[i2].value);
          fuck.push(attributeOptionTypesFuck[i2]);
        }
      }
    }
    //console.log('fuck index: '+index);
    if(
      index < 0
      &&
      empty
    ){ //none set yet
      //console.log('this should unfuck the index');
      fuck = attributeOptionTypesFuck;
    }
    
    fuck.sort((a,b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
    //console.log(fuck);
    return fuck;
  }
  getAttributes() {
    //console.log('getAttributes');
    const data = {
      action: 'get_attribute_settings',
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log('getAttributes');
      //console.log(json);
      this.setState({
        productAttributes:json,
      });
    }); 
  }
  addAttribute(type) {
    //console.log('addAttribute');
    const data = {
      action: 'add_attribute',
      type:type,
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      this.getAttributes();
    });
  }
  deleteAttribute(attribute_key){
    //console.log('deleteAttribute: '+attribute_key);
    const data = {
      action: 'delete_attribute',
      attribute_key:attribute_key,
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      this.getAttributes();
      this.getMetrics();
      this.getProducts();
    });    
  }
  changeConfigurables = (value,attributeKey,fieldKey) => {
    //console.log('changeConfigurables v:'+value+' g: '+group+' ak: '+attributeKey+' fk: '+fieldKey);
    //console.log('changeConfigurables v:'+value+' ak: '+attributeKey+' fk:'+fieldKey);
    //console.log(fieldKey);
    let productAttributesCopy = this.state.productAttributes;
    for (var group in productAttributesCopy){
      //console.log('group: '+group);
      for (let i = 0; i < productAttributesCopy[group].length; i++) {
        if(attributeKey == productAttributesCopy[group][i].attribute_key) {
          //console.log('i: '+i+' = '+productAttributesCopy[group][i].attribute_key);
          //console.log('old: '+productAttributesCopy[group][i].fields[fieldKey].value);
          productAttributesCopy[group][i].fields[fieldKey].value = value;
          productAttributesCopy[group][i].saveable = "1";
          //console.log('new: '+productAttributesCopy[group][i].fields[fieldKey].value);
          this.setState({productAttributes:productAttributesCopy});
        }
      }
    
      //if (target.hasOwnProperty(k)) {
      //     alert("Key is " + k + ", value is " + target[k]);
      //}
    }
    //console.log(productAttributesCopy);
  }
  changeConfigurableTitle = (value,attributeKey) => {
    //console.log('changeConfigurableTitle v:'+value+' ak: '+attributeKey);
    //console.log('changeConfigurables v:'+value+' ak: '+attributeKey+' fk:'+fieldKey);
    //console.log(fieldKey);

    let productAttributesCopy = this.state.productAttributes;
    for (var group in productAttributesCopy){
      //console.log('group: '+group);
      for (let i = 0; i < productAttributesCopy[group].length; i++) {
        if(attributeKey == productAttributesCopy[group][i].attribute_key) {
          //console.log('i: '+i+' = '+productAttributesCopy[group][i].attribute_key);
          //console.log('old: '+productAttributesCopy[group][i].fields[fieldKey].value);
          productAttributesCopy[group][i].name = value;
          productAttributesCopy[group][i].saveable = "1";
          //console.log('new: '+productAttributesCopy[group][i].fields[fieldKey].value);
          this.setState({productAttributes:productAttributesCopy});
        }
      }
    
      //if (target.hasOwnProperty(k)) {
      //     alert("Key is " + k + ", value is " + target[k]);
      //}
    }
    //console.log(productAttributesCopy);
  }
  saveConfigurables = (attributeKey) => {
    //console.log('saveConfigurables: '+attributeKey);
    let productAttributesCopy = this.state.productAttributes;
    for (var group in productAttributesCopy){
      //console.log('group: '+group);
      for (let i = 0; i < productAttributesCopy[group].length; i++) {
        if(attributeKey == productAttributesCopy[group][i].attribute_key) {
          //console.log('i: '+i+' = '+productAttributesCopy[group][i].attribute_key);
          //console.log('old: '+productAttributesCopy[group][i].fields[fieldKey].value);
          const fieldsToSend = productAttributesCopy[group][i].fields;
          const name = productAttributesCopy[group][i].name;
          //console.log(fieldsToSend);
          //console.log(name);
          productAttributesCopy[group][i].saveable = "0";
          //console.log('new: '+productAttributesCopy[group][i].fields[fieldKey].value);
          const data = {
            action: 'update_attribute_settings',
            attribute_key:attributeKey,
            fields:fieldsToSend,
            name:name,
            store_url: storeUrl
          }  
          fetch('/ajax.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          })
          .then(response => response.json())
          .then((json) =>{
            //console.log(json);
            this.setState({productAttributes:productAttributesCopy});
            this.showToast('attributeSaved');
          });           
        }
      }  
    }  
  }
  attributeStatus = (status,attributeKey) => {
    //console.log('attributeStatus s: '+status+' ak: '+attributeKey);
    let productAttributesCopy = this.state.productAttributes;
    for (var group in productAttributesCopy){
      //console.log('group: '+group);
      for (let i = 0; i < productAttributesCopy[group].length; i++) {
        if(attributeKey == productAttributesCopy[group][i].attribute_key) {
          productAttributesCopy[group][i].status = status;
          const data = {
            action: 'update_attribute_status',
            attribute_key:attributeKey,
            status:status,
            store_url: storeUrl
          }  
          fetch('/ajax.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          })
          .then(response => response.json())
          .then((json) =>{
            //console.log(json);
            this.setState({productAttributes:productAttributesCopy});
            if(status == 1){
              this.showToast('attributeEnabled');
            } else {
              this.showToast('attributeDisabled');
            }
          });
        }
      }
    }    
  }
  editBoost = (value,productId,index) => {
    //console.log('editBoost pid: '+productId+' i: '+index+' v: '+value);
    let productsCopy = this.state.products;
    productsCopy[index].saveable = true;
    productsCopy[index].boost = value;
    this.setState({
      products:productsCopy
    });
  }
  saveBoost = (productId,index) => {
    //console.log('saveBoost pid: '+productId+' i: '+index);
    const data = {
      action: 'save_boost',
      product:productId,
      value:this.state.products[index].boost,
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      let productsCopy = this.state.products;
      productsCopy[index].saveable = false;
      this.setState({
        products:productsCopy
      });
      this.setState({products:productsCopy}, () => {
        //console.log('reload with new boost');
        //onChange={(value)=>{this.changeProductsCollectionsChanged(value)}}
        this.getMetricsCollectionProducts();
      });
      this.showToast('boostSaved');
    });
  }
  showOnboardingModal(display) {
    //console.log('showOnboardingModal: '+parseInt(display));
    if(display){
      this.setState({showOnboardingModal:true});
    } else {
      this.setState({showOnboardingModal:false});
    }
  }
  doOnboardingModalClick(section){
    //console.log('doOnboardingModalClick: '+section);
    return;
    this.showOnboardingModal(false);
    if(section == 'metrics'){
      this.setState({activeTab:1}); //xoxo
    }
    if(section == 'collections'){
      this.setState({activeTab:0}); //xoxo
    }
    if(section == 'status'){
      //this.setState({activeTab:1});
      this.statusShowModal(true);
    }
  }
  updateOnboardingModal(){
    //console.log('updateOnboardingModal');
    const data = {
      action: 'update_onboarding_modal',
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      this.setState({
        onboarding_flow:json
      });
    });    
  }
  toggleHelpItem(section,index){
    //console.log('toggleHelpItem');
    let helpItemsOpenCopy = this.state.helpItemsOpen;
    helpItemsOpenCopy[section][index] = !helpItemsOpenCopy[section][index];
    this.setState({
      helpItemsOpen:helpItemsOpenCopy
    });
  }
  displayCollectionIssues(id,index){
    //console.log('displayCollectionIssues: '+id+' / '+index);
    //console.log(this.state.collectionIssues);
    //console.log(this.state.collectionIssues.items);
    //console.log(this.state.collectionIssues.items[index]);
    let currentCollection = {};
    if(this.state.collectionIssues.items[index]){
      currentCollection = this.state.collectionIssues.items[index];
    } else {
      currentCollection = {};
    }
    this.setState({
      displayCollectionIssues:id,
      issueCollectionCurrent:currentCollection,
    },() => {
      this.getCollectionIssuesDetail(id,index);
    });
  }
  getCollectionIssuesDetail(id,index){
    //console.log('getCollectionIssuesDetail: '+id+' / '+index);
    let products = [];
    this.setState({
      singleIssueLoading:true,
    },() => {
      const data = {
        action: 'get_single_collection_issues',
        store_url: storeUrl,
        cid:id,
      }  
      fetch('/ajax.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then(response => response.json())
      .then((json) =>{
        //console.log(json);
        if(json.hasOwnProperty('collection')){
          if(json.collection.hasOwnProperty('products')){
            //console.log('has products');
            //console.log(json.collection.products);
            products = json.collection.products;
          }
        }
        this.setState({
          singleCollectionIssuesProducts:products || [],
          singleCollectionIssuesProductsTotal:json.collection.products_total,
          singleIssueLoading:false,
        });
      });
    })
  }
  getTopCollectionIssues(){
    const issuesMax = 4;
    let issuesDisplayed = 0;
    let issuesCount = 0;
    let topCollectionIssues = [];
    for (let i = 0; i < this.state.collectionIssues.items.length; i++) {
      if(this.state.collectionIssues.items[i].ignored == 0) {
        if(issuesCount < issuesMax){
          topCollectionIssues.push(this.state.collectionIssues.items[i]);
          issuesDisplayed++;
        }
        issuesCount++;
      }
    }
    if(issuesCount > issuesMax){
      let viewAllIssuesObj = {
        collection_id:'all',
        count:this.state.collectionIssues.items.length,
        title:'+'+(this.state.collectionIssues.items.length - issuesMax)+' Additional collection issues',
      };
      topCollectionIssues.push(viewAllIssuesObj);
    }
    return topCollectionIssues;
  }
  getIssueBadges(item){
    let jsx = <Badge>Test</Badge>;
    jsx += <Badge>Test2</Badge>
    let jsx2 = <>{jsx}</>;
    /*
    if(item.hasOwnProperty('critical')){
      if(item.critical.hasOwnProperty('products_sold_out')) {
        jsx += '<Badge status={"critical"}>Sold out items</Badge>' 
      }
      if(item.critical.hasOwnProperty('full_size_run_broken')) {
        jsx += <Badge status={'critical'}>Broken size runs</Badge>;
      }
    } 
    if(item.hasOwnProperty('warning')){
      if(item.warning.hasOwnProperty('low_product_count')) {
        jsx += <Badge status={'warning'}>Low product count</Badge>;
      }
      if(item.warning.hasOwnProperty('low_stock')) {
        jsx += <Badge status={'warning'}>Low quantity items</Badge>;
      }
    } 

    return jsx;
    */
   return jsx2;
  }
  loadCollectionIssues() {
    //disable to test
    if(storeUrl =='us-neweracap.myshopify.com'){
      let x = this.state.collectionIssues;
      x.loaded = true;
      this.setState({
        collectionIssues:x,
      })
      //console.log('reload after fully cached');
      return;
    }
    //console.log('loadCollectionIssues');
    if(this.state.bulkCacheStatus.complete !== true){
      //console.log('reload after fully cached');
      //return;
    }
    let needsAttention = false;
    const data = {
      action: 'get_collection_issues',
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log('loadCollectionIssues json');
      //console.log(json.items);

      if(json.items.length == 0){
        needsAttention = false;
      } else {
        needsAttention = true;
      }

      let collectionIssuesCopy = this.state.collectionIssues;
      collectionIssuesCopy.loaded = true;
      collectionIssuesCopy.items = json.items || [];
      this.setState({
        collectionIssues:collectionIssuesCopy,
        collectionsNeedsAttention:needsAttention,
      });
    });
  }
  getTopIssue(item){
    let topIssue = '';
    if(item.hasOwnProperty('critical')) {
      if(item.critical.hasOwnProperty('products_sold_out')) {
        return 'Sold out items';
      }
      if(item.critical.hasOwnProperty('full_size_run_broken')) {
        return 'Broken size runs';
      }
    } else if(item.hasOwnProperty('warning')){
      if(item.warning.hasOwnProperty('low_product_count')) {
        return 'Low product count';
      }
      if(item.warning.hasOwnProperty('low_stock')) {
        return 'Low quantity items';
      }
    }
    return '';
  }
  toggleIssuesTracking(bool,collectionId,index){
    //console.log('toggleIssuesTracking: '+bool+' / '+collectionId+' / '+index);
    let collectionIssuesCopy = this.state.collectionIssues;
    collectionIssuesCopy.items[index].ignored = bool;
    this.setState({
      collectionIssues:collectionIssuesCopy,
    },() => {
      //console.log(this.state.collectionIssues);
      const data = {
        action: 'update_issues_tracking',
        store_url: storeUrl,
        bool:bool,
        cid:collectionId
      }  
      fetch('/ajax.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then(response => response.json())
      .then((json) =>{
        //console.log(json);
      });
    })
    //this.state.collectionIssues.items
  }

  loadAnalytics() {

    //console.log('loadAnalytics');
    //disable to test
    if(storeUrl =='us-neweracap.myshopify.com'){
      let analyticsCopy = this.state.analytics;
      //set loaded
      analyticsCopy.positionEffectiveness.loaded = true;
      analyticsCopy.risingProducts.loaded = true;

      this.setState({
        analytics:analyticsCopy
      });
      //console.log('reload after fully cached');
      return;
    }
    if(this.state.bulkCacheStatus.complete !== true){
      //console.log('reload after fully cached');
      //return;
    }
    const data = {
      action: 'get_analytics',
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      let analyticsCopy = this.state.analytics;
      //set loaded
      analyticsCopy.positionEffectiveness.loaded = true;
      analyticsCopy.risingProducts.loaded = true;

      analyticsCopy.positionEffectiveness.items = json.position_effectiveness || [];
      analyticsCopy.risingProducts.items = json.rising_products || [];
      this.setState({
        analytics:analyticsCopy
      });
    });
  }
  getSalesVelocity() {
    //console.log('getSalesVelocity');
    if(this.state.bulkCacheStatus.complete !== true){
      //console.log('reload after fully cached');
      //return;
    }
    const data = {
      action: 'get_sales_velocity',
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      const now = new Date();

      //console.log(this.state.graphedObjects);
  
      let salesVelocityChartCopy = this.state.salesVelocityChart;
      let unitSeriesArray = [];
      let volumeSeriesArray = [];
      //let unitSeriesObjectData = [];
      //let volumeSeriesObjectData = [];
      for (var i = 0; i < json.units.length; i++) {
        const daysAgo = (now - (1000 * 60 * 60 * 24 * i));
        const xDate = new Date(daysAgo).setHours(0, 0, 0, 0);
        
        //console.log('unit '+i+' = '+json.units[i]+' daysAgo: '+daysAgo+' xDate: '+xDate);
        unitSeriesArray.push({x:xDate,y:json.units[i]});
      }
      //console.log(unitSeriesArray);
      for (var i = 0; i < json.volume.length; i++) {
        const daysAgo = (now - (1000 * 60 * 60 * 24 * i));
        const xDate = new Date(daysAgo).setHours(0, 0, 0, 0);
        //console.log('volume '+i+' = '+json.volume[i]+' daysAgo: '+daysAgo+' xDate: '+xDate);
        volumeSeriesArray.push({x:xDate,y:json.volume[i]});
      }
      //console.log(volumeSeriesArray);
      salesVelocityChartCopy.series = [
        {
          name:'Units',
          data:unitSeriesArray,
        },
        {
          name:'Volume',
          data:volumeSeriesArray,
        },        
      ];
      let analyticsCopy = this.state.analytics;
      //set loaded
      analyticsCopy.salesVelocity.loaded = true;

      //console.log(salesVelocityChartCopy);
      this.setState({
        salesVelocityChart:salesVelocityChartCopy,
        analytics:analyticsCopy
      },() => {

      })
    });
  }
  openChatWindow() {
    //console.log('openChatWindow');
    //console.log(typeof $crisp);
    window.$crisp.push(["do", "chat:open"])
  }
  openCalendar() {
    //console.log('openChatWindow');
    //console.log(typeof $crisp);
    this.setState({
      calendarOpen:true
    })
  }
  showKBModal(open,title,type,slug){
    let kbModalCopy = this.state.kbModal;
    kbModalCopy = {
      open:open,
      title:title,
      type:type,
      slug:slug,
    };
    this.setState({
      kbModal:kbModalCopy
    });
  }
  getNews() {
    //console.log('get news'); 
    fetch('/news.php', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      this.setState({newsItems:json})
    });    
  }
  viewNews(item){
    //console.log(item);

    this.setState({
      newsItemActive:item,
      newsModalOpen:true,
    });
  }
  showDeleteMetricsModal(id){
    //console.log('showDeleteMetricsModal: '+id);
    //console.log(this.state.metricsBeingEdited);
    const data = {
      action: 'get_metrics_collections',
      store_url: storeUrl,
      id:id
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      this.setState({
        deleteMetricsModalOpen:true,
        deleteMetricsCollectionCount:json.length,
      });
    });
    //
  }
  doDeleteMetricsSet(id) {
    //console.log('doDeleteMetricsSet: '+id);
    const data = {
      action: 'delete_metrics_set',
      store_url: storeUrl,
      id:id
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);

      let metricsCopy = this.state.metrics;
      metricsCopy.createMetricsDisplay = false;
      this.setState({
        deleteMetricsModalOpen:false,
        metrics:metricsCopy,
      },() => {
        this.getMetrics();
        this.getCollections();
      });
    });
  }

  getManagedCollections() {
    //console.log('getManagedCollections'); 
    const data = {
      action: 'get_managed_collections',
      query:this.state.managedFilterQueryValue,
      sort:this.state.popoverFilters.managed.value,
      //active:this.state.popoverFilters.collectionsActive.value,
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      //console.log(json);
      this.setState({
        managedCollections:json.managed_collections,
        //managedPreviewProducts:json.products,
      },()=> {
        //this.getPreviewProducts();
      });
    }).then(()=>{
      //what else?
      //console.log('getCollections() finished');
    });

  }

  createManagedCollection() {
    //console.log('createManagedCollection:');
    this.setState({
      createManagedCollection:true,
      displayManagedCollection:true,
    });
  }
  editManaged = (id,index) => {
    //console.log('editManaged: '+id+' / '+index);

    let managedIndex = false;
    //console.log(this.state.managedCollections);
    for (var i = 0; i < this.state.managedCollections.length; i++) {
      if(this.state.managedCollections[i].id == id){
        //console.log('found it: '+i);
        managedIndex = i;
        //console.log(this.state.managedCollections[managedIndex])
        break;
      }
    }
    if(managedIndex !== false){
      //console.log('should show '+id+' @ '+index);
      //console.log(this.state.managedCollections[managedIndex]);
      let managedBeingEditedCopy = this.state.managedCollections[managedIndex];
      //if()
      //HERES THE PROBLEM, need values
      managedBeingEditedCopy.metaNamespaces = [];
      managedBeingEditedCopy.metaKeys = [];
      for (var i = 0; i < managedBeingEditedCopy.conditions.length; i++) {
        //console.log('condition loop '+i);
        //console.log('condition type '+managedBeingEditedCopy.conditions[i][0]);
        if(managedBeingEditedCopy.conditions[i][0] == 'metafield'){
          //console.log('is metafield');
          managedBeingEditedCopy.metaNamespaces[i] = [{value:'',label:'Select namespace'}];
          for (const key in this.state.metaData) {
            managedBeingEditedCopy.metaNamespaces[i].push({value:key,label:key});
            //console.log('cond? '+managedBeingEditedCopy.conditions[i][3]);
            let metaNMValue = managedBeingEditedCopy.conditions[i][3];
            //console.log('metaNMValue: '+metaNMValue);
            //console.log(this.state.metaData[metaNMValue]);
            managedBeingEditedCopy.metaKeys[i] = [{value:'',label:'Select key'}];
            for (var i2 = 0; i2 < this.state.metaData[metaNMValue].length; i2++) {
              //console.log(this.state.metaData[metaNMValue][i2]);
              //managedBeingEditedCopy.metaKeys[i].push({value:this.state.metaData[metaNMValue][i2],label:this.state.metaData[metaNMValue][i2]})
              managedBeingEditedCopy.metaKeys[i].push({value:this.state.metaData[metaNMValue][i2],label:this.state.metaData[metaNMValue][i2]})
            }          
          }
        }



        /*
        this.state.managedBeingEdited.metaKeys[index] = [{value:'',label:'Select key'}];
        if(this.state.managedBeingEdited.conditions[index][3] != ''){
          //console.log(this.state.managedBeingEdited.conditions[index][3]);
          //keys.push({value:'',label:'Select key'})
          for (var i = 0; i < this.state.metaData[value].length; i++) {
            //console.log(this.state.metaData[value][i]);
            this.state.managedBeingEdited.metaKeys[index].push({value:this.state.metaData[value][i],label:this.state.metaData[value][i]})
          }
        }
        */
      }
      /*
      for (var i = 0; i < defaultConditionObj.length; i++) {
        fuckConditionObject.push(defaultConditionObj[i]);
      }
      managedBeingEditedCopy.conditions.push(fuckConditionObject);
      */
      //console.log(this.state.metaData);
      //managedBeingEditedCopy.metaNamespaces.push({value:'key',label:'key'});
      //for (const key in this.state.metaData) {
        //console.log(key);
        //managedBeingEditedCopy.metaNamespaces[index].push({value:key,label:key});

        //managedBeingEditedCopy.metaNamespaces[index].push({value:key,label:key});
      //}
      this.setState({
        managedBeingEdited:managedBeingEditedCopy,
        createManagedCollection:false,
        displayManagedCollection:true,
        managedPreviewProducts:this.state.managedCollections[managedIndex].products,
        activeTab:2,
      },() => {

      });      
    }
  }
  editManagedObject = (isNew,index=false,key,value) => {
    //console.log('editManagedObject ~ isNew: '+isNew+' index: '+index+' key: '+key+' value: '+value);
    let managedBeingEditedCopy = this.state.managedBeingEdited;
    //console.log(metricsBeingEditedCopy);
    let saveBarCopy = this.state.saveBar;
    saveBarCopy.show = true;
    saveBarCopy.context = 'managed';
    managedBeingEditedCopy[key] = value;
    //metricsBeingEditedCopy.is_default = true;

    //console.log(metricsBeingEditedCopy);
    this.setState({
      managedBeingEdited:managedBeingEditedCopy,
      saveBar:saveBarCopy
    }, () => {
      //console.log(this.state.metricsBeingEdited);
      //this.getMetricsPreviewProducts();
    });
  }
  addManagedCondition() {
    //console.log('addManagedCondition');
    let managedBeingEditedCopy = this.state.managedBeingEdited;
    let fuckConditionObject = [];

    let saveBarCopy = this.state.saveBar;
    saveBarCopy.show = true;
    saveBarCopy.context = 'managed';

    for (var i = 0; i < defaultConditionObj.length; i++) {
      fuckConditionObject.push(defaultConditionObj[i]);
    }
    managedBeingEditedCopy.conditions.push(fuckConditionObject);
    this.setState({
      managedBeingEdited:managedBeingEditedCopy,
      saveBar:saveBarCopy,
    });
  }

  changeConditionType = (value,index) => {
    //console.log('changeConditionType: '+value+' / '+index);
    let managedBeingEditedCopy = this.state.managedBeingEdited;
    managedBeingEditedCopy.conditions[index][0] = value;
    //console.log(managedBeingEditedCopy.conditions);

    let saveBarCopy = this.state.saveBar;
    saveBarCopy.show = true;
    saveBarCopy.context = 'managed';

    for (var i = 0; i < conditions.length; i++) {
      if(conditions[i].value == value){
        //console.log(conditions[i]);
        //console.log(conditions[i].boolean);
        managedBeingEditedCopy.conditions[index][1] = conditions[i].boolean;
        managedBeingEditedCopy.conditions[index][2] = conditionBoolean[conditions[i].boolean][0].value;
        managedBeingEditedCopy.conditions[index][3] = conditions[i].defaults[0];
        managedBeingEditedCopy.conditions[index][4] = conditions[i].defaults[1];
      }
    }
    if(value == 'metafield'){
      //console.log('do metafield namespaces here1');
      managedBeingEditedCopy.metaNamespaces[index] = [];
      managedBeingEditedCopy.metaNamespaces[index] = [{value:'',label:'Select namespace'}];
      //console.log('do metafield namespaces here2');
      managedBeingEditedCopy.metaKeys[index] = [];
      managedBeingEditedCopy.metaKeys[index] = [{value:'',label:'Select key'}];
      //console.log('do metafield namespaces here3');
      //console.log('state meta data');
      //console.log(this.state.metaData);
      for (const key in this.state.metaData) {
        //console.log(key);
        managedBeingEditedCopy.metaNamespaces[index].push({value:key,label:key});
      }
    }
    this.setState({
      managedBeingEdited:managedBeingEditedCopy,
      saveBar:saveBarCopy
    });
  }
  changeConditionBoolean(value,index) {
    //console.log('changeConditionBoolean: '+value+' / '+index);
    let managedBeingEditedCopy = this.state.managedBeingEdited;
    managedBeingEditedCopy.conditions[index][2] = value;

    let saveBarCopy = this.state.saveBar;
    saveBarCopy.show = true;
    saveBarCopy.context = 'managed';

    this.setState({
      managedBeingEdited:managedBeingEditedCopy,
      saveBar:saveBarCopy
    });
  }
  changeConditionValue = (value,index,position) => {
    //console.log('changeConditionValue: '+value+' / '+index+'/ '+position);
    let managedBeingEditedCopy = this.state.managedBeingEdited;
    managedBeingEditedCopy.conditions[index][position] = value;
    //console.log(managedBeingEditedCopy.conditions[index]);

    let saveBarCopy = this.state.saveBar;
    saveBarCopy.show = true;
    saveBarCopy.context = 'managed';

    if(
      position == 3
      &&
      managedBeingEditedCopy.conditions[index][1] == 'metafield'
    ) {
      //console.log('populate metaKeys here');
      //let metaKeys = [];
      this.state.managedBeingEdited.metaKeys[index] = [{value:'',label:'Select key'}];
      if(this.state.managedBeingEdited.conditions[index][3] != ''){
        //console.log(this.state.managedBeingEdited.conditions[index][3]);
        //keys.push({value:'',label:'Select key'})
        for (var i = 0; i < this.state.metaData[value].length; i++) {
          //console.log(this.state.metaData[value][i]);
          this.state.managedBeingEdited.metaKeys[index].push({value:this.state.metaData[value][i],label:this.state.metaData[value][i]})
        }
      }
    } 


    this.setState({
      managedBeingEdited:managedBeingEditedCopy,
      saveBar:saveBarCopy
    });
  }
  removeManagedCondition(index){
    //console.log('removeManagedCondition: '+index);

    let saveBarCopy = this.state.saveBar;
    saveBarCopy.show = true;
    saveBarCopy.context = 'managed';
    let managedBeingEditedCopy = this.state.managedBeingEdited;
    managedBeingEditedCopy.conditions.splice(index, 1);
    
    this.setState({
      managedBeingEdited:managedBeingEditedCopy,
    })

  }
  showDeleteManagedModal(id){
    //console.log('showDeleteManagedModal');
    this.setState({
      deleteManagedModalOpen:true,
    })
  }
  doDeleteManaged(id){
    //console.log('doDeleteManaged: '+id);
    const data = {
      action: 'delete_managed_collection',
      id:id,
      store_url: storeUrl
    }  
    fetch('/ajax.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) =>{
      let saveBarCopy = this.state.saveBar;
      saveBarCopy.discardDisabled = false;
      saveBarCopy.saveLoading = false;
      saveBarCopy.show = false;
      this.setState({
        saveBar:saveBarCopy,
        deleteManagedModalOpen:false,
        createManagedCollection:false,
        displayManagedCollection:false,
        managedBeingEdited:blankManagedBeingEdited,
      });
    }).then(()=>{
      this.getManagedCollections();
      this.showToast('managedDeleted');
    }); 
  }
  doSaveManaged(){
    //console.log('doSaveManaged');
    //console.log(this.state.metricsBeingEdited);
    //wade here
    let saveBarCopy = this.state.saveBar;
    saveBarCopy.discardDisabled = true;
    saveBarCopy.saveLoading = true;

    this.setState({
      saveBar:saveBarCopy
    }, () => {
      const data = {
        action: 'save_managed',
        managed:this.state.managedBeingEdited,
        store_url: storeUrl
      }  
      fetch('/ajax.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      .then(response => response.json())
      .then((json) =>{
        //console.log(json);
        let saveBarCopy = this.state.saveBar;
        saveBarCopy.discardDisabled = false;
        saveBarCopy.saveLoading = false;
        saveBarCopy.show = false;
        //console.log('typeof json.new_collection: '+json.new_collection);
        let managedBeingEditedCopy = this.state.managedBeingEdited;
        if(typeof(json.new_collection) == 'object'){
          //console.log('new!');
          managedBeingEditedCopy.id = json.new_collection.id;
        }
        this.setState({
          managedPreviewProducts:json.products,
          saveBar:saveBarCopy,
          managedBeingEdited:managedBeingEditedCopy,
        });
      }).then(()=>{
        this.getManagedCollections();
        this.showToast('managedSaved');
        this.getCollections();
        /*
        this.getMetrics();
        this.getCollections();
        this.updateOnboardingModal();
        this.showToast('metricsSaved');
        */
        //what else?
        //console.log(this.state.metricsBeingEdited);
      }); 
    });
  }
  

  render() {

    const activatorViewOptions = (
      <Button onClick={() => this.toggleViewOptions()} disclosure>
        View Options
      </Button>
    );
    return (
      <AppProvider i18n={enTranslations}>
        <Frame>
          {/* resorting */}
          {
            this.state.resortingToastShow ? <Toast content="Syncing Collection" onDismiss={() => {this.hideResortingToast()}} />:''
          }
          {
            this.state.resortedToastShow ? <Toast content="Collection Synced" onDismiss={() => {this.hideResortedToast()}} />:''
          }
          {/* single collection */}
          {
            this.state.toasts.collectionEnabled.show ? <Toast content="Collection Enabled" onDismiss={() => {this.hideToast('collectionEnabled')}} />:''
          }
          {
            this.state.toasts.collectionDisabled.show ? <Toast content="Collection Disabled" onDismiss={() => {this.hideToast('collectionDisabled')}} />:''
          }
          {
            this.state.toasts.collectionDetailsChanged.show ? <Toast content="Collection Details Changed" onDismiss={() => {this.hideToast('collectionDetailsChanged')}} />:''
          }
          {/* bulk collections */}
          {
            this.state.toasts.collectionsBulkEnabled.show ? <Toast content="Collections Enabled" onDismiss={() => {this.hideToast('collectionsBulkEnabled')}} />:''
          }
          {
            this.state.toasts.collectionsBulkDisabled.show ? <Toast content="Collections Disabled" onDismiss={() => {this.hideToast('collectionsBulkDisabled')}} />:''
          }
          {
            this.state.toasts.collectionsBulkChanged.show ? <Toast content="Collections Details Changed" onDismiss={() => {this.hideToast('collectionsBulkChanged')}} />:''
          }
          {/* metrics */}
          {
            this.state.toasts.metricsSaved.show ? <Toast content="Metrics Saved" onDismiss={() => {this.hideToast('metricsSaved')}} />:''
          }
          {
            this.state.toasts.metricsReverted.show ? <Toast content="Metrics Reverted" onDismiss={() => {this.hideToast('metricsReverted')}} />:''
          }
          {/* attributes */}
          {
            this.state.toasts.attributeEnabled.show ? <Toast content="Attribute Activated" onDismiss={() => {this.hideToast('attributeEnabled')}} />:''
          }
          {
            this.state.toasts.attributeDisabled.show ? <Toast content="Attribute Deactivated" onDismiss={() => {this.hideToast('attributeDisabled')}} />:''
          }
          {
            this.state.toasts.attributeSaved.show ? <Toast content="Attribute Saved" onDismiss={() => {this.hideToast('attributeSaved')}} />:''
          }
          {/* boost */}
          {
            this.state.toasts.boostSaved.show ? <Toast content="Boost Saved" onDismiss={() => {this.hideToast('boostSaved')}} />:''
          }
          {/* settings */}
          {
            this.state.toasts.settingsSaved.show ? <Toast content="Settings Saved" onDismiss={() => {this.hideToast('settingsSaved')}} />:''
          }
          {/* status */}
          {
            this.state.toasts.status.show ? <Toast content={this.state.toasts.status.content} onDismiss={() => {this.hideToast('status')}} />:''
          }
          {/* managed */}
          {
            this.state.toasts.managedSaved.show ? <Toast content={"Managed Collection Saved"} onDismiss={() => {this.hideToast('managedSaved')}} />:''
          }
          {
            this.state.toasts.managedDeleted.show ? <Toast content={"Managed Collection Deleted"} onDismiss={() => {this.hideToast('managedDeleted')}} />:''
          }



          <Modal
              //activator={activator}
              className="onboarding-modal"
              open={(
                (
                  (
                  this.state.showOnboardingModal 
                  && 
                  this.state.init.show_plans == false 
                  //&&
                  //this.state.init.cache_v2 != "1"
                  //</Frame>&&
                  //1 == 2
                  )
                )? true:false)}
              onClose={()=>{this.showOnboardingModal(false)}}
              //title={"Confirm Status Change"}
              //large
          > 
            <div className='onboarding-modal-content'>
              <div className='onboarding-modal-half content'>
                <div className='onboarding-welcome'>
                  <h4>Welcome to Dynasort!</h4>
                  <p>Let us help you get started</p>
                  <p class="video-cta"><Link monochrome onClick={() => this.watchVideo('quick-start')}><Icon source={PlayCircleMajor} color="base" /> Watch Quick Start Video</Link></p>
                </div>
                <div className='onboarding-modal-quickstart'>
                  <div className={'onboarding-modal-item'}>
                    <span className={''}></span>
                    <h5>Review Metrics</h5>
                    <p>See the Metrics Tab</p>
                  </div>
                  <div className={'onboarding-modal-item'}>
                    <span className={''}></span>
                    <h5>Enable a Collection</h5>
                    <p>In the Collections tab</p>
                  </div>
                  <div className={'onboarding-modal-item'}>
                    <span className={''}></span>
                    <h5>Turn Dynasort On</h5>
                    <p>Top right, next to "Status"</p>
                  </div>
                  <div className='onboarding-modal-footer'>
                    <Link onClick={() => {this.showOnboardingModal(false);this.setState({activeTab:8})}}>See Quickstart Guide</Link>
                  </div>
                </div>
              </div>  
              <div className='onboarding-modal-half image'>
              </div>
            </div>             
          </Modal>
          <Modal
              //activator={activator}
              open={this.state.showVideoModal}
              onClose={()=>{this.closeVideoModal()}}
              title={this.state.videoModalTitle}
              //large
          > 
            <div className='modal-video-container'>
              <iframe 
              src={"https://www.youtube.com/embed/"+this.state.videoUrl+"?autoplay=1&modestbranding=1&rel=0"}
              title="YouTube video player" 
              frameborder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowfullscreen
              ></iframe>
            </div>
          </Modal>
          <div className={"save-bar "+((this.state.saveBar.show)? 'show':'hide')}>
          </div>
          {
            ((this.state.saveBar.show)? 
              <ContextualSaveBar
                message="Unsaved changes"
                saveAction={{
                  onAction: () => {this.doSaveAction()},
                  loading: this.state.saveBar.saveLoading,
                  disabled: false,
                }}
                discardAction={{
                  onAction: () => (this.doDiscardAction()),
                  loading: false,
                  disabled: this.state.saveBar.discardDisabled,
                }}
                alignContentFlush
                fullWidth
              />
            :'')
          }
            
          <div className={"interface "+(!hasRunInit? 'loading':'not-loading')}>
            <div className={"tabbed-navigation "+((this.state.init.show_tabs && this.state.init.show_plans == false)? 'show':'hide')}>
              <Tabs 
                tabs={this.state.tabs}
                selected={this.state.activeTab}
                onSelect={this.handleNavTabChange}
              ></Tabs>
              <div class={'getting-started '+((this.state.onboarding_flow.onboarding_steps.complete || this.state.init.cache_v2 == "1")  ? 'hide':'show')} onClick={() => this.showOnboardingModal(true)}>Getting Started</div>
              {(
                this.state.init.cache_v2 == "1" //lose this
                &&
                this.state.bulkCacheStatus.complete == false //keep this
                )?
                <div class="nav-status">
                  <span className='status-text'>Status:</span>
                  <Badge status='attention'>Caching Shopify Data</Badge>
                  <Spinner size='small' />
                </div>
                :
                <div class="nav-status" onClick={() => this.statusShowModal(true)}>
                  <span className='status-text'>Status:</span>
                  <Badge
                    status={(this.state.status == "On"? "success":"")}
                  >{this.state.status}</Badge>
                    <div className={"inline-status-time "+(this.state.isSortingCollections? 'sorting-active':'')}>
                      <Icon source={ClockMajor} color="base" />
                      <div className="status-time-hover">
                        <div className='next'><span>Next Sort:</span>{this.state.sortingCollectionsNext}</div>
                        <div className='last'><span>Last Sorted:</span>{this.state.sortingCollectionsLast}</div>
                        <div className='current'>Sorting Collections Now</div>
                      </div>
                    </div>
                </div>
              }
              <Modal
                  //activator={activator}
                  open={(this.state.statusModalOpen? true:false)}
                  onClose={()=>{this.statusShowModal(false)}}
                  title={(this.state.firstCollectionEnabled ? "Ready to Turn It On?":"Confirm Status Change")}
                  small={(this.state.firstCollectionEnabled?false:true)}
                  //small
                > 
                <div className='modal-content'>
                  {(
                    this.state.firstCollectionEnabled?
                    <Banner
                      status='success'
                      title='Success! You have enabled a collection'
                    >
                      <p>Are you ready to turn Dynasort on now and sort {this.state.firstCollectionEnabledObject.name}?</p>
                    </Banner>
                    :
                    ''
                  )}
                  <p>Turning Dynasort status {(this.state.status == "On"? "off":"on")} will {(this.state.status == "On"? "disable":"enable")} collections sorting for enabled collections.</p>
                  <div className={"settings-save-container"}>
                    <Button primary onClick={() => { this.toggleStatus()}}>Turn {(this.state.status == "On"? "Off":"On")}</Button>
                    <Button onClick={() => { this.statusShowModal(false)}}>Cancel</Button>
                  </div>   
                </div>             
              </Modal>
            </div>
            <Layout>
              <div className={"iec-tabbed-content-container collection-content-container"+(!hasRunInit? ' loading ':' not-loading')}>
                {/* v2 cache status below */}
                {(
                  this.state.init.cache_v2 == "1" //lost this too
                  &&
                  this.state.init.cache_v2_complete == "0" //lose this
                  &&
                  this.state.init.show_plans == false
                )?
                <Collapsible
                  open={this.state.bulkCacheStatus.showBanner}
                  id="caching-collapsible"
                  transition={{duration: '500ms', timingFunction: 'ease-in-out'}}
                  expandOnPrint
                >
                  {/*<div className={" "+(this.state.bulkCacheStatus.showBanner? 'onboarding-status show':'onboarding-status hide')}>*/}
                  <div className={" "+(this.state.bulkCacheStatus.showBanner? 'onboarding-status show':'onboarding-status show')}>
                    <div className={"cache-status"}>
                      <Layout.Section>
                        <Page>
                          <Banner
                            title="Caching Store Data"
                            status={this.state.bulkCacheStatus.bannerStatus}
                            onDismiss={(this.state.bulkCacheStatus.bannerDismissable)? () => {this.dismissBulkBanner()}:false}
                          >
                            {(this.state.bulkCacheStatus.complete)?
                            <p>Caching complete. You're ready to go.</p>
                            :
                            <p>Based on your store's data, this should take {this.state.bulkCacheStatus.timeRequired} minutes.</p>
                            }
                            <ol>
                              {/*
                              <li className="cache-v2-progress-item">
                                <Spinner size='small' />
                                <span class="check"><Badge status='success'>Complete</Badge></span>
                                <span className="copy">Gathering Shopify Stats</span>
                              </li>
                              */}
                              <li className={"cache-v2-progress-item "+(this.state.bulkCacheStatus.bulkStatuses.collections.class)}>
                                <span class="check"><Badge progress={this.state.bulkCacheStatus.bulkStatuses.collections.progress} status={this.state.bulkCacheStatus.bulkStatuses.collections.status}>{this.state.bulkCacheStatus.bulkStatuses.collections.badgeLabel}</Badge></span>
                                <span className="count">{this.state.bulkCacheStatus.bulkStatuses.collections.count}</span>
                                <span className="copy">Collection{(parseInt(this.state.bulkCacheStatus.bulkStatuses.collections.count.replace(',','')) == 1 ? '':'s')}</span>
                                <Spinner size='small' />
                              </li>
                              <li className={"cache-v2-progress-item "+(this.state.bulkCacheStatus.bulkStatuses.products.class)}>
                                <span class="check"><Badge progress={this.state.bulkCacheStatus.bulkStatuses.products.progress} status={this.state.bulkCacheStatus.bulkStatuses.products.status}>{this.state.bulkCacheStatus.bulkStatuses.products.badgeLabel}</Badge></span>
                                <span className="count">{this.state.bulkCacheStatus.bulkStatuses.products.count}</span>
                                <span className="copy">Product{(parseInt(this.state.bulkCacheStatus.bulkStatuses.products.count.replace(',','')) == 1 ? '':'s')}</span>
                                <Spinner size='small' />
                              </li>
                              <li className={"cache-v2-progress-item "+(this.state.bulkCacheStatus.bulkStatuses.orders.class)}>
                                <span class="check"><Badge progress={this.state.bulkCacheStatus.bulkStatuses.orders.progress} status={this.state.bulkCacheStatus.bulkStatuses.orders.status}>{this.state.bulkCacheStatus.bulkStatuses.orders.badgeLabel}</Badge></span>
                                <span className="count">{this.state.bulkCacheStatus.bulkStatuses.orders.count}</span>
                                <span className="copy">Order{(parseInt(this.state.bulkCacheStatus.bulkStatuses.orders.count.replace(',','')) == 1 ? '':'s')}</span>
                                <Spinner size='small' />
                              </li>
                            </ol>
                          </Banner>
                        </Page>
                      </Layout.Section>
                    </div>
                  </div>
                </Collapsible>
                  :
                  ''
                }                
                {/* v2 cache status above */}
                {/* remove when v2 complete 
                <div className={"onboarding-status "+((this.state.showOnboarding) ? 'show':'hide')}>
                  <div className={"cache-status "+((this.state.showCacheStatus && this.state.init.show_plans == false && this.state.init.cache_v2 != "1") ? 'show':'hide')}>
                    <Layout.Section>
                      <Page>
                        <Banner
                          title="Caching Store Data"
                          status="info"
                        >
                          <p>Dynasort is busy caching your shop's data, this will only take a few moments.</p>
                          <ul>
                            <li><span class="cache-label">Products Cached</span><span class="cache-status">{this.state.cacheStatus.products_cached}<span>/</span>{this.state.cacheStatus.products_total}</span></li>
                            <li><span class="cache-label">Orders Cached</span><span class="cache-status">{this.state.cacheStatus.orders_cached}<span>/</span>{this.state.cacheStatus.orders_total}</span></li>
                            <li><span class="cache-label">Collections Cached</span><span class="cache-status">{this.state.cacheStatus.collections_cached}<span>/</span>{this.state.cacheStatus.collections_total}</span></li>
                          </ul>
                        </Banner>
                      </Page>
                    </Layout.Section>
                  </div>
                </div>
                */}
                {/* remove when v2 complete */}

                <div className={"iec-tabbed-content "+((this.state.activeTab == 1) ? ' show ':' hide ')}>
                  <Layout.Section>
                    <Page
                      title={'Collection Sorting'}
                    >
                      <div className="top-card-padding">
                        <Card>
                          <Card.Section>
                            <Tabs 
                              tabs={this.state.collectionsTabs} 
                              selected={this.state.activeCollectionsTab} 
                              onSelect={this.handleCollectionsNavChange}
                              fitted={false}
                            >
                            </Tabs> 
                            <div className='collection-count-status'>
                              {this.state.collectionsResourceItemEnabled }/{this.state.init.permissions.collections} Enabled
                              <div className="inline-tooltip-container">
                                <Tooltip content={this.state.init.current_plan + " Plan allows for "+this.state.init.permissions.collections+" enabled collections"}>
                                  <Icon source={QuestionMarkMajor} color="base" />
                                </Tooltip>
                              </div>
                            </div>
                          </Card.Section>   
                          <Card.Section>
                            <ResourceList
                              resourceName={{singular: 'collection', plural: 'collections'}}
                              items={this.getCollectionResourceItems(this.state.collectionsResourceItemsPage || []) || []}
                              totalItemsCount={this.state.collectionsResourceItems.length}

                              emptyState={
                                (
                                 !this.state.collectionsResourceItems.length
                                 &&
                                 !this.state.bulkCacheStatus.bulkStatuses.collections.complete 
                                )?
                                  <EmptyState 
                                  heading="Collections Are Caching"
                                  >
                                  <Icon
                                    source={CollectionsMajor}
                                    color="base"
                                  />
                                    <p>Once your collections are cached they will display here.</p>
                                  </EmptyState>
                                :
                                (
                                  !this.state.collectionsResourceItems.length
                                  &&
                                  this.state.bulkCacheStatus.bulkStatuses.collections.complete
                                )?
                                <EmptyState 
                                heading="No Collections Found"
                                >
                                  <Icon
                                    source={CollectionsMajor}
                                    color="base"
                                  />
                                  <p>Once collections are added in Shopify they will display here.</p>
                                  <p><Link url={storeUrl+'/admin/collections/new/'} external>Add A Collection</Link></p>
                                </EmptyState>
                                :
                                undefined
                              }

                              filterControl={(
                                <div className="collections-header-container">
                                  <Filters
                                    queryValue={this.state.collectionFilterQueryValue}
                                    filters={this.state.collectionsFilters}
                                    //appliedFilters={appliedFilters}
                                    onQueryChange={(value) => {this.collectionFilterChangeQueryValue(value)}}
                                    onQueryClear={() => {this.collectionFilterChangeQueryValue('')}}
                                    //onClearAll={() => console.log('Todo: implement onClearAll')}
                                  >
                                    <div className="sort-popover-container" style={{paddingLeft: '8px'}}>
                                      
                                      <Button onClick={() => {this.togglePopover('collections')}}><Icon source={SortMinor} color="base" />Sort</Button>
                                      <div className={"sort-popover "+(this.state.popoverFilters.collections.show? 'show':'hide')}>
                                        <ChoiceList
                                          //title="Company name"
                                          choices={[
                                            {label: 'Title A-Z', value: 'name-asc'},
                                            {label: 'Title Z-A', value: 'name-desc'},
                                            {label: 'Date (Newest first)', value: 'date-asc'},
                                            {label: 'Date (Oldest first)', value: 'date-desc'},
                                            {label: 'Products (Most first)', value: 'count-asc'},
                                            {label: 'Products (Least first)', value: 'count-desc'},
                                          ]}
                                          selected={this.state.popoverFilters.collections.value}
                                          onChange={(value) => {this.changePopover(value,'collections')}}
                                        />
                                        <div className='hr' />
                                        <ChoiceList
                                          //title="Company name"
                                          choices={[
                                            {label: 'All', value: 'all'},
                                            {label: 'Active', value: 'active'},
                                            {label: 'Inactive', value: 'inactive'},
                                          ]}
                                          selected={this.state.popoverFilters.collectionsActive.value}
                                          onChange={(value) => {this.changePopover(value,'collectionsActive')}}
                                        />
                                      </div>
                                    </div>
                                  </Filters>
                                  <div className="resource-list-headings">
                                    <div className="resource-list-heading-item rlhi-0">
                                      <Checkbox 
                                        checked={this.state.collectionsAllCheckboxSelected}
                                        //checked={() => {this.isCollectionsAllChecked()}}
                                        onChange={() => {this.collectionsAllCheckboxToggle(!this.state.collectionsAllCheckboxSelected)}}
                                      />
                                    </div>
                                    <div className="resource-list-heading-item rlhi-1">
                                      <h3>Title</h3>
                                    </div>
                                    <div className="resource-list-heading-item rlhi-2">
                                      <h3>Products</h3>
                                    </div>
                                    <div className="resource-list-heading-item rlhi-3">
                                      <h3>Metrics</h3>
                                    </div>
                                    <div className="resource-list-heading-item rlhi-4">
                                      <h3>Status</h3>
                                    </div>
                                    <div className="resource-list-heading-item rlhi-5">
                                      <h3></h3>
                                    </div>
                                    <div className="resource-list-heading-item rlhi-6">
                                      <h3></h3>
                                    </div>
                            
                                    <div class={"resource-list-button-group "+(this.state.collectionsSelectedItems.length > 0 ? '':' hide ')+(this.state.collectionsResourceItems.length == this.state.collectionsSelectedItems.length ? ' all-selected ':' not-all-selected ' )}>
                                      <ButtonGroup segmented>                            
                                        <Button onClick={() => {this.uncheckAllCollectionsResourceItems()}}>{this.state.collectionsSelectedItems.length} Selected</Button>
                                        <Button 
                                          onClick={() => {this.collectionsBulkToggle(true)}}
                                          disabled={
                                            (
                                              (this.state.collectionsResourceItemEnabled + this.state.collectionsSelectedItems.length) > this.state.init.permissions.collections ? true:false
                                              ||
                                              !this.state.bulkCacheStatus.complete
                                            )
                                          }
                                          //disabled={true}
                                        >Enable Collections</Button>
                                        <Button onClick={() => {this.collectionsBulkToggle(false)}}>Disable Collections</Button>
                                        <Button onClick={() => {this.collectionsBulkEdit(true)}}>Edit Details</Button>
                                      </ButtonGroup>
                                      <Button plain onClick={() => this.collectionsToggleCheckAll(true)}>Select All {this.state.collectionsResourceItems.length} Collections</Button>
                                      <span>All {this.state.collectionsResourceItems.length} Collections Selected</span>
                                      <Button plain onClick={() => this.collectionsToggleCheckAll(false)}>Undo</Button>
                                      {/*
                                      <span className='resource-list-num-selected'>
                                      {this.state.collectionsSelectedItems.length} Selected
                                      </span>
                                      */}
                                    </div>
                                  </div>
                                </div>

                              )}
                              /*
                              promotedBulkActions={[
                                {
                                  content: 'Enable collections',
                                  onAction: () => console.log('Todo: implement bulk collection enable'),
                                },
                                {
                                  content: 'Disable collections',
                                  onAction: () => console.log('Todo: implement bulk collection disable'),
                                },
                              ]}
                              */
                              //selectedItems={selectedItems}
                              //onSelectionChange={this.setCollectionsSelectedItems}
                              //selectedItems={this.state.collectionsSelectedItems}
                              renderItem={(item,id,index) => {
                                const {
                                  name, 
                                  handle,
                                  url,
                                  productCount,
                                  metricId,
                                  metricName,
                                  lastSorted,
                                  enabled,
                                  checked,
                                  isSorting,
                                  managed,
                                  //shortcutActions,
                                } = item;
                                let collectionShortcutActions = [];
                                if(enabled == "0"){
                                  if(this.state.collectionsResourceItemEnabled >= this.state.init.permissions.collections){
                                    //nothing, maxed out
                                  } else {
                                    collectionShortcutActions.push({content:'Enable',onAction:(e)=>{this.setCollectionStatus(id,index,"1")}})
                                  }
                                } else {
                                  collectionShortcutActions.push({content:'Disable',onAction:(e)=>{this.setCollectionStatus(id,index,"0")}})
                                }
                                collectionShortcutActions.push({content:'Edit details',onAction:(e) => this.collectionDetailsModal(id,index,true)})
                                //collectionShortcutActions.push({content:'View Collection',onAction:(e) => window.open('https://'+storeUrl+'/admin/collections/'+id, '_blank')})
                                if(
                                  storeUrl == 'dynasort.myshopify.com'
                                  &&
                                  enabled == "1"
                                ){
                                  //collectionShortcutActions.push({content:'Re-sort Collection',onAction:(e) => {this.resortCollection(id)}})
                                }
                                return (
                                  <ResourceItem
                                    id={id}
                                    //url={url}
                                    //media={media}
                                    accessibilityLabel={`View details for ${name}`}
                                    //shortcutActions={collectionShortcutActions}
                                    //persistActions
                                    
                                    //className={"url-resource-item "+((enable) ? 'url-resource-item-disabled':'')}
                                  >
                                    <div className="resource-item-col collection-resource-item-col collection-resource-item-col-0">
                                      <Checkbox 
                                        checked={checked}
                                        onChange={() => {console.log(item);console.log(index);this.selectCollectionItem(item,index,checked)}}
                                      />
                                    </div>
                                    <div 
                                      className="resource-item-col collection-resource-item-col collection-resource-item-col-1"
                                      //onClick={(e)=>{this.collectionDetailsModal(id,index,true)}}
                                      >
                                      <h3 
                                      //onClick={(e)=>{this.collectionDetailsModal(id,index,true)}}
                                      >
                                        <Link monochrome url={'https://'+storeUrl+'/admin/collections/'+id} external>
                                          <TextStyle variation="strong">{name}</TextStyle>
                                        </Link>
                                      </h3>
                                      <div class="resource-item-col-bottom">
                                        <Link monochrome url={'https://'+storeUrl+'/admin/collections/'+id} external>{handle}</Link>
                                      </div>
                                    </div>
                                    <div className="resource-item-col collection-resource-item-col collection-resource-item-col-2" 
                                    //onClick={(e)=>{this.collectionDetailsModal(id,index,true)}}
                                    >
                                      <h3>
                                        <TextStyle variation="strong">{productCount} Products</TextStyle> {parseInt(managed) == 1 ? <Link onClick={() => this.editManaged(id,id)}><Badge status="info" small>Managed</Badge></Link>:''}
                                      </h3>
                                      <div class="resource-item-col-bottom">
                                        <Button 
                                          plain
                                          monochrome
                                          onClick={() => {this.viewSorting(metricId,id)}}
                                        >View sorting</Button>
                                        
                                      </div>
                                    </div>
                                    <div className="resource-item-col collection-resource-item-col collection-resource-item-col-3" 
                                    onClick={(e)=>{this.collectionDetailsModal(id,index,true)}}>
                                      <h3>
                                        <TextStyle variation="strong">{metricName}</TextStyle>
                                      </h3>
                                      <div class="resource-item-col-bottom">
                                        {(
                                          isSorting || !this.state.bulkCacheStatus.complete?
                                          <Spinner size='small' />
                                          :
                                          ''
                                        )}
                                        <span>{(!this.state.bulkCacheStatus.complete? 'caching data':lastSorted)}</span>
                                      </div>
                                    </div>
                                    <div className="resource-item-col collection-resource-item-col collection-resource-item-col-4">
                                      {enabled == "1"? <Badge status="success">On</Badge>:<Badge>Off</Badge>}
                                    </div>
                                    <div className="resource-item-col collection-resource-item-col collection-resource-item-col-5">
                                    {
                                      enabled == "1" ? 
                                      <Button
                                      plain
                                      destructive
                                      onClick={(e)=>{this.setCollectionStatus(id,index,"0")}}
                                      disabled={(isSorting)}
                                      >Disable</Button>
                                      :
                                      (
                                        enabled == "0"
                                        &&
                                        this.state.collectionsResourceItemEnabled >= this.state.init.permissions.collections
                                      )
                                      ? 
                                      <Button
                                      plain
                                      disabled
                                      //onClick={(e)=>{this.setCollectionStatus(id,index,"1")}}
                                      >Enable</Button>
                                      :
                                      <Button
                                      plain
                                      primary
                                      onClick={(e)=>{this.setCollectionStatus(id,index,"1")}}
                                      disabled={(isSorting || !this.state.bulkCacheStatus.complete)}
                                      >Enable</Button> 
                                    }
   
                                    </div>
                                    <div className="resource-item-col collection-resource-item-col collection-resource-item-col-6">
                                      <Button
                                        slim
                                        plain
                                        onClick={(e) => this.collectionDetailsModal(id,index,true)}
                                        >Change</Button>
                                    </div>
                                    
                                  </ResourceItem>
                                );
                              }}
                            />
                            <div className='pagination-container'>
                              <Pagination
                                hasNext={
                                  (
                                    (this.state.collectionsResourceItemsPage < (this.state.collectionsResourceItemsPages - 1))
                                    &&
                                    (this.state.collectionsResourceItemsPages > 1)
                                  )
                                  ? true:false}
                                hasPrevious={
                                  (
                                    (this.state.collectionsResourceItemsPage > 0)
                                    &&
                                    (this.state.collectionsResourceItemsPages > 1)
                                  )
                                  ? true:false}
                                onNext={() => {
                                  //console.log('page: '+this.state.collectionsResourceItemsPage + ' Pages: '+this.state.collectionsResourceItemsPages );
                                  this.collectionResourcePage(1);
                                }}
                                onPrevious={() => {
                                  //console.log('page: '+this.state.collectionsResourceItemsPage + ' Pages: '+this.state.collectionsResourceItemsPages );
                                  this.collectionResourcePage(-1);
                                }}
                              />
                            </div>
                          </Card.Section>                
                        </Card>
                      </div>
                    </Page>
                  </Layout.Section>
                  <Modal
                    //activator={activator}
                    open={this.state.collectionBeingEditedModal}
                    onClose={()=>{this.collectionDetailsModal(0,0,false)}}
                    title={"Change metrics for \""+this.state.collectionBeingEdited.name+"\""}
                  >
                    <div className='modal-content'>
                      <p>
                        Select which metric set you'd like to apply to this collection.
                      </p>
                      <FormLayout>
                        <Select 
                          label="Metrics Selected"
                          options={this.state.metricsResourceItems.map(function(item, i){
                            return {label:item.name,value:item.id}
                          })}
                          value={this.state.collectionBeingEdited.metricId}
                          onChange={(value)=>{this.metricsChangeCollection(value,this.state.collectionBeingEdited,'metricId')}}
                        />
                        <Select 
                          label="Revert To (When Off)"
                          options={revertToSelectOptions}
                          value={this.state.collectionBeingEdited.revertSorting}
                          onChange={(value,item,i)=>{this.metricsChangeCollection(value,this.state.collectionBeingEdited,'revertSorting')}}
                        />
                      </FormLayout>
                    </div>
                  </Modal>
                  <Modal
                    //activator={activator}
                    open={this.state.collectionBeingEditedModalBulk}
                    onClose={()=>{this.collectionsBulkEdit(false)}}
                    title={"Change metrics for "+this.state.collectionsSelectedItems.length+" Collections"}
                  >
                    <div className='modal-content'>
                      <p>
                        Select which metric set you'd like to apply to these collections.
                      </p>
                      <FormLayout>
                        <Select 
                          label="Metrics Selected"
                          options={this.state.collectionsBulkEditMetricSetOptions}
                          value={this.state.collectionsBulkEditMetricSetValue}
                          //onChange={(value)=>{this.metricsChangeCollection(value,this.state.collectionBeingEdited,'metricId')}}
                          onChange={(value)=>{this.changeCollectionsEditBulkMetrics(value)}}
                        />
                        <Select 
                          label="Revert To (When Off)"
                          options={this.state.collectionsBulkEditRevertOptions}
                          //value={this.state.collectionBeingEdited.revertSorting}
                          value={this.state.collectionsBulkEditRevertValue}
                          //onChange={(value,item,i)=>{this.metricsChangeCollection(value,this.state.collectionBeingEdited,'revertSorting')}}
                          onChange={(value)=>{this.changeCollectionsEditBulkRevert(value)}}
                        />
                      </FormLayout>
                      <div className={"settings-save-container "+((this.state.collectionsBulkEditShowSave) ? 'show':'hide')}>
                        <Button primary loading={this.state.collectionsBulkEditSaveLoading} disabled={this.state.collectionsBulkEditSaveLoading} onClick={() => { this.saveCollectionsEditBulk()}}>Save</Button>
                        <Button disabled={this.state.collectionsBulkEditSaveLoading} onClick={() => { this.discardCollectionsEditBulk()}}>Discard</Button>
                      </div>
                    </div>
                  </Modal>
                </div>
                <div className={"iec-tabbed-content "+((this.state.activeTab == 3) ? 'show':'hide')}>
                  <Layout.Section>
                      <div className={'tab-parent-page '+(this.state.metrics.createMetricsDisplay ? 'hide':'show')}>                     
                      <Page
                        title={'Metrics'}
                        primaryAction={
                          <Button
                            primary
                            onClick={()=>{this.displayEditMetrics(true,true)}}
                            disabled={(this.state.metricsResourceItemsCount >= this.state.init.permissions.metrics)}
                          >
                            Create Metrics
                          </Button>
                        }
                      >
                        <p class="video-cta video-cta-in-title" style={{left:'115px'}}><Link monochrome onClick={() => this.watchVideo('metrics')}><Icon source={PlayCircleMajor} color="base" /> Watch Training Video</Link></p>
                        <div className='metrics-info'>
                          <p>Sets of weighted attributes for scoring &amp; dynamically sorting the products within your collections.</p>
                          <div className='metrics-count-status'>
                            {this.state.metricsResourceItems.length }/{this.state.init.permissions.metrics} Created
                            <div className="inline-tooltip-container">
                              <Tooltip content={this.state.init.current_plan + " Plan allows for "+this.state.init.permissions.metrics+" metrics"}>
                                <Icon source={QuestionMarkMajor} color="base" />
                              </Tooltip>
                            </div>
                          </div>                          
                        </div>
                        <div className="top-card-padding metrics-tab">
                          <Card>
                            <Card.Section>
                              <Tabs 
                                tabs={this.state.metricsTabs} 
                                selected={this.state.activeMetricsTab} 
                                onSelect={this.handleMetricsNavChange}
                                fitted={false}
                                >
                              </Tabs> 
                            </Card.Section> 
                            <Card.Section>
                            <ResourceList
                                resourceName={{singular: 'metric', plural: 'metrics'}}
                                items={this.state.metricsResourceItems || []}
                                //shortcutActions={shortcutActions}
                                //persistActions
                                filterControl={(
                                  <div className="metric-header-container">
                                    <Filters
                                      queryValue={this.state.metricsFilterQueryValue}
                                      filters={[]}
                                      //appliedFilters={appliedFilters}
                                      onQueryChange={(value) => {this.metricsFilterChangeQueryValue(value)}}
                                      onQueryClear={(value) => {this.metricsFilterChangeQueryValue('')}}
                                      //onClearAll={() => console.log('Todo: implement onClearAll')}
                                    >
                                    <div className="sort-popover-container" style={{paddingLeft: '8px'}}>
                                      
                                      <Button onClick={() => {this.togglePopover('metrics')}}><Icon source={SortMinor} color="base" />Sort</Button>
                                      <div className={"sort-popover "+(this.state.popoverFilters.metrics.show? 'show':'hide')}>
                                        <ChoiceList
                                          //title="Company name"
                                          choices={[
                                            {label: 'Title A-Z', value: 'name-asc'},
                                            {label: 'Title Z-A', value: 'name-desc'},
                                            {label: 'Date (Newest first)', value: 'date-asc'},
                                            {label: 'Date (Oldest first)', value: 'date-desc'},
                                          ]}
                                          selected={this.state.popoverFilters.metrics.value}
                                          onChange={(value) => {this.changePopover(value,'metrics')}}
                                        />
                                      </div>
                                    </div>
                                    </Filters>
                                    <div className="resource-list-headings">
                                      <div className="resource-list-heading-item rlhi-1">
                                        <h3>Title</h3>
                                      </div>
                                      <div className="resource-list-heading-item rlhi-2">
                                        <h3>Attributes</h3>
                                      </div>
                                      <div className="resource-list-heading-item rlhi-3">
                                        <h3>Collections</h3>
                                      </div>
                                      <div className="resource-list-heading-item rlhi-4">
                                        <h3>Boost</h3>
                                      </div>
                                      <div className="resource-list-heading-item rlhi-5">
                                        <h3>Default</h3>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                onSelectionChange={this.setCollectionsSelectedItems}
                                renderItem={(item,id,index) => {
                                  const {
                                    name, 
                                    attributes,
                                    collections,
                                    boost,
                                    is_default,
                                    enabled,
                                    attribute_name,
                                    //shortcutActions,
                                  } = item;
                                  let metricShortcutActions = [{content:'Edit',onAction:(e)=>{this.editMetrics(id,index)}}];


                                  return (
                                    <ResourceItem
                                      id={id}
                                      //url={url}
                                      //media={media}
                                      accessibilityLabel={`View details for ${name}`}
                                      //shortcutActions={metricShortcutActions}
                                      persistActions
                                      onClick={() => {this.editMetrics(id,index)}}
                                      //className={"url-resource-item "+((enable) ? 'url-resource-item-disabled':'')}
                                    >
                                      <div className="resource-item-col collection-resource-item-col collection-resource-item-col-1">
                                        <h3>
                                          <TextStyle variation="strong">{name}</TextStyle>
                                        </h3>
                                      </div>
                                      <div className="resource-item-col collection-resource-item-col collection-resource-item-col-2">
                                        <ul className="metric-attribute-list">
                                        {
                                        (attributes)?
                                          attributes.map(function(item, i){
                                            if(i < 3){
                                              //return <li key={i}><small>{item.select.value} ({item.value.charAt(0).toUpperCase() + item.value.replace('-',' ').slice(1)})</small></li>
                                              return <li key={i}>
                                                <small>{item.attribute_name} ({ item.value })</small>
                                              </li>
                                            } else {
                                              return;
                                            }
                                          })
                                          :
                                          ''
                                        }
                                        {attributes.length > 3 ? <li className='metrics-and-more'><small>...and {attributes.length - 3} more</small></li>:''}
                                        </ul>
                                      </div>
                                      <div className="resource-item-col collection-resource-item-col collection-resource-item-col-3">
                                        <h3>
                                          <TextStyle variation="strong">Applied to {collections} collections</TextStyle>
                                        </h3>
                                      </div>
                                      <div className="resource-item-col collection-resource-item-col collection-resource-item-col-4">
                                        {boost == "1"? <Badge status="success">On</Badge>:<Badge>Off</Badge>}
                                      </div>
                                      <div className="resource-item-col collection-resource-item-col collection-resource-item-col-4">
                                        {is_default == "1"? <Badge status="success">Default</Badge>:''}
                                      </div>
                                    </ResourceItem>
                                  );
                                }}
                              />
                              <div className='pagination-container'>
                                <Pagination
                                  //hasPrevious
                                  onPrevious={() => {
                                    //console.log('Previous');
                                  }}
                                  //hasNext
                                  onNext={() => {
                                    //console.log('Next');
                                  }}
                                />
                              </div>
                            </Card.Section>                         
                          </Card>
                        </div>
                      </Page>
                    </div>
                    <div className={'create-page '+(this.state.metrics.createMetricsDisplay ? 'show':'hide')}>
                      <Modal
                          //activator={activator}
                          open={this.state.deleteMetricsModalOpen}
                          onClose={() => {this.setState({deleteMetricsModalOpen:false})}}
                          title={'Remove '+this.state.metricsBeingEdited.name+'?'}
                          //large
                      > 
                        <div className='modal-video-container'>
                          <Banner
                            title="This cannot be undone."
                            status="warning"
                          >
                            <p>Removing this metrics set will do so permanently.</p>
                          </Banner>
                          <div className='delete-metrics-modal-content'>
                            {
                              (this.state.deleteMetricsCollectionCount > 1)?
                              <p>This also will reassign {this.state.deleteMetricsCollectionCount} collections to your default metrics set.</p>
                              :
                              ''
                            }
                            <Button
                            destructive
                            onClick={() => {this.doDeleteMetricsSet(this.state.metricsBeingEdited.id)}}
                            >Delete Metrics Set</Button>
                            <Button
                            plain
                            monochrome
                            onClick={() => {this.setState({deleteMetricsModalOpen:false})}}
                            >Cancel</Button>
                          </div>
                        </div>
                      </Modal>
                      <Page
                        title={this.state.metricsBeingEdited.name == '' ? 'Create Metrics':this.state.metricsBeingEdited.name}
                        breadcrumbs={(this.state.saveBar.show ? []:[{content: 'Metrics', onAction:()=>{this.displayEditMetrics(false,true)}}])}
                      >
                        <div className="top-card-padding">
                          <div className='metrics-top-actions'>
                            <Button
                            plain
                            monochrome
                            removeUnderline
                            onClick={() => this.duplicateMetrics(this.state.metricsBeingEdited.id)}
                            >
                              Duplicate
                            </Button>
                            <Button
                            plain
                            monochrome
                            removeUnderline
                            onClick={() => this.viewProductScores(this.state.metricsBeingEdited.id)}
                            >
                              View Product Scores
                            </Button>
                            {/*
                            <Pagination
                              onPrevious={() => {
                                //console.log('Previous');
                              }}
                              //hasNext
                              onNext={() => {
                                //console.log('Next');
                              }}
                              hasNext
                            ></Pagination>
                            */}
                          </div>
                          <Grid>
                            <Grid.Cell columnSpan={{xs: 6, sm: 6, md: 6, lg: 8, xl: 8}}>
                              <Card sectioned>
                                <Card.Section>
                                  <p>
                                    <TextField
                                      label="Title"
                                      value={this.state.metricsBeingEdited.name}
                                      //(isNew,index=false,key,value)
                                      onChange={(value) => { this.editMetricsObject(true,false,'name',value);}}
                                      autoComplete="off"
                                      //labelHidden
                                    />
                                  </p>
                                  <div className={'edit-metrics-card-heading'}>
                                    <h4>
                                      Attributes
                                      <div className="inline-tooltip-container">
                                        <Tooltip content={'Assign Attributes and their ranking weight for this metrics set'}>
                                          <Icon source={QuestionMarkMajor} color="base" />
                                        </Tooltip>
                                      </div>
                                    </h4>
                                  </div>
                                  <div>
                                  {
                                    this.state.metricsBeingEdited.attributes.map((item, i) => {
                                      return <div className='metric-attribute-row'>
                                              <Select 
                                                label="Metric"
                                                //options={attributeOptionTypes}
                                                options={this.getAttributeOptionTypes(i)}
                                                value={this.state.metricsBeingEdited.attributes[i].select.value}
                                                onChange={(value) => { this.editMetricsAttributes(i,'select',value)}}
                                                //labelHidden
                                              />  
                                              <TextField
                                                label="Value"
                                                value={this.state.metricsBeingEdited.attributes[i].value}
                                                onChange={(value) => { this.editMetricsAttributes(i,'value',value)}}
                                                autoComplete="off"
                                                //labelHidden
                                                type={'number'}
                                                step={1}
                                              />
                                              <Button
                                                onClick={() => {this.removeMetricAttribute(i)}}
                                              ><Icon
                                              source={DeleteMajor}
                                              color="base" 
                                              /></Button>
                                              <div className='inline-tooltip-container small'>
                                                <Tooltip content={'Values can be both negative or positive.'} className={'inline-tooltip'}>
                                                  <Icon source={QuestionMarkMajor} color="base" />
                                                </Tooltip>
                                              </div>                                              
                                            </div>
                                    })
                                  }
                                  </div>
                                  <Button disabled={
                                    (
                                      (
                                        this.getAttributeOptionTypes(-1).length < 1
                                      ) 
                                      && 
                                      (
                                        this.state.metricsBeingEdited.attributes > 0
                                      )
                                    )
                                    ||
                                    (
                                      this.getAttributeOptionTypes(-1).length == 0 
                                    )
                                  } onClick={()=>{this.addMetricsAttributeRow();}}>Add {(this.state.metricsBeingEdited.attributes.length > 0? 'another':'')} attribute</Button>
                                </Card.Section>
                                <Card.Section>
                                  <p>
                                    <Checkbox 
                                    label={'Apply Product Boost values to these metrics'}
                                    disabled={(this.state.init.current_plan == 'Basic' || this.state.init.current_plan == 'Demo')}
                                    checked={(this.state.metricsBeingEdited.boost == "1" ? true:false)}
                                    onChange={() => {this.editMetricsObject(true,false,'boost',(this.state.metricsBeingEdited.boost == "0"? "1":"0"))}}
                                    />
                                    <div className='inline-tooltip-container'>
                                      <Tooltip content={'Select whether this metrics set boosts products as defined in the Products tab'} className={'inline-tooltip'}>
                                        <Icon source={QuestionMarkMajor} color="base" />
                                      </Tooltip>
                                    </div>
                                  </p>
                                  {
                                    (this.state.init.current_plan == 'Basic' || this.state.init.current_plan == 'Demo')
                                    ?
                                    <Link onClick={() => this.handleNavTabChange(7)}>Upgrade your plan to use Product Boosts</Link>
                                    :
                                    ''
                                  }

                                </Card.Section>
                              </Card>
                              <Card
                              title="Metrics Preview">
                                <div className={'metrics-preview-products'}>
                                  <ResourceList
                                    
                                    resourceName={{singular: 'metric', plural: 'metrics'}}
                                    items={this.state.metricsPreviewProducts || []}
                                    emptyState={this.state.metricsPreviewProducts == null || !this.state.metricsPreviewProducts.length? <EmptyState
                                      heading="Save Metrics to Preview Products Ordering"
                                    ><p>Once metrics are saved above, product ordering will display here.</p></EmptyState>:undefined}
                                    //onSelectionChange={this.setCollectionsSelectedItems}
                                    renderItem={(item) => {
                                      const {
                                        id, 
                                        position,
                                        title, 
                                        image,
                                        value
                                      } = item;

                                      return (
                                        <ResourceItem
                                          id={id}
                                          //url={url}
                                          //media={media}
                                          accessibilityLabel={`View details for ${title}`}
                                          //shortcutActions={shortcutActions}
                                          //persistActions
                                          //className={"url-resource-item "+((enable) ? 'url-resource-item-disabled':'')}
                                        >
                                          <div className="metric-product-item-col">
                                            {position}.
                                          </div>
                                          <div className="metric-product-item-col">
                                            {(
                                              image == '' ?
                                                <img src="https://dynasort.immersiveecommerce.com/assets/img/placeholder.png" alt="No Image Available" />
                                                :
                                                <img src={image} alt={title} />
                                            )}
                                          </div>
                                          <div className="metric-product-item-col">
                                            {title}
                                          </div>
                                          <div className="metric-product-item-col">
                                            {value}
                                          </div>
                                        </ResourceItem>
                                      );
                                    }}
                                  />    
                                </div>       
                              </Card>
                            </Grid.Cell>
                            <Grid.Cell columnSpan={{xs: 6, sm: 6, md: 6, lg: 4, xl: 4}}>
                              <Card title="Settings" sectioned>
                                <Card.Section>
                                  <Checkbox 
                                  //label="Set as Default Metric" 
                                  label={'Set as Default Metric'}
                                  checked={parseInt(this.state.metricsBeingEdited.is_default)}
                                  onChange={() => {this.editMetricsObject(true,false,'is_default',(this.state.metricsBeingEdited.is_default == "0" ? "1":"0"))}}
                                  disabled={(this.state.metricsDefaultId == this.state.metricsBeingEdited.id)?true:false}
                                  />
                                  {
                                  (parseInt(this.state.metricsBeingEdited.is_default))
                                  ?
                                  ''
                                  :
                                  <div className="inline-tooltip-container small" style={{marginTop:'4px'}}>
                                  <Tooltip content={"All current collections using the default metrics will be switched to this set."}>
                                    <Icon source={QuestionMarkMajor} color="base" />
                                  </Tooltip>
                                  </div>
                                  }                                  
                                </Card.Section>
                                <Card.Section>
                                  <Select 
                                    label="Sold Out Items"
                                    options={soldOutOptions}
                                    value={this.state.metricsBeingEdited.soldOutValue}
                                    onChange={(value) => this.editMetricsObject(true,false,'soldOutValue',value)}
                                  />
                                </Card.Section>
                                <Card.Section>
                                  <div className='tie-breaker-select'>
                                    <Select 
                                      label="Tie Breaker"
                                      options={tieBreaker}
                                      value={this.state.metricsBeingEdited.tieBreakerValue}
                                      onChange={(value) => this.editMetricsObject(true,false,'tieBreakerValue',value)}
                                    />        
                                    <div className="inline-tooltip-container small">
                                      <Tooltip content={"When products share the same score value this will dictate what value breaks the tie."}>
                                        <Icon source={QuestionMarkMajor} color="base" />
                                      </Tooltip>
                                    </div>  
                                  </div>                                  
                                </Card.Section>
                                {(parseInt(this.state.metricsBeingEdited.is_default) < 1)?
                                <Card.Section>
                                  <div className='delete-metrics'>
                                    <Button
                                    plain 
                                    destructive
                                    onClick={()=> this.showDeleteMetricsModal(this.state.metricsBeingEdited.id)}
                                    >Delete Metrics Set</Button>      
                                    <div className="inline-tooltip-container small">
                                      <Tooltip content={"Delete this metrics set and assign any already assigned collections to your default metrics set"}>
                                        <Icon source={QuestionMarkMajor} color="base" />
                                      </Tooltip>
                                    </div>  
                                  </div>                                  
                                </Card.Section>
                                :
                                ''
                                }

                              </Card>
                              <Card
                              title="Assigned Collections"
                              className="">
                                <div className='collections-side-card'>
                                  <TextField 
                                    prefix={<Icon source={SearchMinor} />}
                                    placeholder="Filter assigned collections"
                                    autoCompleteRequired="off"
                                    label="Search for assigned collections"
                                    labelHidden={true}
                                    onChange={(value) => this.sidebarCollectionsChange(value)}
                                    value={this.state.sidebarCollectionsValue}
                                  />
                                  <ul>
                                    {this.state.metricsSidebarCollections.map(function(item, i){
                                      return <li className={("collections-side-card-item-"+i)}>{ item }</li>
                                    })}
                                    {/*
                                    metricsSidebarCollections
                                    <li>Really long collection title that we'll surely encounter one day</li>
                                    <li>Super Collection</li>
                                    <li>Super Duper Collection</li>
                                    <li>Raddest Collection</li>
                                    <li>Stellar Collection</li>
                                    */}
                                  </ul>
                                </div>
                              </Card>
                            </Grid.Cell>
                          </Grid>
                        </div>
                      </Page>
                    </div>
      
                  </Layout.Section>
                </div>
                <div className={"iec-tabbed-content "+((this.state.activeTab == 4) ? 'show':'hide')}>
                  {
                  //check vars available
                  this.state.productAttributes == null
                  ? ''
                  :<Layout.Section>
                    <Page
                      title={'Attributes'}
                    >
                      <p class="video-cta video-cta-in-title" style={{left:'140px'}}><Link monochrome onClick={() => this.watchVideo('attributes')}><Icon source={PlayCircleMajor} color="base" /> Watch Training Video</Link></p>
                      <div className="top-card-padding product-data-attributes">
                        {(this.state.init.generating_attr_values ?
                        <div class="below-title-banner">
                          <Banner status='info'>
                            Generating default attribute values unique to your store. We'll update these once caching completes.
                          </Banner>
                        </div>
                        :
                        ''
                        )}
                        <Card>
                          <Heading element="h4">Product Data Attributes</Heading>
                          <ResourceList
                              resourceName={{singular: 'attribute', plural: 'attributes'}}
                              items={this.state.productAttributes['data'] || []}
                              filterControl={(
                                <div className="attributes-header-container">
                                  <div className="resource-list-headings">
                                    <div className="resource-list-heading-item rlhi-1">
                                      <h3>Name</h3>
                                    </div>
                                    <div className="resource-list-heading-item rlhi-2">
                                      <h3>Status</h3>
                                    </div>
                                    <div className="resource-list-heading-item rlhi-3">
                                      <h3>Configurables</h3>
                                    </div>
                                    <div className="resource-list-heading-item rlhi-4">
                                      <h3>Info</h3>
                                    </div>
                                    <div className="resource-list-heading-item rlhi-5"></div>
                                  </div>
                                </div>
                              )}
                              renderItem={(item) => {
                                return (
                                  <ResourceItem
                                    id={'id'}
                                    //url={url}
                                    //media={media}
                                    accessibilityLabel={`View details for ${item.name}`}
                                    shortcutActions={(item.status == "1" ? [{content:'Deactivate',onAction:(e)=>{this.attributeStatus("0",item.attribute_key)}}]:[{content:'Activate',onAction:(e)=>{this.attributeStatus("1",item.attribute_key)}}])}
                                    persistActions
                                    //className={"url-resource-item "+((enable) ? 'url-resource-item-disabled':'')}
                                  >
                                      <Configurables 
                                        configurables={item}
                                        change={(value,attributeKey,fieldKey) => {this.changeConfigurables(value,attributeKey,fieldKey)}}
                                        changeTitle={(value,attributeKey) => {this.changeConfigurableTitle(value,attributeKey)}}
                                        save={(attributeKey) => {this.saveConfigurables(attributeKey)}}
                                        section={'standard_attributes'}
                                        permissions={this.state.init.permissions}
                                        group='data'
                                        metaData={this.state.metaData}
                                        init={this.state.init}
                                        shop={storeUrl}
                                      />                                  
                                  </ResourceItem>
                                );
                              }}
                          />
                        </Card>
                        <Card>
                          <Heading element="h4">Custom Attributes</Heading>
                          <div className={'custom-attributes '+(this.state.init.permissions.custom_attributes ? 'yep':'custom-attributes-disabled')}>
                            <ResourceList
                                resourceName={{singular: 'attribute', plural: 'attributes'}}
                                items={this.state.productAttributes['custom'] || []}
                                emptyState={(this.state.init.current_plan == 'Demo' || this.state.init.current_plan == 'Basic') ? <div></div>:<EmptyState
                                heading="Create an attribute to get started"
                                //action={{content: 'Upload files'}}
                                //image="https://cdn.shopify.com/s/files/1/2376/3301/products/emptystate-files.png"
                              >
                                
                              </EmptyState>}
                                filterControl={(
                                  <>
                                    <div className="attributes-header-container">
                                      <div className="resource-list-headings">
                                        <div className="resource-list-heading-item rlhi-1">
                                          <h3>Name</h3>
                                        </div>
                                        <div className="resource-list-heading-item rlhi-2">
                                          <h3>Status</h3>
                                        </div>
                                        <div className="resource-list-heading-item rlhi-3">
                                          <h3>Configurables</h3>
                                        </div>
                                        <div className="resource-list-heading-item rlhi-4">
                                          <h3>Info</h3>
                                        </div>
                                        <div className="resource-list-heading-item rlhi-5"></div>
                                      </div>
                                    </div>
                                  </>
                                )}
                                renderItem={(item) => {
                                  return (
                                    (
                                      (
                                        this.state.init.current_plan == 'Pro'
                                        ||
                                        this.state.init.current_plan == 'Enterprise'
                                        ||
                                        1 == 1
                                      )
                                    )
                                    ?
                                    <ResourceItem
                                      id={'id'}
                                      //url={url}
                                      //media={media}
                                      accessibilityLabel={`View details for ${item.name}`}
                                      shortcutActions={
                                        (
                                            item.status == "1" ? [
                                              {content:'Deactivate',onAction:(e)=>{this.attributeStatus("0",item.attribute_key)}},
                                              {content:'Delete',onAction:(e)=>{this.deleteAttribute(item.attribute_key)}},
                                              ]
                                              
                                              : (item.status == "0" && this.state.init.permissions.custom_attributes) ? 
                                              [
                                                {content:'Activate',onAction:(e)=>{this.attributeStatus("1",item.attribute_key)}},
                                                {content:'Delete',onAction:(e)=>{this.deleteAttribute(item.attribute_key)}},
                                              ]
                                              : (item.status == "0" && !this.state.init.permissions.custom_attributes) ? 
                                              [
                                                {content:'Upgrade Plan to Activate',onAction:(e)=>{}},
                                                {content:'Delete',onAction:(e)=>{this.deleteAttribute(item.attribute_key)}},
                                              ]
                                              :
                                              ''
    
                                        )
                                      }
                                      persistActions
                                      //className={"url-resource-item "+((enable) ? 'url-resource-item-disabled':'')}
                                    >
                                        <Configurables 
                                          configurables={item}
                                          change={(value,attributeKey,fieldKey) => {this.changeConfigurables(value,attributeKey,fieldKey)}}
                                          changeTitle={(value,attributeKey) => {this.changeConfigurableTitle(value,attributeKey)}}
                                          save={(attributeKey) => {this.saveConfigurables(attributeKey)}}
                                          section={'custom_attributes'}
                                          permissions={this.state.init.permissions}
                                          group='custom'
                                          metaData={this.state.metaData}
                                          init={this.state.init}
                                          shop={storeUrl}
                                        />                                    
                                    </ResourceItem>
                                    :
                                    ''
                                  );
                                }}
                            />
                            
                            <div className='add-attribute-container'>
                              <Button
                                //disabled={(this.state.init.current_plan == 'Basic' || this.state.init.current_plan == 'Demo')}
                                onClick={() => {this.addAttribute('custom')}}
                              >
                                Add custom attribute
                              </Button>
                            </div>
                            {
                              (
                                (
                                  this.state.init.current_plan == 'Demo'
                                  ||
                                  this.state.init.current_plan == 'Basic'
                                )
                              )
                              ?
                              <div className='attributes-upgrade'>
                                <DisplayText size='small'>Upgrade to Activate!</DisplayText>
                                <p>With Custom Attributes you can define your own attributes using: metafields, tags, titles, vendors and product types.</p>
                                <Link onClick={() => {this.handleNavTabChange(7)}}>View Plans</Link>
                              </div>
                              :
                              ''
                            }                            
                          </div>
                        </Card>
                        {(storeUrl == 'dynasort.myshopify.com' || storeUrl == 'dakine-prod.myshopify.com' || 1 ==1) ?
                        <Card>
                          <Heading element="h4">Partner Integrated Attributes</Heading>
                          <ResourceList
                              resourceName={{singular: 'attribute', plural: 'attributes'}}
                              items={this.state.productAttributes['partner'] || []}
                              emptyState={(this.state.init.current_plan == 'Demo' || this.state.init.current_plan == 'Basic') ? <div></div>:<EmptyState
                              heading="Create an attribute to get started"
                              //action={{content: 'Upload files'}}
                              //image="https://cdn.shopify.com/s/files/1/2376/3301/products/emptystate-files.png"
                            >
                              
                            </EmptyState>}
                              filterControl={(
                                <div className="attributes-header-container">
                                  <div className="resource-list-headings">
                                    <div className="resource-list-heading-item rlhi-1">
                                      <h3>Name</h3>
                                    </div>
                                    <div className="resource-list-heading-item rlhi-2">
                                      <h3>Status</h3>
                                    </div>
                                    <div className="resource-list-heading-item rlhi-3">
                                      <h3>Configurables</h3>
                                    </div>
                                    <div className="resource-list-heading-item rlhi-4">
                                      <h3>Info</h3>
                                    </div>
                                    <div className="resource-list-heading-item rlhi-5"></div>
                                  </div>
                                </div>
                              )}
                              renderItem={(item) => {
                                return (
                                  <ResourceItem
                                    id={'id'}
                                    //url={url}
                                    //media={media}
                                    accessibilityLabel={`View details for ${item.name}`}
                                    shortcutActions={
                                      (
                                          item.status == "1" ? [
                                            {content:'Deactivate',onAction:(e)=>{this.attributeStatus("0",item.attribute_key)}},
                                            {content:'Delete',onAction:(e)=>{this.deleteAttribute(item.attribute_key)}},
                                            ]
                                            
                                            : (item.status == "0" && this.state.init.permissions.custom_attributes) ? 
                                            [
                                              {content:'Activate',onAction:(e)=>{this.attributeStatus("1",item.attribute_key)}},
                                              {content:'Delete',onAction:(e)=>{this.deleteAttribute(item.attribute_key)}},
                                            ]
                                            : (item.status == "0" && !this.state.init.permissions.custom_attributes) ? 
                                            [
                                              {content:'Upgrade Plan to Activate',onAction:(e)=>{}},
                                              {content:'Delete',onAction:(e)=>{this.deleteAttribute(item.attribute_key)}},
                                            ]
                                            :
                                            ''
  
                                      )
                                    }
                                    persistActions
                                    //className={"url-resource-item "+((enable) ? 'url-resource-item-disabled':'')}
                                  >
                                        <Configurables 
                                          configurables={item}
                                          change={(value,attributeKey,fieldKey) => {this.changeConfigurables(value,attributeKey,fieldKey)}}
                                          changeTitle={(value,attributeKey) => {this.changeConfigurableTitle(value,attributeKey)}}
                                          save={(attributeKey) => {this.saveConfigurables(attributeKey)}}
                                          section={'partner_attributes'}
                                          permissions={this.state.init.permissions}
                                          group='partner'
                                          metaData={this.state.metaData}
                                          init={this.state.init}
                                          shop={storeUrl}
                                        />                                
                                  </ResourceItem>
                                );
                              }}
                          />
                            <div className='add-attribute-container'>
                              <Button
                                //disabled={(this.state.init.current_plan == 'Basic' || this.state.init.current_plan == 'Demo')}
                                onClick={() => {this.addAttribute('partner')}}
                              >
                                Add partner attribute
                              </Button>
                            </div>
                            {
                              (
                                (
                                  this.state.init.current_plan == 'Demo'
                                  ||
                                  this.state.init.current_plan == 'Basic'
                                )
                              )
                              ?
                              <div className='attributes-upgrade'>
                                <DisplayText size='small'>Upgrade to Activate!</DisplayText>
                                <p>With Partner Attributes you can define your own attributes using your favorite product reviews platform.</p>
                                <Link onClick={() => {this.handleNavTabChange(7)}}>View Plans</Link>
                              </div>
                              :
                              ''
                            }         
                        </Card>
                        :
                        '' //if not dyna demo store
                        }
                      </div>                    
                    </Page>
                  </Layout.Section>
                  }
                </div>
                <div className={"iec-tabbed-content "+((this.state.activeTab == 5) ? 'show':'hide')}>
                  <Layout.Section>
                    <Page
                      title={'Products'}
                    >
                      <div className='header-selection-form'>
                        <FormLayout>
                          <Select 
                            label="Metrics"
                            options={this.state.productMetricsOptions}
                            value={this.state.productsMetricsSelected}
                            onChange={(value)=>{this.productsMetricsChanged(value)}}
                            labelInline={true}
                          />
                          <Select 
                            label="Collections"
                            options={this.state.productsCollectionsOptions}
                            value={this.state.productsCollectionsSelected}
                            onChange={(value)=>{this.changeProductsCollectionsChanged(value)}}
                            labelInline={true}
                          />
                          <div className='box-right'>
                            {/*
                            <Button
                              onClick={()=>{console.log('print')}}
                              external
                              monochrome
                              plain
                              removeUnderline
                            >
                              Print
                            </Button>
                            */}
                            <div className='resort-button'>
                              <Button
                                onClick={()=>{this.resortCollection(this.state.productsCollectionsSelected)}}
                                external
                                monochrome
                                plain
                                removeUnderline
                                disabled={false
                                 // (this.state.init.permissions.resort == false || this.state.productsResorting ? true:false)
                                }
                                //url={(downloadProductsUrl+'?shop='+storeUrl+'&token='+this.state.init.plan_token+'&metrics='+this.state.productsMetricsSelected+'&collection='+this.state.productsCollectionsSelected)}
                              >
                                Sync Now
                              </Button>
                            </div>
                            <Button
                              //onClick={()=>{this.downloadProducts}}
                              external
                              monochrome
                              plain
                              removeUnderline
                              disabled={(this.state.init.permissions.exports == false ? true:false)}
                              url={(downloadProductsUrl+'?shop='+storeUrl+'&token='+this.state.init.plan_token+'&metrics='+this.state.productsMetricsSelected+'&collection='+this.state.productsCollectionsSelected)}
                            >
                              Download as CSV
                            </Button>
                          </div>
                        </FormLayout>
                      </div>
                      <IndexTableCustomHeadings
                        filters={this.state.filtersProduct}
                        products={this.state.products}
                        attributes={this.state.metricsCollectionProductsAttributes}
                        boost={this.state.metricsCollectionProductsBoost}
                        metrics={this.state.metricsResourceItems[this.state.productsMetricsSelected]}
                        change={(value,productId,index) => {this.editBoost(value,productId,index)}}
                        save={(productId,index) => {this.saveBoost(productId,index)}}
                        showProductCount={this.state.showProductCount}
                        showProductIndex={this.state.showProductIndex}
                        loadMore={() => {this.loadMoreProducts()}}
                        permissions={this.state.init.permissions}
                        storeUrl={storeUrl}
                        bulkCacheStatus={this.state.bulkCacheStatus}
                        loading={this.state.productsLoading}
                      />
                      
                    </Page>
                  </Layout.Section>
                </div>
                <div className={"iec-tabbed-content top-padding "+((this.state.activeTab == 6) ? 'show':'hide')}>
                  {
                  //check vars available
                  //this.state.productAttributes == null
                  this.state.settings.processing_interval == null
                  ||
                  this.state.settings.days_of_the_week == null
                  ||
                  this.state.settings.hours_of_the_day == null
                  ||
                  this.state.settings.email_shop_owner == null
                  ||
                  this.state.settings.additional_emails == null
                  ||
                  this.state.settings.notify_collections_sorted == null
                  ||
                  this.state.settings.notify_order_changed == null
                  ? ''
                  :
                  <Page>
                    <Layout.AnnotatedSection
                      title="Processing Schedule"
                      description="This is how often the app will process your
                      collections to apply your sorting metrics.
                      Premium plans have more options on timing.
                      To see these options please check your plan."
                    >
                      <Card>
                        <FormLayout>
                          <Select
                            label="Processing Schedule"
                            options={this.state.settings.processing_interval.options}
                            onChange={(value) => {this.changeSettingsSelect(value,'processing_interval')}}
                            value={this.state.settings.processing_interval.value}
                          />
                          <Select
                            label="Days of the Week"
                            options={this.state.settings.days_of_the_week.options}
                            onChange={(value) => {this.changeSettingsSelect(value,'days_of_the_week')}}
                            value={this.state.settings.days_of_the_week.value}
                          />
                          <Select
                            label="Hours of the Day to Run"
                            options={this.state.settings.hours_of_the_day.options}
                            onChange={(value) => {this.changeSettingsSelect(value,'hours_of_the_day')}}
                            value={this.state.settings.hours_of_the_day.value}
                          />
                          <div className={"settings-save-container "+((this.state.showProcessingSave) ? 'show':'hide')}>
                            <Button primary loading={this.state.settings.processingSaveLoading} disabled={this.state.settings.processingSaveLoading} onClick={() => { this.saveProcessingSettings()}}>Save</Button>
                            <Button disabled={this.state.settings.processingSaveLoading} onClick={() => { this.discardProcessingSettings()}}>Discard</Button>
                          </div>
                        </FormLayout>
                      </Card>
                    </Layout.AnnotatedSection>
                      {/* //hidden for review and dev
                    <Layout.AnnotatedSection
                      title="Notifications"
                      description={"Configure when the app sends you e-mail notifications and to what address."}
                    >
                      <Card>
                        <Heading element="h4">E-mail Addresses</Heading>
                        <FormLayout>
                          <p>Deliver notifications to the following e-mail addresses:</p>
                          <p><Checkbox 
                            checked={(this.state.settings.email_shop_owner.value == "true" ? true:false)}
                            label={'Shop owner ('+this.state.init.shop_email+')'} 
                            onChange={() => {this.changeSettingsCheckbox('email_shop_owner',(this.state.settings.email_shop_owner.value == "false"? "true":"false"))}}
                          /></p>
                          <TextField 
                            label="Additional E-mail Addresses"
                            helpText="Split multiple addresses by commas"
                            value={this.state.settings.additional_emails.value}
                            onChange={(value) => this.changeSettingsAdditionalEmails(value)}
                            autoComplete={'off'}
                            error={this.state.errors.additional_emails}
                          ></TextField>
                        </FormLayout>
                        <Heading element="h4">Events</Heading>
                        <p>Send e-mails on the following events:</p>
                        <FormLayout>
                        <table className="settings-table">
                            <thead>
                              <tr>
                                <th>Event</th>
                                <th>Per Process</th>
                                <th>Daily Digest</th>
                                <th>None</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Collections sorted</td>                               
                                <td><Checkbox 
                                      onChange={() => {this.changeSettingsCheckbox('notify_collections_sorted','per_process')}} 
                                      label="Collections Sorted Per Process" 
                                      labelHidden={true} 
                                      checked={(this.state.settings.notify_collections_sorted.value == 'per_process' ? true:false)} 
                                /></td>
                                <td><Checkbox 
                                      onChange={() => {this.changeSettingsCheckbox('notify_collections_sorted','daily_digest')}} 
                                      label="Collections Sorted Daily Digest" 
                                      labelHidden={true} 
                                      checked={(this.state.settings.notify_collections_sorted.value == 'daily_digest' ? true:false)} 
                                /></td>
                                <td><Checkbox 
                                      onChange={() => {this.changeSettingsCheckbox('notify_collections_sorted','')}} 
                                      label="Collections Sorted None" 
                                      labelHidden={true} 
                                      checked={(this.state.settings.notify_collections_sorted.value == '' ? true:false)} 
                                /></td>
                                </tr>
                              <tr>
                                <td>Sorting Order Changed</td>
                                <td><Checkbox 
                                      onChange={() => {this.changeSettingsCheckbox('notify_order_changed','per_process')}} 
                                      label="Order Changed Per Process" 
                                      labelHidden={true} 
                                      checked={(this.state.settings.notify_order_changed.value == 'per_process' ? true:false)} 
                                /></td>
                                <td><Checkbox 
                                      onChange={() => {this.changeSettingsCheckbox('notify_order_changed','daily_digest')}} 
                                      label="Order Changed Daily Digest" 
                                      labelHidden={true} 
                                      checked={(this.state.settings.notify_order_changed.value == 'daily_digest' ? true:false)} 
                                /></td>
                                <td><Checkbox 
                                      onChange={() => {this.changeSettingsCheckbox('notify_order_changed','')}} 
                                      label="Order Changed None" 
                                      labelHidden={true} 
                                      checked={(this.state.settings.notify_order_changed.value == '' ? true:false)} 
                                /></td>
                              </tr>
                            </tbody>
                          </table>
                        </FormLayout>
                        <div className={"settings-save-container "+((this.state.showNotificationsSave) ? 'show':'hide')}>
                          <Button primary loading={this.state.notificationsSaveLoading} disabled={this.state.settings.notificationsSaveLoading} onClick={() => { this.saveNotificationsSettings()}}>Save</Button>
                          <Button disabled={this.state.settings.notificationsSaveLoading} onClick={() => { this.discardNotificationsSettings()}}>Discard</Button>
                        </div>
                      </Card>
                    </Layout.AnnotatedSection>
                      */}
                  </Page>
                  }
                </div>
                <div className={"iec-tabbed-content "+((this.state.activeTab == 7) ? 'show':'hide')}>
                  <Layout.Section>
                    <Page
                      title={'Plans'}
                    >
                      <p className='plan-notice'>You may upgrade or downgrade your plan at any time.</p>
                      <Plans 
                        plans={this.state.init.plans}
                        storeUrl={storeUrl}
                        planUrl={planUrl}
                        token={this.state.init.plan_token}
                        boxHeight={300}
                      />
                    </Page>
                  </Layout.Section>
                </div>
                <div className={"iec-tabbed-content dashboard-tab "+(
                  (
                    this.state.activeTab == 0
                    &&
                    !this.state.displayCollectionIssues //add conditionals here
                    ) ? 'show':'hide')}>
                    <Modal
                        //activator={activator}
                        open={this.state.calendarOpen}
                        onClose={() => {this.setState({calendarOpen:false})}}
                        title={'Schedule Training Session'}
                        //large
                    > 
                      <div className='modal-video-container'>
                        <iframe 
                        src={"https://calendly.com/d/2jw-vnp-ym3/30min?back=1&month=2023-05"}
                        title="Schedule Training Session" 
                        frameborder="0" 
                        //allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                        //allowfullscreen
                        large
                        ></iframe>
                      </div>
                    </Modal>
                    <Modal
                        //activator={activator}
                        open={this.state.kbModal.open}
                        onClose={() => {this.showKBModal(false,'','','')}}
                        title={this.state.kbModal.title}
                        //large
                    > 
                      <div className='modal-video-container'>
                        <iframe 
                        src={"https://www.youtube.com/embed/"+this.state.kbModal.slug+"?autoplay=1&modestbranding=1&rel=0"}
                        title={this.state.kbModal.title}
                        frameborder="0" 
                        //allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                        //allowfullscreen
                        large
                        ></iframe>
                      </div>
                    </Modal>
                    <Modal
                        //activator={activator}
                        open={this.state.newsModalOpen}
                        onClose={() => {this.setState({newsModalOpen:false})}}
                        title={(this.state.newsItemActive.title ? this.state.newsItemActive.title :'')}
                        large
                    > 
                      <div className='modal-video-container'>
                      {(this.state.newsItemActive.body_html ?
                        <div
                          dangerouslySetInnerHTML={{__html: this.state.newsItemActive.body_html}}
                        />
                        :
                        ''
                      )}
                      </div>
                    </Modal>

                  <Layout.Section>
                    <Page
                      //title={''}
                      //</Layout.Section>titleMetadata={<Badge status="warning">Needs attention</Badge>}                    
                    >
                      <Layout>
                        <Layout.Section>
                          <h1 class="Polaris-Header-Title">Collection Issues {(this.state.collectionsNeedsAttention?<Badge status="warning">Needs attention</Badge>:'')}</h1>
                          <div className='dashboard-issues-card'>
                            <Card
                              title={'Active issues found in your collections.'}
                            >
                              <p class={'card-paragraph'}>These issues lower your conversion rates &amp; customer experience and need attention. </p>

                              <div className='dashboard-issues-header'>
                                <div className='dashboard-issues-header-container'>
                                  <div>Collection</div>
                                  <div>Severity</div>
                                  <div>Top Issue</div>
                                  <div>Details</div>
                                </div>
                              </div>
                              {(
                                //this.state.bulkCacheStatus.complete == false
                                !this.state.bulkCacheStatus.complete

                              )
                              ?
                              <EmptyState
                                heading="Analyzing Collections"
                                //action={{content: 'Add transfer'}}
                                image="https://dynasort.immersiveecommerce.com/assets/img/dynasort-modal-bg.png"
                              >
                                <p>Once caching is complete, we'll display any issues with your collections here.</p>
                              </EmptyState>
                              :
                              (!this.state.collectionIssues.loaded) ?
                              <div className='analytics-loading'>
                                <p class="Polaris-DisplayText Polaris-DisplayText--sizeSmall">Checking For Collection Issues</p>
                                <Spinner size='large' />
                              </div>
                              :
                              <ResourceList
                                resourceName={{singular: 'issue', plural: 'issues'}}
                                items={this.getTopCollectionIssues()}
                                renderItem={(item,index) => {
                                  //const {id, title, severity, topIssue, type} = item;
                                  const {collection_id,title} = item;

                                  return (
                                    <ResourceItem
                                      id={item.collection_id}
                                      //title={title}
                                      accessibilityLabel={`View details for ${item.title}`}
                                      //topIssue={topIssue}
                                      //severity={severity}
                                      //type={type}
                                    >
                                      <div>
                                      {item.title.replace('u0026','&')}
                                      </div>
                                      <div>
                                        {
                                          (item.hasOwnProperty('critical'))?
                                          <Badge status={"critical"}>Critical</Badge>
                                          :
                                          (item.hasOwnProperty('warning'))?
                                          <Badge status={"warning"}>Warning</Badge>
                                          :
                                          ''
                                        }
                                      </div>
                                      <div>
                                        {this.getTopIssue(item)}
                                      </div>
                                      <div>
                                        {(item.collection_id == 'all')?
                                        <Link onClick={() => this.displayCollectionIssues('all',index)}>View</Link>
                                        :
                                        <Link onClick={() => this.displayCollectionIssues(item.collection_id,index)}>Details</Link>
                                        }
                                      </div>
                                    </ResourceItem>
                                  );
                                }

                              }
                              />     
                            }                   
                            </Card>
                          </div>
                          <h1 class="Polaris-Header-Title top-margin">Analytics</h1>
                          <div className='dashboard-analytics-card'>
                            <Card
                              title={'Position Effectiveness'}
                            >
                              <p className='analytics-header-note'>In the last 7 days</p>
                              {/*
                              <div className="analytics-tooltip-container">
                                <Tooltip content={"tooltip content"}>
                                  <Icon source={QuestionMarkMajor} color="base" />
                                </Tooltip>
                              </div>
                              */}
                              <p>Products taking the most advantage of their position.</p>
                              <div className='dashboard-analytics-header position-effectiveness'>
                                <div className='dashboard-analytics-header-container'>
                                  <div>Product</div>
                                  <div>Score</div>
                                </div>
                              </div>
                              {(
                                //this.state.bulkCacheStatus.complete == false
                                !this.state.bulkCacheStatus.complete

                              )
                              ?
                              <EmptyState
                                heading="Tracking Position Effectiveness"
                                //action={{content: 'Add transfer'}}
                                image="https://dynasort.immersiveecommerce.com/assets/img/dynasort-modal-bg.png"
                              >
                                <p>24 hours after installing Dynasort, we'll start displaying position effectiveness for your products.</p>
                              </EmptyState>
                              :
                              (!this.state.analytics.positionEffectiveness.loaded) ?
                              <div className='analytics-loading'>
                                <p class="Polaris-DisplayText Polaris-DisplayText--sizeSmall">Loading Position Effectiveness</p>
                                <Spinner size='large' />
                              </div>
                              :
                              <ResourceList
                                resourceName={{singular: 'customer', plural: 'customers'}}
                                items={this.state.analytics.positionEffectiveness.items || []}
                                renderItem={(item,index) => {
                                  const {
                                    product_id, 
                                    title, 
                                    image, 
                                    position_effectiveness
                                  } = item;

                                  return (
                                    <ResourceItem
                                      id={product_id}
                                      title={title}
                                      accessibilityLabel={`View details for ${title}`}
                                      image={image}
                                      position_effectiveness={position_effectiveness}
                                    >
                                      <div className='analytics-position'>{(parseInt(index)+1)}.</div>
                                      <div className='analytics-image'>
                                      {
                                        (image != '')?
                                          <img src={image} alt={title} />
                                        :
                                          <img src="https://dynasort.immersiveecommerce.com/assets/img/placeholder.png" alt="Title here" />
                                      }
                                      </div>
                                      <div className='analytics-title'>
                                        {title}
                                      </div>
                                      <div className='analytics-data'>
                                        {position_effectiveness}%
                                      </div>
                                    </ResourceItem>
                                  );
                                }}
                              />
                              }
                            </Card>
                          </div>
                          <div className='dashboard-analytics-card'>
                            <Card
                              title={'Rising Products'}
                            >
                              <p className='analytics-header-note'>In the last 7 days</p>
                              {/*
                              <div className="analytics-tooltip-container">
                                <Tooltip content={"tooltip content"}>
                                  <Icon source={QuestionMarkMajor} color="base" />
                                </Tooltip>
                              </div>
                              */}
                              <p>These products have dynamically climbed the most spots in the last week.</p>
                              <div className='dashboard-analytics-header position-effectiveness'>
                                <div className='dashboard-analytics-header-container'>
                                  <div>Product</div>
                                  <div>Position Change</div>
                                </div>
                              </div>
                              {(
                                //this.state.bulkCacheStatus.complete == false
                                !this.state.bulkCacheStatus.complete

                              )
                              ?
                              <EmptyState
                                heading="Tracking Rising Products"
                                //action={{content: 'Add transfer'}}
                                image="https://dynasort.immersiveecommerce.com/assets/img/dynasort-modal-bg.png"
                              >
                                <p>24 hours after installing Dynasort, we'll display rising products here.</p>
                              </EmptyState>
                              :
                              (!this.state.analytics.risingProducts.loaded) ?
                              <div className='analytics-loading'>
                                <p class="Polaris-DisplayText Polaris-DisplayText--sizeSmall">Loading Rising Products</p>
                                <Spinner size='large' />
                              </div>
                              :
                              <ResourceList
                                resourceName={{singular: 'customer', plural: 'customers'}}
                                items={this.state.analytics.risingProducts.items}
                                renderItem={(item,index) => {
                                  const {id, title, image, change} = item;

                                  return (
                                    <ResourceItem
                                      id={id}
                                      title={title}
                                      accessibilityLabel={`View details for ${title}`}
                                      image={image}
                                      change={change}
                                    >
                                      <div className='analytics-position'>{(parseInt(index)+1)}.</div>
                                      <div className='analytics-image'>
                                      {
                                        (image != '')?
                                          <img src={image} alt={title} />
                                        :
                                          <img src="https://dynasort.immersiveecommerce.com/assets/img/placeholder.png" alt="Title here" />
                                      }
                                      </div>
                                      <div className='analytics-title'>
                                        {title}
                                      </div>
                                      <div className='analytics-data'>
                                        {(parseInt(change.change) > 0 ? '+':'')+change.change}
                                        <small class="deets">{change.previous} &rarr; {change.current}</small>
                                      </div>
                                    </ResourceItem>
                                  );
                                }}
                              />
                              }
                            </Card>
                          </div>
                          <div className='dashboard-analytics-card'>
                            <Card
                              title={'Sales Velocity'}
                            >
                              <p className='analytics-header-note'>In the last 7 days</p>
                              {/*
                              <div className="analytics-tooltip-container">
                                <Tooltip content={"tooltip content"}>
                                  <Icon source={QuestionMarkMajor} color="base" />
                                </Tooltip>
                              </div>
                              */}
                              <p>How are sales trending on your store.</p>
                              {(
                                //this.state.bulkCacheStatus.complete == false
                                !this.state.bulkCacheStatus.complete

                              )
                              ?
                              <EmptyState
                                heading="Caching Sales Velocity"
                                //action={{content: 'Add transfer'}}
                                image="https://dynasort.immersiveecommerce.com/assets/img/dynasort-modal-bg.png"
                              >
                                <p>Once your orders are cached, we'll display sales velocity here.</p>
                              </EmptyState>
                              :
                              (!this.state.analytics.salesVelocity.loaded) ?
                              <div className='analytics-loading'>
                                <p class="Polaris-DisplayText Polaris-DisplayText--sizeSmall">Loading Sales Velocity</p>
                                <Spinner size='large' />
                              </div>
                              :
                              <Chart
                                options={this.state.salesVelocityChart.options}
                                series={this.state.salesVelocityChart.series}
                                type="line"
                                width="100%"
                                height="300px"
                              />
                              }
                            </Card>
                          </div>
                        </Layout.Section>
                        <Layout.Section secondary>
                          <h1 class="Polaris-Header-Title">Knowledgebase</h1>
                          <div class="dashboard-secondary-card">
                            <Card
                              //title={'adfasdf'}
                            >
                              <ResourceList
                                resourceName={{singular: 'post', plural: 'posts'}}
                                items={[
                                  {
                                    id: '1',
                                    title: 'Quick start video guide',
                                    type: 'video',
                                    slug: '_Apmr1BJEW0',
                                  },
                                  {
                                    id: '2',
                                    title: 'Understanding Attributes',
                                    type: 'video',
                                    slug: 'ggf1EDRh77A',
                                  },
                                  {
                                    id: '3',
                                    title: 'Building Metric Sets',
                                    type: 'video',
                                    slug: 'qc5cmxhGEd0',
                                  },
                                  {
                                    id: '4',
                                    title: 'Sort collections using inventory',
                                    type: 'video',
                                    slug: 'iLiwx_pUjFs',
                                  },
                                ]}
                                renderItem={(item) => {
                                  const {id, title, type, slug} = item;

                                  return (
                                    <ResourceItem
                                      id={id}
                                      title={title}
                                      accessibilityLabel={`View details for ${title}`}
                                      type={type}
                                      slug={slug}
                                    >
                                      <div className='kb-icon'>
                                        <Icon source={PlayCircleMajor} color="base" />
                                      </div>
                                      <div className='analytics-title'>
                                        {title}
                                      </div>
                                      <div className='analytics-data'>
                                        <Link onClick={() => {this.showKBModal(true,title,type,slug)}}>View</Link>
                                      </div>
                                    </ResourceItem>
                                  );
                                }}
                              />
                              <Button
                              onClick={() => {this.setState({activeTab:8})}}
                              >View all help</Button>
                            </Card>
                          </div>
                          <div class="dashboard-secondary-card  top-margin padding-bottom">

                            <Card
                            title={'Need more help getting started?'}
                            >
                              <p><Link onClick={() => {this.openChatWindow()}}>Chat with us now</Link></p>
                              <p><Link onClick={() => {this.openCalendar()}}>Schedule training session</Link></p>
                              
                            </Card>
                          </div>
                          {/*
                          <h1 class="Polaris-Header-Title top-margin">What's New</h1>
                          <div class="dashboard-secondary-card">
                            <Card
                              //title={'adfasdf'}
                            >
                              <ResourceList
                                resourceName={{singular: 'post', plural: 'posts'}}
                                items={this.state.newsItems}
                                renderItem={(item) => {
                                  const {index, id, title, body_html} = item;

                                  return (
                                    <ResourceItem
                                      id={id}
                                      title={title}
                                      accessibilityLabel={`View details for ${title}`}
                                      //type={type}
                                      //url={url}
                                    >
                                      <div className='kb-icon'>
                                      <Icon source={TextBlockMajor} color="base" />
                                      </div>
                                      <div className='analytics-title'>
                                        {title}
                                      </div>
                                      <div className='analytics-data'>
                                        <Link onClick={() => this.viewNews(item)}>View</Link>
                                      </div>
                                    </ResourceItem>
                                  );
                                }}
                              />
                            </Card>
                          </div>
                          */}
                        </Layout.Section>
                      </Layout>
                    </Page>
                  </Layout.Section>
                </div>
                <div className={'issues-overview issues-padding '+(this.state.displayCollectionIssues && this.state.displayCollectionIssues == 'all' && this.state.activeTab == 0 ? 'show':'hide')}>
                  <Page
                    title={'All Collection Issues'}
                    breadcrumbs={[{content: 'Dashboard', onAction:()=>{this.displayCollectionIssues(false,'all')}}]}
                  >
                    <div className='dashboard-issues-card-all'>
                      <Card
                        title={'Active issues found in your collections.'}
                      >
                        <p class={'card-paragraph'}>These issues lower your conversion rates &amp; customer experience and need attention. </p>

                        <div className='dashboard-issues-header'>
                          <div className='dashboard-issues-header-container'>
                            <div>Collection</div>
                            <div></div>
                            <div>Issues</div>
                            <div>Track</div>
                            <div></div>
                            <div>Details</div>
                          </div>
                        </div>
                        <ResourceList
                          resourceName={{singular: 'issue', plural: 'issues'}}
                          items={this.state.collectionIssues.items || []}
                          renderItem={(item,index) => {
                            //const {id, title, severity, topIssue, type} = item;
                            const {collection_id,title} = item;

                            return (
                              <ResourceItem
                                id={item.collection_id}
                                //title={title}
                                accessibilityLabel={`View details for ${item.title}`}
                                //topIssue={topIssue}
                                //severity={severity}
                                //type={type}
                              >
                                <div className={(parseInt(item.ignored) == 0 ? 'tracked':'ignored')}>
                                  <h4>{(item.title) ? item.title.replace('u0026','&'):''}</h4>
                                  <small>{item.metrics_name}</small>
                                </div>
                                <div className={(parseInt(item.ignored) == 0 ? 'tracked':'ignored')}>
                                  {(parseInt(item.enabled) > 0)?<Badge status="success">On</Badge>:<Badge status="">Off</Badge>}
                                </div>                                
                                <div className={(parseInt(item.ignored) == 0 ? 'tracked':'ignored')}>
                                  {
                                    item.hasOwnProperty('critical') ? (item.critical.hasOwnProperty('products_sold_out') && parseInt(item.ignored) == 0 ? <Badge status={'critical'}>Sold out products</Badge>:''):''
                                  }          
                                  {
                                    item.hasOwnProperty('critical') ? (item.critical.hasOwnProperty('full_size_run_broken')&& parseInt(item.ignored) == 0 ? <Badge status={'critical'}>Broken size runs</Badge>:''):''
                                  }
                                  {
                                    item.hasOwnProperty('warning') ? (item.warning.hasOwnProperty('low_product_count') && parseInt(item.ignored) == 0 ? <Badge status={'warning'}>Low product count</Badge>:''):''
                                  }          
                                  {
                                    item.hasOwnProperty('warning') ? (item.warning.hasOwnProperty('low_stock') && parseInt(item.ignored) == 0? <Badge status={'warning'}>Low quantity items</Badge>:''):''
                                  }
                                </div>
                                <div className={(parseInt(item.ignored) == 0 ? 'tracked':'ignored')}>
                                  <ButtonGroup segmented spacing='extraTight'>
                                    <Button 
                                    size='slim' 
                                    primary={(parseInt(item.ignored) == 0)}
                                    onClick={() => this.toggleIssuesTracking(0,item.collection_id,index)}
                                    >Track</Button>
                                    <Button 
                                    size='slim' 
                                    primary={(parseInt(item.ignored) == 1)}
                                    onClick={() => this.toggleIssuesTracking(1,item.collection_id,index)}
                                    >Ignore</Button>
                                  </ButtonGroup>
                                </div>
                                <div className={(parseInt(item.ignored) == 0 ? 'tracked':'ignored')}></div>
                                <div className={(parseInt(item.ignored) == 0 ? 'tracked':'ignored')}>
                                  {
                                    (parseInt(item.ignored) == 0)?
                                    <Link onClick={() => this.displayCollectionIssues(item.collection_id,index)}>Details</Link>
                                    :
                                    ''
                                  }
                                </div>
                              </ResourceItem>
                            );
                          }

                        }
                        />     
                      </Card>
                    </div>
                  </Page>
                </div>
                <div className={'issues-single issues-padding '+(this.state.displayCollectionIssues != 'undefined' && this.state.displayCollectionIssues != 'all'  && this.state.activeTab == 0 && this.state.issueCollectionCurrent.collection_id != false && this.state.issueCollectionCurrent.collection_id ? 'show':'hide')}>
                  <Page
                  //displayCollectionIssues
                  //title={'Collection Issues For '+(this.state.collectionIssues.items[this.state.displayCollectionIssues].title || '')}
                  title={'Collection Issues For '+(this.state.issueCollectionCurrent.hasOwnProperty('title') ? this.state.issueCollectionCurrent.title.replace('u0026','&'):'')}
                  breadcrumbs={[{content: 'Collection Issues', onAction:()=>{this.displayCollectionIssues('all',0)}}]}
                  >
                    <div className='issues-single-overview'>   
                      <div className='issues-single-header'>
                        <Link url={'https://'+storeUrl+'/admin/collections/'+this.state.issueCollectionCurrent.collection_id} external>{'https://'+storeUrl+'/admin/collections/'+this.state.issueCollectionCurrent.collection_id}</Link>           
                      </div>
                      <Card
                        title="Overview"
                        >
                          <div className={'issues-single-loading '+(this.state.singleIssueLoading ? 'show':'hide')}>
                            <div className={'analytics-loading '}>
                              <p class="Polaris-DisplayText Polaris-DisplayText--sizeSmall">Loading Collection Details</p>
                              <Spinner size='large' />
                            </div>
                          </div>
                          <div className={'issues-single-badge-container '+(this.state.singleIssueLoading ? 'hide':'show')}>
                            {
                              //JSON.stringify(this.state.issueCollectionCurrent)
                              //{"collection_id":405382168809,"title":"Backpacks Mission Series","ignored":"0","warning":{"low_product_count":5}}
                              (this.state.issueCollectionCurrent.hasOwnProperty('warning'))?
                                (this.state.issueCollectionCurrent.warning.hasOwnProperty('low_product_count')) ?
                                <Badge status="warning">Low Product Count ({this.state.issueCollectionCurrent.warning.low_product_count})</Badge>
                                :
                                ''
                              :
                              ''

                            }
                          </div>
                          <div className={'issues-single-grid warning '+(this.state.singleIssueLoading ? 'hide':'show')}>
                            {this.state.singleCollectionIssuesProducts.map(function(product, i){
                              return (i < 8) ? <div className={'issues-product '+(product.data.class)}>
                              <div className='issues-product-image'>
                                {
                                  (product.data.image != '')?
                                  <img src={product.data.image} alt="Title here" />
                                  :
                                  <img src="https://dynasort.immersiveecommerce.com/assets/img/placeholder.png" alt="Title here" />
                                }
                              </div>
                              <div className='issues-product-title'>
                                <Link url={'https://'+storeUrl+'/admin/products/'+product.data.product_id} external>{product.data.title}</Link>
                              </div>
                              <div className='issues-product-meta'>
                                {/*
                                <div className='issues-product-meta-item'>
                                  <label>Effectiveness:</label><span>{product.data.effectiveness}%</span>
                                </div>
                                <div className='issues-product-meta-item'>
                                  <label>Change:</label><span>{parseInt(product.data.change) > 0 ? '+':''}{product.data.change}</span>
                                </div>
                                */}
                              </div>
                              <div className='issues-product-issues'>
                                {
                                  (product.data.sold_out ?                                 
                                <div className='issues-product-issue'>
                                  <Badge status="critical">Sold out</Badge>
                                </div>
                                :'')
                                }
                                {
                                  (product.data.full_size_run_broken ?                                 
                                <div className='issues-product-issue'>
                                  <Badge status="critical">Broken size run</Badge>
                                  <small>{(product.data.full_size_run_broken.sizes.length == 1)? <s>{product.data.full_size_run_broken.sizes[0]}</s> : (product.data.full_size_run_broken.sizes.map(function(size, i){return <s>{size}</s>}))}</small>
                                </div>
                                :'')
                                }
                                {
                                  (product.data.low_stock ?                                 
                                <div className='issues-product-issue'>
                                  <Badge status="warning">Low stock ({product.data.low_stock} avg.)</Badge>
                                </div>
                                :'')
                                }
                              </div>
                            </div>
                            :
                            ''
                            })}
                            {(this.state.singleCollectionIssuesProducts.length > 8)?
                              <div className='issues-fold'><span>fold</span></div>
                            :
                            ''
                            }
                            {this.state.singleCollectionIssuesProducts.map(function(product, i){
                              return (i >= 8) ? <div className={'issues-product '+(product.data.class)}>
                              <div className='issues-product-image'>
                                {
                                  (product.data.image != '')?
                                  <img src={product.data.image} alt="Title here" />
                                  :
                                  <img src="https://dynasort.immersiveecommerce.com/assets/img/placeholder.png" alt="Title here" />
                                }
                              </div>
                              <div className='issues-product-title'>
                                <Link url={'https://'+storeUrl+'/admin/products/'+product.data.product_id} external>{product.data.title}</Link>
                              </div>
                              <div className='issues-product-meta'>
                                {/*
                                <div className='issues-product-meta-item'>
                                  <label>Effectiveness:</label><span>{product.data.effectiveness}%</span>
                                </div>
                                <div className='issues-product-meta-item'>
                                  {JSON.stringify(product.data.change)}<br />
                                  <label>Change:</label><span>{parseInt(product.data.change) > 0 ? '+':''}{product.data.change}</span>
                                </div>
                                */}
                              </div>
                              <div className='issues-product-issues'>
                                {
                                  (product.data.sold_out ?                                 
                                <div className='issues-product-issue'>
                                  <Badge status="critical">Sold out</Badge>
                                </div>
                                :'')
                                }
                                {
                                  (product.data.full_size_run_broken ?                                 
                                <div className='issues-product-issue'>
                                  <Badge status="critical">Broken size run</Badge>
                                  <small>{(product.data.full_size_run_broken.sizes.length == 1)? <s>{product.data.full_size_run_broken.sizes[0]}</s> : (product.data.full_size_run_broken.sizes.map(function(size, i){return <s>{size}</s>}))}</small>
                                </div>
                                :'')
                                }
                                {
                                  (product.data.low_stock ?                                 
                                <div className='issues-product-issue'>
                                  <Badge status="warning">Low stock ({product.data.low_stock} avg.)</Badge>
                                </div>
                                :'')
                                }
                              </div>
                            </div>
                            :
                            ''
                            })}
                          </div>
                          <div className={'issues-footer-container '+(this.state.singleIssueLoading ? 'hide':'show')}>
                            <Card.Section>
                              <div class="issues-footer">Showing {(this.state.singleCollectionIssuesProductsTotal > this.state.singleCollectionIssuesProducts.length ? 'first ':'')} {this.state.singleCollectionIssuesProducts.length} of {this.state.singleCollectionIssuesProductsTotal} products</div>
                            </Card.Section>
                          </div>
                      </Card>
                    </div>
                  </Page>
                </div>
                <div className={"iec-tabbed-content top-padding "+((this.state.activeTab == 8) ? 'show':'hide')}>
                  <Page>
                    <Layout.AnnotatedSection
                      id="help-quickstart"
                      title="Quickstart Guide"
                      description="Get your first collection setup in seconds"
                    >
                      <Card sectioned
                        //title="Three Quick Steps"
                      >      
                      <p>Getting started only takes a moment, follow the steps below, or watch the video.</p>
                      <p class="help-video"><Link monochrome onClick={() => this.watchVideo('quick-start')}><Icon source={PlayCircleMajor} color="base" /> Watch Quick Start Video</Link></p>
                      <ol className='quickstart-ol-list'>
                        <li>
                          <h4>Review Metrics</h4>
                          <p>In the Metrics tab, review the weighted values for your DynaSort Default Metrics. Add or remove attributes,  and change weighted values accordingly.</p>
                        </li>
                        <li>
                          <h4>Enable a Collection</h4>
                          <p>In the Collections tab, find a collection of your choice and click "Enable" under the Status column.</p>
                        </li>
                        <li>
                          <h4>Turn Dynasort On</h4>
                          <p>At the top right of your screen, click the "Off" badge and select "Turn On" when prompted.</p>
                        </li>
                      </ol>
                      <p>Great work! Note the clock icon at the top right of your screen. Hovering over this icon displays the queued time for your next collection sorting.</p>
                      </Card>
                    </Layout.AnnotatedSection> 
                    {/*
                    <Layout.AnnotatedSection
                      id="help-faqs"
                      title="Frequently Asked Questions"
                      description="You got questions? We got answers."
                    >
                      <Card sectioned
                        //title="Title"
                      >      
                      <ul className='help-faqs'>
                        <li onClick={() => {this.toggleHelpItem('faqs',0)}}>
                          <h4>
                            Question
                            <Icon source={(this.state.helpItemsOpen.faqs[0]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                          </h4>
                          <Collapsible
                            open={this.state.helpItemsOpen.faqs[0]}
                            id="help-faqs-0"
                            transition={helpTransition}
                            expandOnPrint
                          >
                            <p>Answer here</p>
                          </Collapsible>
                        </li>
                        <li onClick={() => {this.toggleHelpItem('faqs',1)}}>
                          <h4>
                            Question
                            <Icon source={(this.state.helpItemsOpen.faqs[1]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                          <Collapsible
                            open={this.state.helpItemsOpen.faqs[1]}
                            id="help-faqs-1"
                            transition={helpTransition}
                            expandOnPrint
                          >
                            <p>Answer here</p>
                          </Collapsible>
                        </li>
                      </ul>
                      </Card>
                    </Layout.AnnotatedSection> 
                    */}
                    {/*
                    <Layout.AnnotatedSection
                      id="help-grades"
                      title="Collection Evaluation"
                      description="Identify Opportunities For Improvement"
                    >
                      <Card sectioned
                        title="Title"
                      >      
                      Content
                      </Card>
                    </Layout.AnnotatedSection>
                    */}
                    <Layout.AnnotatedSection
                      id="help-attributes"
                      title="Attributes"
                      description="Defining Data for Success"
                    >
                      <Card sectioned
                        //title="Title"
                      >      
                        <p>Attributes are how we define product data.</p>
                        <p class="help-video" style={{left:'140px'}}><Link monochrome onClick={() => this.watchVideo('attributes')}><Icon source={PlayCircleMajor} color="base" /> Watch Training Video</Link></p>
                        <ul className='help-dropdown-items'>
                        <li onClick={() => {this.toggleHelpItem('attributes',0)}}>
                            <h4>Status
                            <Icon source={(this.state.helpItemsOpen.attributes[0]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.attributes[0]}
                              id="help-attributes-0"
                              transition={helpTransition}
                              expandOnPrint
                            >
                              <p>Product Data Attributes are activated by default. By clicking the "..." you may activate or deactivate an attribute to be used in sorting calculations globally.</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('attributes',1)}}>
                            <h4>Min and Max Values
                            <Icon source={(this.state.helpItemsOpen.attributes[1]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.attributes[1]}
                              id="help-attributes-1"
                              transition={helpTransition}
                              expandOnPrint
                            >
                              <p>Range data attributes have an upper and lower limit. Below the Min value, no points will be given in calculations. Above the Max value, total points will be given. Product values between the two will be assigned partial points according to the product value.</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('attributes',2)}}>
                            <h4>Quantity
                            <Icon source={(this.state.helpItemsOpen.attributes[2]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.attributes[2]}
                              id="help-attributes-2"
                              transition={helpTransition}
                              expandOnPrint
                            >                            
                              <p>The total inventory quantity for all variants of a product.</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('attributes',3)}}>
                            <h4>Full Size Run
                            <Icon source={(this.state.helpItemsOpen.attributes[3]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.attributes[3]}
                              id="help-attributes-3"
                              transition={helpTransition}
                              expandOnPrint
                            >                            
                              <p>Define a variant title to calculate size availability.</p>
                              <p>If the product has one variant or more in all sizes available the product will be awarded this value, if not, this value will not be awarded.</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('attributes',4)}}>
                            <h4>Age of Newest Variant
                            <Icon source={(this.state.helpItemsOpen.attributes[4]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.attributes[4]}
                              id="help-attributes-4"
                              transition={helpTransition}
                              expandOnPrint
                            >                            
                              <p>This is based upon the last published variant of a product.</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('attributes',5)}}>
                            <h4>Sales                           
                            <Icon source={(this.state.helpItemsOpen.attributes[5]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.attributes[5]}
                              id="help-attributes-5"
                              transition={helpTransition}
                              expandOnPrint
                            >                            
                              <p>Sales values include how many times a product has been sold in the last number of days.</p>
                              <p>These data values are inclusive, e.g. a product sale from 15 days ago would be included in both the 30 day and 60 day Attributes.</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('attributes',6)}}>
                            <h4>Product Margin
                            <Icon source={(this.state.helpItemsOpen.attributes[6]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.attributes[6]}
                              id="help-attributes-6"
                              transition={helpTransition}
                              expandOnPrint
                            >                            
                              <p>Values are percentage points.</p>
                              <p>Product margin is calculated by the average margin of the product's variants. ((Price - Cost)/Price)</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('attributes',7)}}>
                            <h4>Sold Out
                            <Icon source={(this.state.helpItemsOpen.attributes[7]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.attributes[7]}
                              id="help-attributes-7"
                              transition={helpTransition}
                              expandOnPrint
                            >                            
                              <p>Whether or not a product has less than one in stock for all the product's variants.</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('attributes',8)}}>
                            <h4>On Sale
                            <Icon source={(this.state.helpItemsOpen.attributes[8]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.attributes[8]}
                              id="help-attributes-8"
                              transition={helpTransition}
                              expandOnPrint
                            >
                              <p>Whether or not a product has one or more variants with a compare at price listed above the selling price.</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('attributes',9)}}>
                            <h4>Adding Custom Attributes
                            <Icon source={(this.state.helpItemsOpen.attributes[9]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.attributes[9]}
                              id="help-attributes-9"
                              transition={helpTransition}
                              expandOnPrint
                            >                            
                            <p>Custom Attributes for Metrics Sets may be added for Product Tag, Metafields, Product Titles, Vendors, and Product Types.</p>
                            <p>Boolean values may be set to match the Attribute Value if the value contains, does not contain, equals, does not equal, or starts with the value.</p>
                            <p><em>Note: </em>Matches are case insensitive.</p>
                            <p><em>Note: </em>Custom Attributes are not activated by default.</p>
                            </Collapsible>
                          </li>
                        </ul>
                      </Card>
                    </Layout.AnnotatedSection>
                    <Layout.AnnotatedSection
                      id="help-metrics"
                      title="Metrics"
                      description="Setting Up Outstanding Rulesets"
                    >
                      <Card sectioned
                        //title="Title"
                      >      
                        <p>Metrics are like a sorting algorithm that you define.</p>
                        <p class="help-video" style={{left:'115px'}}><Link monochrome onClick={() => this.watchVideo('metrics')}><Icon source={PlayCircleMajor} color="base" /> Watch Training Video</Link></p>
                        <ul className='help-dropdown-items'>
                          <li onClick={() => {this.toggleHelpItem('metrics',0)}}>
                            <h4>Attribute Values
                            <Icon source={(this.state.helpItemsOpen.metrics[0]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.metrics[0]}
                              id="help-metrics-0"
                              transition={helpTransition}
                              expandOnPrint
                            >                            
                              <p>This assigns the weighted values for a metrics set based upon the attributes you setup in the Attributes tab.</p>
                              <p><em>Note: </em>Negative values are allowed here, effectively penalizing matching products and moving them down in the collection order.</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('metrics',1)}}>
                            <h4>Product Boost
                            <Icon source={(this.state.helpItemsOpen.metrics[1]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.metrics[1]}
                              id="help-metrics-1"
                              transition={helpTransition}
                              expandOnPrint
                            >                               
                              <p>Toggle on and off whether product boost values are applied to the sorting.</p>
                              <p>Product boost values are set under the Products tab, and are set globally across all Metrics Sets and Collections on a per product basis.</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('metrics',2)}}>
                            <h4>Default Metric
                            <Icon source={(this.state.helpItemsOpen.metrics[2]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.metrics[2]}
                              id="help-metrics-2"
                              transition={helpTransition}
                              expandOnPrint
                            >                               
                              <p>Enabling a Metrics Set as the default will change all collections using the previous default Metrics Set to this Metrics Set.</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('metrics',3)}}>
                            <h4>Viewing Product Scores
                            <Icon source={(this.state.helpItemsOpen.metrics[3]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.metrics[3]}
                              id="help-metrics-3"
                              transition={helpTransition}
                              expandOnPrint
                            >                               
                              <p>By clicking "View Product Scores" you may jump to the Products tab to view collection sort order and product data values for collections sorted with this Metrics Set.</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('metrics',4)}}>
                            <h4>Sold Out Items
                            <Icon source={(this.state.helpItemsOpen.metrics[4]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.metrics[4]}
                              id="help-metrics-4"
                              transition={helpTransition}
                              expandOnPrint
                            >                               
                              <p>Enabling this will automatically move all products that are sold out to the bottom of the collection order each time the collection is sorted.</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('metrics',5)}}>
                            <h4>Tie Breaker
                            <Icon source={(this.state.helpItemsOpen.metrics[5]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.metrics[5]}
                              id="help-metrics-5"
                              transition={helpTransition}
                              expandOnPrint
                            >                               
                              <p>In case two or more products are calculated with the same number of points, the tie breaker value will control the order of the aforementioned products.</p>
                            </Collapsible>
                          </li>
                        </ul>
                      </Card>
                    </Layout.AnnotatedSection> 
                    <Layout.AnnotatedSection
                      id="help-collections"
                      title="Collections"
                      description="Automating Collection Merchandising"
                    >
                      <Card sectioned
                        //title="Title"
                      >      
                        <ul className='help-dropdown-items'>
                          <li onClick={() => {this.toggleHelpItem('collections',0)}}>
                            <h4>Dynamic vs. Traditional
                              <Icon source={(this.state.helpItemsOpen.collections[0]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.collections[0]}
                              id="help-collections-0"
                              transition={helpTransition}
                              expandOnPrint
                            >                               
                              <p>Dynamic, or Smart, collections are ones where products are included based upon rule sets in the Shopify admin.</p>
                              <p>Traditional, or Custom, collections are ones where products hand selected in the Shopify admin.</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('collections',1)}}>
                            <h4>View Sorting
                            <Icon source={(this.state.helpItemsOpen.collections[1]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.collections[1]}
                              id="help-collections-1"
                              transition={helpTransition}
                              expandOnPrint
                            >                               
                              <p>To view current collection sorting order of products, click "View Sorting" and current sort order with calculated values will display in the Products tab.</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('collections',2)}}>
                            <h4>Metrics
                            <Icon source={(this.state.helpItemsOpen.collections[2]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.collections[2]}
                              id="help-collections-2"
                              transition={helpTransition}
                              expandOnPrint
                            >                               
                              <p>Currently assigned Metrics Set is displayed, clicking on it will allow you to assign a different Metrics Set.</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('collections',3)}}>
                            <h4>Revert To (When Off)
                            <Icon source={(this.state.helpItemsOpen.collections[3]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.collections[3]}
                              id="help-collections-3"
                              transition={helpTransition}
                              expandOnPrint
                            >                               
                              <p>When the Dynasort Status is turned off, or when processing settings are idle as you have defined, you may select a Shopify sort order to revert the collection order sorting.</p>
                              <p><em>Note: </em>Selecting the "Manual" option will leave the current sort order in place until Dynasort is enabled and active, or until manual action is taken in the collection's admin.</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('collections',4)}}>
                            <h4>Status
                            <Icon source={(this.state.helpItemsOpen.collections[4]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.collections[4]}
                              id="help-collections-4"
                              transition={helpTransition}
                              expandOnPrint
                            >                               
                              <p>Collections may be enabled or disabled in Dynasort, and sorting calculations will be applied at the next sorting interval.</p>
                            </Collapsible>
                          </li>
                        </ul>
                      </Card>
                    </Layout.AnnotatedSection> 
                    <Layout.AnnotatedSection
                      id="help-products"
                      title="Products"
                      description="Viewing Collection Sorting in Action"
                    >
                      <Card sectioned
                        //title="Title"
                      >      
                        <ul className='help-dropdown-items'>
                          <li onClick={() => {this.toggleHelpItem('products',0)}}>
                            <h4>Metrics and Collections Selection
                            <Icon source={(this.state.helpItemsOpen.products[0]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.products[0]}
                              id="help-products-0"
                              transition={helpTransition}
                              expandOnPrint
                            >                              
                              <p>The Metrics dropdown will toggle between metrics sets and populate the Collections dropdown with ones assigned to this metrics set.</p>
                              <p>Selecting a Collection will populate it's products and calculations data below.</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('products',1)}}>
                            <h4>Sync Now
                            <Icon source={(this.state.helpItemsOpen.products[1]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.products[1]}
                              id="help-products-1"
                              transition={helpTransition}
                              expandOnPrint
                            >                              
                              <p>Click "Sync Now" to push the current sort order to the live Shopify collection immediately.</p>
                              <p><em>Note: </em>Sync Now is only available on Pro and Enterprise plans.</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('products',2)}}>
                            <h4>Download as CSV
                            <Icon source={(this.state.helpItemsOpen.products[2]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.products[2]}
                              id="help-products-2"
                              transition={helpTransition}
                              expandOnPrint
                            >                              
                              <p>Export current product data, order, and caculations values in CSV format.</p>
                              <p><em>Note: </em>Exports are only available on Pro and Enterprise plans.</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('products',3)}}>
                            <h4>Product Boost
                            <Icon source={(this.state.helpItemsOpen.products[3]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.products[3]}
                              id="help-products-3"
                              transition={helpTransition}
                              expandOnPrint
                            >                              
                              <p>Product boost values may be used to promote or demote specific products throughout your collections. Product boost is assigned globally across Metrics Sets and Collections on a per product basis.</p>
                              <p><em>Note: </em>Product Boost is only available on Pro and Enterprise plans.</p>
                            </Collapsible>
                          </li>
                          <li onClick={() => {this.toggleHelpItem('products',4)}}>
                            <h4>Value Columns
                            <Icon source={(this.state.helpItemsOpen.products[4]? ChevronUpMinor:ChevronDownMinor)} color="base" />
                            </h4>
                            <Collapsible
                              open={this.state.helpItemsOpen.products[4]}
                              id="help-products-4"
                              transition={helpTransition}
                              expandOnPrint
                            >                              
                              <p>For each attribute calculated in the Metrics Set, there are corresponding value columns. The top (bold) value is the point value awared to the product, and the bottom value is the maximum number of points assigned to the attribute in the Attributes tab.</p>
                            </Collapsible>
                          </li>
                        </ul>
                      </Card>
                    </Layout.AnnotatedSection> 
                  </Page>
                </div>
                <div className={"iec-tabbed-content "+((this.state.activeTab == 2) ? 'show':'hide')}>
                  <Layout.Section>
                      <div className={'tab-parent-page '+(this.state.displayManagedCollection ? 'hide':'show')}>                     
                      <Page
                        title={'Managed Collections'}
                        primaryAction={
                          <Button
                            primary
                            onClick={()=>{this.createManagedCollection()}}
                            disabled={(this.state.managedCount >= this.state.init.permissions.managed)}
                          >
                            Create Managed Collection
                          </Button>
                        }
                      >
                        <div className='metrics-info'>
                          <p>Create collections with advanced conditions that automatically update included products.</p>
                          <div className='metrics-count-status'>
                            {this.state.managedCollections.length }/{this.state.init.permissions.managed} Created
                            <div className="inline-tooltip-container">
                              <Tooltip content={this.state.init.current_plan + " Plan allows for "+this.state.init.permissions.metrics+" managed collections"}>
                                <Icon source={QuestionMarkMajor} color="base" />
                              </Tooltip>
                            </div>
                          </div>                          
                        </div>
                        <div className="top-card-padding metrics-tab">
                          <Card>
                            <Card.Section>
                            <ResourceList
                                resourceName={{singular: 'managed collection', plural: 'managed collections'}}
                                items={this.state.managedCollections || []}
                                //shortcutActions={shortcutActions}
                                emptyState={
                                  (
                                   !this.state.managedCollections.length
                                  )?
                                    <EmptyState 
                                    heading={(this.state.managedFilterQueryValue == '' ? "No Managed Collections Created":"No Matching Managed Collections")}
                                    >
                                    <Icon
                                      source={CollectionsMajor}
                                      color="base"
                                    />
                                      <p style={{ marginBottom: 20 }}>Why not create one today?</p>
                                      <Button
                                        primary
                                        onClick={()=>{this.createManagedCollection()}}
                                        disabled={(this.state.managedCount >= this.state.init.permissions.managed)}
                                      >
                                        Create
                                      </Button>
                                    </EmptyState>
                                  :
                                  (
                                    this.state.collectionsResourceItems.length
                                  )?
                                  <EmptyState 
                                  heading="No Managed Collections Found"
                                  >
                                    <Icon
                                      source={CollectionsMajor}
                                      color="base"
                                    />
                                    <p style={{ marginBottom: 20 }}>No matching managed collections found.</p>
                                  </EmptyState>
                                  :
                                  undefined
                                }
                                filterControl={(
                                  <div className="managed-header-container">
                                    <Filters
                                      queryValue={this.state.managedFilterQueryValue}
                                      filters={[]}
                                      //appliedFilters={appliedFilters}
                                      onQueryChange={(value) => {this.managedFilterChangeQueryValue(value)}}
                                      onQueryClear={(value) => {this.managedFilterChangeQueryValue('')}}
                                      //onClearAll={() => console.log('Todo: implement onClearAll')}
                                    >
                                    <div className="sort-popover-container" style={{paddingLeft: '8px'}}>
                                      
                                      <Button onClick={() => {this.togglePopover('managed')}}><Icon source={SortMinor} color="base" />Sort</Button>
                                      <div className={"sort-popover "+(this.state.popoverFilters.managed.show? 'show':'hide')}>
                                        <ChoiceList
                                          //title="Company name"
                                          choices={[
                                            {label: 'Title A-Z', value: 'name-asc'},
                                            {label: 'Title Z-A', value: 'name-desc'},
                                            {label: 'Date (Newest first)', value: 'date-asc'},
                                            {label: 'Date (Oldest first)', value: 'date-desc'},
                                          ]}
                                          selected={this.state.popoverFilters.managed.value}
                                          onChange={(value) => {this.changePopover(value,'managed')}}
                                        />
                                      </div>
                                    </div>
                                    </Filters>
                                    <div className="resource-list-headings">
                                      <div className="resource-list-heading-item rlhm-2">
                                        <h3>Title</h3>
                                      </div>
                                      <div className="resource-list-heading-item rlhm-3">
                                        <h3>Products</h3>
                                      </div>
                                      <div className="resource-list-heading-item rlhm-4">
                                        <h3>Metrics</h3>
                                      </div>
                                      <div className="resource-list-heading-item rlhm-5">
                                        <h3></h3>
                                      </div>
                                      <div className="resource-list-heading-item rlhm-6">
                                        <h3>Conditions</h3>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                  //persistActions
                                  renderItem={(item,index) => {
                                  const {
                                    id,
                                    title, 
                                    conditions,
                                    conditions_display,
                                    product_count,
                                    metrics,
                                    enabled,
                                  } = item;
                                  let managedShortcutActions = [{content:'Edit',onAction:(e)=>{this.editManaged(id,index)}}];


                                  return (
                                    <ResourceItem
                                      id={id}
                                      //url={url}
                                      //media={media}
                                      accessibilityLabel={`View details for ${title}`}
                                      //shortcutActions={metricShortcutActions}
                                      persistActions
                                      onClick={() => {this.editManaged(id,index)}}
                                      //className={"url-resource-item "+((enable) ? 'url-resource-item-disabled':'')}
                                    >
                                      <div className="resource-item-col managed-resource-item-col managed-resource-item-col-2">
                                        <h3>
                                          <TextStyle variation="strong">{title}</TextStyle>
                                        </h3>
                                      </div>
                                      <div className="resource-item-col managed-resource-item-col managed-resource-item-col-3">
                                        <h3>
                                          {product_count}
                                        </h3>
                                      </div>
                                      <div className="resource-item-col managed-resource-item-col managed-resource-item-col-4">
                                        {metrics}
                                      </div>
                                      <div className="resource-item-col managed-resource-item-col managed-resource-item-col-5">
                                        {enabled == "1"? <Badge status="success">On</Badge>:<Badge>Off</Badge>}
                                      </div>
                                      <div className="resource-item-col managed-resource-item-col managed-resource-item-col-6">
                                        <ul className="metric-attribute-list">
                                        {
                                        (conditions_display)?
                                          conditions_display.map(function(item, i){
                                            if(i < 3){
                                              //return <li key={i}><small>{item.select.value} ({item.value.charAt(0).toUpperCase() + item.value.replace('-',' ').slice(1)})</small></li>
                                              return <li key={i}>
                                                <small>{item}</small>
                                              </li>
                                            } else {
                                              return;
                                            }
                                          })
                                          :
                                          ''
                                        }
                                        {conditions_display.length > 3 ? <li className='metrics-and-more'><small>...and {conditions_display.length - 3} more</small></li>:''}
                                        </ul>
                                      </div>
                                    </ResourceItem>
                                  );
                                }}
                              />
                              <div className='pagination-container'>
                                <Pagination
                                  //hasPrevious
                                  onPrevious={() => {
                                    //console.log('Previous');
                                  }}
                                  //hasNext
                                  onNext={() => {
                                    //console.log('Next');
                                  }}
                                />
                              </div>
                            </Card.Section>                         
                          </Card>
                        </div>
                      </Page>
                    </div>
                    <div className={'create-page '+(this.state.displayManagedCollection ? 'show':'hide')}>
                      <Page
                        title={this.state.managedBeingEdited.title == '' ? 'Create Managed Collection':this.state.managedBeingEdited.title}
                        //breadcrumbs={(this.state.saveBar.show ? []:[{content: 'Managed', onAction:()=>{console.log('save it')}}])}
                        breadcrumbs={(this.state.saveBar.show ? []:[{content: 'Managed', onAction:()=>{this.setState({displayManagedCollection:false,managedBeingEdited:blankManagedBeingEdited})}}])}
                      >
                        <div className="top-card-padding">
                          <div className='metrics-top-actions'>
                            <Button
                            plain
                            monochrome
                            removeUnderline
                            //onClick={() => console.log('show it in admin')}
                            url={'https://'+storeUrl+'/admin/collections/'+this.state.managedBeingEdited.id}
                            disabled={(parseInt(this.state.managedBeingEdited.id) > 0 ? false:true)}
                            external
                            >
                              Edit In Shopify Admin
                            </Button>
                            <Button
                            plain
                            monochrome
                            removeUnderline
                            onClick={() => {this.viewSorting(this.state.managedBeingEdited.metricsId,this.state.managedBeingEdited.id)}}
                            disabled={(parseInt(this.state.managedBeingEdited.doSort) == 0 || parseInt(this.state.managedBeingEdited.id) == 0 || this.state.saveBar.show)?true:false}
                            >View Sorting</Button>
                                 
                          </div>
                          <Grid>
                            <Grid.Cell columnSpan={{xs: 6, sm: 6, md: 6, lg: 8, xl: 8}}>
                              <Card sectioned>
                                <Card.Section>
                                  <p>
                                    <TextField
                                      label="Title"
                                      value={this.state.managedBeingEdited.title}
                                      //(isNew,index=false,key,value)
                                      onChange={(value) => { this.editManagedObject(true,false,'title',value);}}
                                      autoComplete="off"
                                      //labelHidden
                                    />
                                  </p>
                                  </Card.Section>
                                  <Card.Section>
                                    <div className='managed-conditions-boolean'>
                                      <ChoiceList
                                        title="Products must match:"
                                        choices={[
                                          {label: 'all conditions', value: 'all'},
                                          {label: 'any condition', value: 'any'},
                                        ]}
                                        selected={this.state.managedBeingEdited.boolean}
                                        onChange={(value) => { this.editManagedObject(true,false,'boolean',value);}}
                                        />
                                    </div>
                                  </Card.Section>
                                  <Card.Section>
                                  <div className={'edit-metrics-card-heading'}>
                                    <h4>
                                      Conditions
                                      <div className="inline-tooltip-container">
                                        <Tooltip content={'Assign conditions to filter collection products'}>
                                          <Icon source={QuestionMarkMajor} color="base" />
                                        </Tooltip>
                                      </div>
                                    </h4>
                                  </div>
                                  <div>
                                  {
                                    this.state.managedBeingEdited.conditions.map((item, index) => {
                                      return <div className='managed-condition-row'>
                                              <div className='condition-type'>
                                                <Select 
                                                  label="Type"
                                                  //options={attributeOptionTypes}
                                                  options={conditions || []}
                                                  value={this.state.managedBeingEdited.conditions[index][0]}
                                                  onChange={(value) => { this.changeConditionType(value,index)}}
                                                  labelHidden
                                                />  
                                              </div>
                                              {(
                                                this.state.managedBeingEdited.conditions[index][0] == 'metafield'?
                                                <div className='condition-group standard'>
                                                  <Select 
                                                    label="Namespace"
                                                    //options={attributeOptionTypes}
                                                    options={this.state.managedBeingEdited.metaNamespaces[index] || []}
                                                    //value={item[0].value}
                                                    value={this.state.managedBeingEdited.conditions[index][3]}
                                                    onChange={(value) => { this.changeConditionValue(value,index,3)}}
                                                    //onChange={(value) => { console.log('change')}}
                                                   labelHidden
                                                  /> 
                                                  <Select 
                                                    label="Key"
                                                    //options={attributeOptionTypes}
                                                    options={this.state.managedBeingEdited.metaKeys[index]}
                                                    //value={item[0].value}
                                                    disabled={this.state.managedBeingEdited.conditions[index][3] == ''}
                                                    value={this.state.managedBeingEdited.conditions[index][4]}
                                                    onChange={(value) => { this.changeConditionValue(value,index,4)}}
                                                    //onChange={(value) => { console.log('change')}}
                                                    labelHidden
                                                  />   
                                                  <Select 
                                                    label="Boolean"
                                                    //options={attributeOptionTypes}
                                                    options={conditionBoolean[this.state.managedBeingEdited.conditions[index][1]]}
                                                    //value={item[0].value}
                                                    value={this.state.managedBeingEdited.conditions[index][2]}
                                                    onChange={(value) => { this.changeConditionBoolean(value,index)}}
                                                    labelHidden
                                                  />  
                                                  {(
                                                    this.state.managedBeingEdited.conditions[index][2] != 'is-not-empty'
                                                    &&
                                                    this.state.managedBeingEdited.conditions[index][2] != 'is-empty'
                                                    &&
                                                    this.state.managedBeingEdited.conditions[index][2] != 'exists'
                                                    &&
                                                    this.state.managedBeingEdited.conditions[index][2] != 'does-not-exist'
                                                    &&
                                                    this.state.managedBeingEdited.conditions[index][2] != 'true'
                                                    &&
                                                    this.state.managedBeingEdited.conditions[index][2] != 'false'
                                                  )?
                                                  <TextField
                                                    label="Value"
                                                    value={this.state.managedBeingEdited.conditions[index][5]}
                                                    onChange={(value) => { this.changeConditionValue(value,index,5)}}
                                                    //onChange={(value) => { this.changeConditionMetaValue(value,index,5)}}
                                                    autoComplete="off"
                                                    labelHidden
                                                    //type={'number'}
                                                    //step={1}
                                                  />  
                                                  :
                                                  ''
                                                  }
                                                                                                  
                                                </div>
                                                :
                                                this.state.managedBeingEdited.conditions[index][1] == 'truthy'?
                                                <div className='condition-group standard'>
                                                  <Select 
                                                    label="Boolean"
                                                    //options={attributeOptionTypes}
                                                    options={conditionBoolean[this.state.managedBeingEdited.conditions[index][1]]}
                                                    //value={item[0].value}
                                                    value={this.state.managedBeingEdited.conditions[index][2]}
                                                    onChange={(value) => { this.changeConditionBoolean(value,index)}}
                                                    labelHidden
                                                  />  
                                                </div>
                                                :
                                                <div className='condition-group standard'>
                                                  <Select 
                                                    label="Boolean"
                                                    //options={attributeOptionTypes}
                                                    options={conditionBoolean[this.state.managedBeingEdited.conditions[index][1]]}
                                                    //value={item[0].value}
                                                    value={this.state.managedBeingEdited.conditions[index][2]}
                                                    onChange={(value) => { this.changeConditionBoolean(value,index)}}
                                                    labelHidden
                                                  />  
                                                  {(
                                                    this.state.managedBeingEdited.conditions[index][2] != 'is-not-empty'
                                                    &&
                                                    this.state.managedBeingEdited.conditions[index][2] != 'is-empty'
                                                    &&
                                                    this.state.managedBeingEdited.conditions[index][2] != 'exists'
                                                    &&
                                                    this.state.managedBeingEdited.conditions[index][2] != 'does-not-exist'
                                                    &&
                                                    this.state.managedBeingEdited.conditions[index][2] != 'true'
                                                    &&
                                                    this.state.managedBeingEdited.conditions[index][2] != 'false'
                                                  )?
                                                  <TextField
                                                    label="Value"
                                                    value={this.state.managedBeingEdited.conditions[index][3]}
                                                    onChange={(value) => { this.changeConditionValue(value,index,3)}}
                                                    autoComplete="off"
                                                    labelHidden
                                                    //type={'number'}
                                                    //step={1}
                                                  />
                                                  :
                                                  ''
                                                  }
                                                </div>
                                              )
                                              }

                                              
                                              <Button
                                                onClick={() => {this.removeManagedCondition(index)}}
                                              ><Icon
                                              source={DeleteMajor}
                                              color="base" 
                                              /></Button>
 
                                            </div>
                                    })
                                  }
                                  </div>
                                  <Button 
                                  disabled={(this.state.managedBeingEdited.conditions.length >= this.state.init.permissions.conditions)}
                                  onClick={()=>{this.addManagedCondition();}}>Add {(this.state.managedBeingEdited.conditions.length > 0? 'another':'')} condition</Button>
                                  <p><small>{(this.state.managedBeingEdited.conditions.length? this.state.managedBeingEdited.conditions.length : '0')} / {this.state.init.permissions.conditions} used for {this.state.init.current_plan} plan</small></p>

                                </Card.Section>
                                
                              </Card>
                              <Card
                              title="Collection Products Preview">
                                {
                                  (this.state.managedBeingEdited.product_count > 250)?
                                  <div className='preview-count-note'>Showing 250 of {this.state.managedBeingEdited.product_count} products</div>
                                  :
                                  null
                                  
                                }
                                <div className={'metrics-preview-products'}>
                                  <ResourceList
                                    
                                    resourceName={{singular: 'metric', plural: 'metrics'}}
                                    items={this.state.managedPreviewProducts || []}
                                    emptyState={this.state.managedPreviewProducts == null || !this.state.managedPreviewProducts.length? <EmptyState
                                      heading="Save Managed Collection to Preview Products"
                                    ><p>Once collection is saved above, products will display here.</p></EmptyState>:undefined}
                                    //onSelectionChange={this.setCollectionsSelectedItems}
                                    renderItem={(item) => {
                                      const {
                                        position,
                                        product_id, 
                                        //handle, 
                                        image,
                                        title
                                      } = item;

                                      return (
                                        <ResourceItem
                                          id={product_id}
                                          //url={url}
                                          //media={media}
                                          accessibilityLabel={`View details for ${title}`}
                                          //shortcutActions={shortcutActions}
                                          //persistActions
                                          //className={"url-resource-item "+((enable) ? 'url-resource-item-disabled':'')}
                                        >
                                          <div className="metric-product-item-col managed-num">
                                            {position}.
                                          </div>
                                          <div className="metric-product-item-col">
                                            <Link
                                            url={"https://"+storeUrl+"/admin/products/"+product_id}
                                            external
                                            >
                                            {
                                              (image != '')?
                                                <img src={image} alt={title} />
                                              :
                                                <img src="https://dynasort.immersiveecommerce.com/assets/img/placeholder.png" alt={title} />
                                            }
                                            </Link>
                                          </div>
                                          <div className="metric-product-item-col managed-title">
                                            <Link
                                            url={"https://"+storeUrl+"/admin/products/"+product_id}
                                            external
                                            >
                                            {title}
                                            </Link>
                                          </div>
                                        </ResourceItem>
                                      );
                                    }}
                                  />    
                                </div>       
                              </Card>
                            </Grid.Cell>
                            <Grid.Cell columnSpan={{xs: 6, sm: 6, md: 6, lg: 4, xl: 4}}>
                              <Card title="Settings" sectioned>
                                <Card.Section>
                                  <Checkbox 
                                  //label="Set as Default Metric" 
                                  label={'Auto Sort Collection'}
                                  //{this.state.collectionsResourceItemEnabled }/{this.state.init.permissions.collections} Enabled
                                  checked={(this.state.collectionsResourceItemEnabled < this.state.init.permissions.collections && this.state.managedBeingEdited.doSort == "1"? true:false)}
                                  onChange={() => {this.editManagedObject(true,false,'doSort',(this.state.managedBeingEdited.doSort == "0" ? "1":"0"))}}
                                  disabled={(this.state.collectionsResourceItemEnabled >= this.state.init.permissions.collections && this.state.managedBeingEdited.doSort? true:false)}
                                  />
                                  <div className="inline-tooltip-container small" style={{marginTop:'4px'}}>
                                  <Tooltip content={this.state.init.current_plan + " Plan allows for "+this.state.init.permissions.collections+" enabled collections, "+this.state.collectionsResourceItemEnabled+"/"+this.state.init.permissions.collections+" enabled"}>
                                    <Icon source={QuestionMarkMajor} color="base" />
                                  </Tooltip>
                                  </div>                                
                                </Card.Section>
                                {
                                (this.state.managedBeingEdited.last_run.length > 0) ?
                                <Card.Section>
                                  <Label>
                                    <div className="card-section-icon">
                                      <Icon source={ClockMajor} color="base" />
                                    </div>
                                    Last Sorted: {this.state.managedBeingEdited.last_run}</Label>
                                </Card.Section>
                                :
                                ''
                                }
                                <Card.Section>
                                  <Select 
                                    label="Metrics Set"
                                    //options={[]}
                                    options={this.state.metricsResourceItems.map(function(item, i){
                                      return {label:item.name,value:item.id}
                                    })}
                                    value={(this.state.managedBeingEdited.metricsId > 0 ? this.state.managedBeingEdited.metricsId:0)}
                                    //value={''}
                                    onChange={(value) => this.editManagedObject(true,false,'metricsId',value)}
                                    disabled={(this.state.managedBeingEdited.doSort == "0")}
                                    />
                                    {
                                      (this.state.managedBeingEdited.doSort == "1") ? 
                                        this.state.metricsResourceItems.map((metricsItem) => (
                                          metricsItem.id == this.state.managedBeingEdited.metricsId
                                          ||
                                          metricsItem.is_default == "1" && this.state.managedBeingEdited.metricsId == 0
                                          ? (<ul className='metric-attribute-list'>{
                                              metricsItem.attributes.map((attribute) => (
                                                <li key={attribute.id}>
                                                  <small>{attribute.attribute_name} ({ attribute.value })</small>
                                                </li>
                                              ))
                                            }</ul>)
                                          : null
                                        ))   
                                      :
                                      null                                 
                                    }
                                    

                                </Card.Section>
                                <Card.Section>
                                  <Checkbox 
                                  //label="Set as Default Metric" 
                                  label={'Limit Product Count'}
                                  //{this.state.collectionsResourceItemEnabled }/{this.state.init.permissions.collections} Enabled
                                  //checked={(this.state.collectionsResourceItemEnabled < this.state.init.permissions.collections && this.state.managedBeingEdited.doSort == "1"? true:false)}
                                  checked={this.state.managedBeingEdited.doLimit == "1"}
                                  onChange={() => {this.editManagedObject(true,false,'doLimit',(this.state.managedBeingEdited.doLimit == "0" ? "1":"0"))}}
                                  disabled={(
                                    this.state.managedBeingEdited.doSort == "0"
                                    ? true:false)}
                                  />            
                                  <TextField
                                    label="Product Limit"
                                    value={this.state.managedBeingEdited.limit}
                                    onChange={(value) => {this.editManagedObject(true,false,'limit',value)}}
                                    autoComplete="off"
                                    //labelHidden
                                    type={'number'}
                                    step={1}
                                    disabled={(
                                      this.state.managedBeingEdited.doSort == "0"
                                      ||
                                      this.state.managedBeingEdited.doLimit == "0"
                                      ? true:false)}                                    
                                  />                        
                                </Card.Section>
                                {(parseInt(this.state.managedBeingEdited.id) > 0)?
                                <Card.Section>
                                  <div className='delete-metrics'>
                                    <Button
                                    plain 
                                    destructive
                                    onClick={()=> this.showDeleteManagedModal(this.state.managedBeingEdited.id)}
                                    >Delete Collection</Button>      
                                    <div className="inline-tooltip-container small">
                                      <Tooltip content={"Deleting this collection will remove it from your Shopify store and cannot be undone"}>
                                        <Icon source={QuestionMarkMajor} color="base" />
                                      </Tooltip>
                                    </div>  
                                  </div>                                  
                                </Card.Section>
                                :
                                ''
                                }
                              </Card>
                            </Grid.Cell>
                          </Grid>
                        </div>
                      </Page>
                    </div>
      
                  </Layout.Section>
                </div>

                <Modal
                  //activator={activator}
                  open={this.state.deleteManagedModalOpen}
                  onClose={() => {this.setState({deleteManagedModalOpen:false})}}
                  title={'Remove '+this.state.managedBeingEdited.title+'?'}
                  //large
                > 
                  <div className='modal-video-container'>
                    <Banner
                      title="This cannot be undone."
                      status="warning"
                    >
                      <p>Deleting this managed collection set will do so permanently in Dynasort and Shopify.</p>
                    </Banner>
                    <div className='delete-metrics-modal-content'>
                      <Button
                      destructive
                      onClick={() => {this.doDeleteManaged(this.state.managedBeingEdited.id)}}
                      >Delete Managed Collection</Button>
                      <Button
                      plain
                      monochrome
                      onClick={() => {this.setState({deleteManagedModalOpen:false})}}
                      >Cancel</Button>
                    </div>
                  </div>
                </Modal>
              </div>
            </Layout>
          </div>
          <div className={"loading-skeleton "+(!hasRunInit? '':'hide')}>
            <SkeletonPage>
              <Layout>
                <Layout.Section>
                  <Card sectioned>
                    <SkeletonBodyText />
                  </Card>
                  <Card sectioned>
                    <TextContainer>
                      <SkeletonDisplayText size="small" />
                      <SkeletonBodyText />
                    </TextContainer>
                  </Card>
                  <Card sectioned>
                    <TextContainer>
                      <SkeletonDisplayText size="small" />
                      <SkeletonBodyText />
                    </TextContainer>
                  </Card>
                </Layout.Section>
              </Layout>
            </SkeletonPage>
          </div>
        </Frame>
      </AppProvider>
        
    );
  }
}

export default App;
